var _image, _mask, _image2, _image3, _mask2, _image4, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267, _use268, _use269, _use270, _use271, _use272, _use273, _use274, _use275, _use276, _use277, _use278, _use279, _use280, _use281, _use282, _use283, _use284, _use285, _use286, _use287, _use288, _use289, _use290, _use291, _use292, _use293, _use294, _use295, _use296, _use297, _use298, _use299, _use300, _use301, _use302, _use303, _use304, _use305, _use306, _use307, _use308, _use309, _use310, _use311, _use312, _use313, _use314, _use315, _use316, _use317, _use318, _use319, _use320, _use321, _use322, _use323, _use324, _use325, _use326, _use327, _use328, _use329, _use330, _use331, _use332, _use333, _use334, _use335, _use336, _use337, _use338, _use339, _use340, _use341, _use342, _use343, _use344, _use345, _use346, _use347, _use348, _use349, _use350, _use351, _use352, _use353, _use354, _use355, _use356, _use357, _use358, _use359, _use360, _use361, _use362, _use363, _use364, _use365, _use366, _use367, _use368, _use369, _use370, _use371, _use372, _use373, _use374, _use375, _use376, _use377, _use378, _use379, _use380, _use381, _use382, _use383, _use384, _use385, _use386, _use387, _use388, _use389, _use390, _use391, _use392, _use393, _use394, _use395, _use396, _use397, _use398, _use399, _use400, _use401, _use402, _use403, _use404, _use405, _use406, _use407, _use408, _use409, _use410, _use411, _use412, _use413, _use414, _use415, _use416, _use417, _use418, _use419, _use420, _use421, _use422, _use423, _use424, _use425, _use426, _use427, _use428, _use429, _use430, _use431, _use432, _use433, _use434, _use435, _use436, _use437, _use438, _use439, _use440, _use441, _use442, _use443, _use444, _use445, _use446, _use447, _use448, _use449, _use450, _use451, _use452, _use453, _use454, _use455, _use456, _use457, _use458, _use459, _use460, _use461, _use462, _use463, _use464, _use465, _use466, _use467, _use468, _use469, _use470, _use471, _use472, _use473, _use474, _use475, _use476, _use477, _use478, _use479, _use480, _use481, _use482, _use483, _use484, _use485, _use486, _use487, _use488, _use489, _use490, _use491, _use492, _use493, _use494, _use495, _use496, _use497, _use498, _use499, _use500, _use501, _use502, _use503, _use504, _use505, _use506, _use507, _use508, _use509, _use510, _use511, _use512, _use513, _use514, _use515, _use516, _use517, _use518, _use519, _use520, _use521, _use522, _use523, _use524, _use525, _use526, _use527, _use528;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBac(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "595pt",
    height: "842pt",
    viewBox: "0 0 595 842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.265625 L -5.328125 -0.265625 L -5.328125 -2.390625 L 0 -2.390625 Z M -0.265625 -0.53125 L -0.265625 -2.125 L -5.0625 -2.125 L -5.0625 -0.53125 Z M -0.265625 -0.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.203125 L -5.28125 -2.265625 L -5.28125 -3.03125 L 0 -5.078125 L 0 -4.390625 L -1.46875 -3.828125 L -1.46875 -1.4375 L 0 -0.875 Z M -2.0625 -1.671875 L -2.0625 -3.609375 L -3.9375 -2.890625 L -4.671875 -2.640625 L -4.671875 -2.625 L -3.96875 -2.390625 Z M -2.0625 -1.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.453125 -0.25 L -4 -0.25 L -4 -1.046875 L -4.96875 -1.046875 L -5.140625 -1.6875 L -4 -1.6875 L -4 -3.171875 L -3.453125 -3.171875 L -3.453125 -1.6875 L -1.109375 -1.6875 C -0.910156 -1.6875 -0.757812 -1.738281 -0.65625 -1.84375 C -0.5625 -1.957031 -0.515625 -2.109375 -0.515625 -2.296875 C -0.515625 -2.546875 -0.613281 -2.769531 -0.8125 -2.96875 L -0.28125 -3.1875 C -0.0390625 -2.925781 0.078125 -2.582031 0.078125 -2.15625 C 0.078125 -1.832031 -0.0078125 -1.566406 -0.1875 -1.359375 C -0.363281 -1.160156 -0.632812 -1.054688 -1 -1.046875 L -3.453125 -1.046875 Z M -3.453125 -0.25 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2 -0.5 C -2.65625 -0.5 -3.164062 -0.660156 -3.53125 -0.984375 C -3.894531 -1.316406 -4.078125 -1.785156 -4.078125 -2.390625 C -4.078125 -2.753906 -3.992188 -3.070312 -3.828125 -3.34375 C -3.671875 -3.625 -3.445312 -3.832031 -3.15625 -3.96875 C -2.875 -4.101562 -2.554688 -4.171875 -2.203125 -4.171875 C -2.054688 -4.171875 -1.910156 -4.160156 -1.765625 -4.140625 L -1.765625 -1.125 C -1.359375 -1.164062 -1.039062 -1.300781 -0.8125 -1.53125 C -0.59375 -1.757812 -0.484375 -2.0625 -0.484375 -2.4375 C -0.484375 -2.726562 -0.53125 -2.96875 -0.625 -3.15625 C -0.726562 -3.351562 -0.878906 -3.488281 -1.078125 -3.5625 L -0.796875 -4.09375 C -0.515625 -3.9375 -0.296875 -3.722656 -0.140625 -3.453125 C 0.00390625 -3.191406 0.078125 -2.851562 0.078125 -2.4375 C 0.078125 -1.832031 -0.101562 -1.359375 -0.46875 -1.015625 C -0.84375 -0.671875 -1.351562 -0.5 -2 -0.5 Z M -2.328125 -1.140625 L -2.328125 -3.5625 C -2.703125 -3.519531 -2.992188 -3.394531 -3.203125 -3.1875 C -3.410156 -2.988281 -3.515625 -2.722656 -3.515625 -2.390625 C -3.515625 -2.035156 -3.410156 -1.75 -3.203125 -1.53125 C -2.992188 -1.3125 -2.703125 -1.179688 -2.328125 -1.140625 Z M -2.328125 -1.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -0.828125 -0.390625 L -1.1875 -0.90625 C -0.945312 -1 -0.769531 -1.15625 -0.65625 -1.375 C -0.539062 -1.601562 -0.484375 -1.867188 -0.484375 -2.171875 C -0.484375 -2.484375 -0.535156 -2.722656 -0.640625 -2.890625 C -0.753906 -3.054688 -0.898438 -3.140625 -1.078125 -3.140625 C -1.222656 -3.140625 -1.34375 -3.0625 -1.4375 -2.90625 C -1.539062 -2.75 -1.625 -2.476562 -1.6875 -2.09375 C -1.757812 -1.707031 -1.84375 -1.398438 -1.9375 -1.171875 C -2.039062 -0.953125 -2.164062 -0.789062 -2.3125 -0.6875 C -2.46875 -0.582031 -2.65625 -0.53125 -2.875 -0.53125 C -3.09375 -0.53125 -3.289062 -0.59375 -3.46875 -0.71875 C -3.65625 -0.851562 -3.800781 -1.039062 -3.90625 -1.28125 C -4.019531 -1.519531 -4.078125 -1.796875 -4.078125 -2.109375 C -4.078125 -2.535156 -4 -2.878906 -3.84375 -3.140625 C -3.6875 -3.398438 -3.445312 -3.585938 -3.125 -3.703125 L -2.796875 -3.15625 C -3.054688 -3.070312 -3.238281 -2.941406 -3.34375 -2.765625 C -3.457031 -2.585938 -3.515625 -2.367188 -3.515625 -2.109375 C -3.515625 -1.847656 -3.457031 -1.625 -3.34375 -1.4375 C -3.226562 -1.257812 -3.09375 -1.171875 -2.9375 -1.171875 C -2.757812 -1.171875 -2.625 -1.25 -2.53125 -1.40625 C -2.4375 -1.570312 -2.351562 -1.859375 -2.28125 -2.265625 C -2.1875 -2.816406 -2.050781 -3.207031 -1.875 -3.4375 C -1.695312 -3.664062 -1.441406 -3.78125 -1.109375 -3.78125 C -0.878906 -3.78125 -0.671875 -3.710938 -0.484375 -3.578125 C -0.304688 -3.441406 -0.164062 -3.242188 -0.0625 -2.984375 C 0.03125 -2.734375 0.078125 -2.441406 0.078125 -2.109375 C 0.078125 -1.722656 0.00390625 -1.375 -0.140625 -1.0625 C -0.296875 -0.757812 -0.523438 -0.535156 -0.828125 -0.390625 Z M -0.828125 -0.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1 -0.453125 C -1.300781 -0.453125 -1.5625 -0.585938 -1.78125 -0.859375 C -2 -1.128906 -2.148438 -1.515625 -2.234375 -2.015625 L -2.421875 -3.078125 L -2.640625 -3.078125 C -2.910156 -3.078125 -3.125 -2.992188 -3.28125 -2.828125 C -3.4375 -2.671875 -3.515625 -2.441406 -3.515625 -2.140625 C -3.515625 -1.878906 -3.453125 -1.648438 -3.328125 -1.453125 C -3.203125 -1.253906 -3.015625 -1.101562 -2.765625 -1 L -3.109375 -0.53125 C -3.410156 -0.632812 -3.644531 -0.832031 -3.8125 -1.125 C -3.988281 -1.414062 -4.078125 -1.753906 -4.078125 -2.140625 C -4.078125 -2.617188 -3.960938 -3 -3.734375 -3.28125 C -3.503906 -3.570312 -3.164062 -3.71875 -2.71875 -3.71875 L -0.75 -3.71875 C -0.65625 -3.71875 -0.582031 -3.738281 -0.53125 -3.78125 C -0.488281 -3.832031 -0.46875 -3.914062 -0.46875 -4.03125 C -0.46875 -4.132812 -0.476562 -4.238281 -0.5 -4.34375 L 0 -4.3125 C 0.0507812 -4.15625 0.078125 -3.992188 0.078125 -3.828125 C 0.078125 -3.617188 0.0351562 -3.453125 -0.046875 -3.328125 C -0.140625 -3.210938 -0.296875 -3.140625 -0.515625 -3.109375 C -0.328125 -2.984375 -0.179688 -2.800781 -0.078125 -2.5625 C 0.0234375 -2.320312 0.078125 -2.070312 0.078125 -1.8125 C 0.078125 -1.414062 -0.0078125 -1.085938 -0.1875 -0.828125 C -0.375 -0.578125 -0.644531 -0.453125 -1 -0.453125 Z M -1 -1.125 C -0.832031 -1.125 -0.703125 -1.1875 -0.609375 -1.3125 C -0.523438 -1.4375 -0.484375 -1.613281 -0.484375 -1.84375 C -0.484375 -2.1875 -0.5625 -2.476562 -0.71875 -2.71875 C -0.882812 -2.957031 -1.09375 -3.078125 -1.34375 -3.078125 L -1.890625 -3.078125 L -1.734375 -2.1875 C -1.660156 -1.832031 -1.566406 -1.566406 -1.453125 -1.390625 C -1.335938 -1.210938 -1.1875 -1.125 -1 -1.125 Z M -1 -1.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -5.25 -0.59375 C -5.394531 -0.59375 -5.507812 -0.632812 -5.59375 -0.71875 C -5.6875 -0.800781 -5.734375 -0.914062 -5.734375 -1.0625 C -5.734375 -1.207031 -5.6875 -1.320312 -5.59375 -1.40625 C -5.507812 -1.5 -5.394531 -1.546875 -5.25 -1.546875 C -5.101562 -1.546875 -4.984375 -1.5 -4.890625 -1.40625 C -4.804688 -1.320312 -4.765625 -1.207031 -4.765625 -1.0625 C -4.765625 -0.914062 -4.804688 -0.800781 -4.890625 -0.71875 C -4.984375 -0.632812 -5.101562 -0.59375 -5.25 -0.59375 Z M 0 -0.75 L -4 -0.75 L -4 -1.390625 L 0 -1.390625 Z M 0 -0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2 -0.5 C -2.65625 -0.5 -3.164062 -0.671875 -3.53125 -1.015625 C -3.894531 -1.359375 -4.078125 -1.832031 -4.078125 -2.4375 C -4.078125 -3.039062 -3.894531 -3.515625 -3.53125 -3.859375 C -3.164062 -4.203125 -2.65625 -4.375 -2 -4.375 C -1.351562 -4.375 -0.84375 -4.203125 -0.46875 -3.859375 C -0.101562 -3.515625 0.078125 -3.039062 0.078125 -2.4375 C 0.078125 -1.832031 -0.101562 -1.359375 -0.46875 -1.015625 C -0.84375 -0.671875 -1.351562 -0.5 -2 -0.5 Z M -2 -1.140625 C -1.53125 -1.140625 -1.15625 -1.253906 -0.875 -1.484375 C -0.601562 -1.710938 -0.46875 -2.03125 -0.46875 -2.4375 C -0.46875 -2.84375 -0.601562 -3.160156 -0.875 -3.390625 C -1.15625 -3.617188 -1.53125 -3.734375 -2 -3.734375 C -2.476562 -3.734375 -2.851562 -3.617188 -3.125 -3.390625 C -3.394531 -3.160156 -3.53125 -2.84375 -3.53125 -2.4375 C -3.53125 -2.03125 -3.394531 -1.710938 -3.125 -1.484375 C -2.851562 -1.253906 -2.476562 -1.140625 -2 -1.140625 Z M -2 -1.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.75 L -4 -0.75 L -4 -1.3125 L -3.375 -1.34375 C -3.613281 -1.476562 -3.789062 -1.660156 -3.90625 -1.890625 C -4.019531 -2.128906 -4.078125 -2.394531 -4.078125 -2.6875 C -4.078125 -3.144531 -3.945312 -3.519531 -3.6875 -3.8125 C -3.425781 -4.101562 -3.050781 -4.25 -2.5625 -4.25 L 0 -4.25 L 0 -3.609375 L -2.34375 -3.609375 C -2.757812 -3.609375 -3.054688 -3.519531 -3.234375 -3.34375 C -3.421875 -3.164062 -3.515625 -2.925781 -3.515625 -2.625 C -3.515625 -2.414062 -3.46875 -2.21875 -3.375 -2.03125 C -3.28125 -1.84375 -3.128906 -1.6875 -2.921875 -1.5625 C -2.710938 -1.445312 -2.445312 -1.390625 -2.125 -1.390625 L 0 -1.390625 Z M 0 -0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -0.375 C 0.484375 -0.375 0.316406 -0.4375 0.171875 -0.5625 C 0.0351562 -0.6875 -0.0546875 -0.859375 -0.109375 -1.078125 C -0.191406 -0.910156 -0.296875 -0.773438 -0.421875 -0.671875 C -0.546875 -0.578125 -0.6875 -0.53125 -0.84375 -0.53125 C -1.039062 -0.53125 -1.203125 -0.582031 -1.328125 -0.6875 C -1.460938 -0.789062 -1.566406 -0.9375 -1.640625 -1.125 C -1.753906 -0.9375 -1.90625 -0.789062 -2.09375 -0.6875 C -2.28125 -0.59375 -2.492188 -0.546875 -2.734375 -0.546875 C -2.992188 -0.546875 -3.222656 -0.613281 -3.421875 -0.75 C -3.628906 -0.894531 -3.789062 -1.09375 -3.90625 -1.34375 C -4.019531 -1.59375 -4.078125 -1.875 -4.078125 -2.1875 C -4.078125 -2.488281 -4.023438 -2.757812 -3.921875 -3 C -4.460938 -3.144531 -4.734375 -3.519531 -4.734375 -4.125 L -4.171875 -4.28125 C -4.171875 -3.75 -4.023438 -3.429688 -3.734375 -3.328125 C -3.609375 -3.484375 -3.460938 -3.601562 -3.296875 -3.6875 C -3.128906 -3.78125 -2.941406 -3.828125 -2.734375 -3.828125 C -2.472656 -3.828125 -2.238281 -3.753906 -2.03125 -3.609375 C -1.820312 -3.472656 -1.660156 -3.28125 -1.546875 -3.03125 C -1.429688 -2.78125 -1.375 -2.5 -1.375 -2.1875 C -1.375 -1.945312 -1.398438 -1.738281 -1.453125 -1.5625 C -1.410156 -1.40625 -1.347656 -1.289062 -1.265625 -1.21875 C -1.191406 -1.15625 -1.085938 -1.125 -0.953125 -1.125 C -0.804688 -1.125 -0.695312 -1.171875 -0.625 -1.265625 C -0.550781 -1.359375 -0.515625 -1.488281 -0.515625 -1.65625 L -0.515625 -2.984375 C -0.515625 -3.359375 -0.425781 -3.648438 -0.25 -3.859375 C -0.0820312 -4.078125 0.144531 -4.1875 0.4375 -4.1875 C 0.695312 -4.1875 0.921875 -4.097656 1.109375 -3.921875 C 1.304688 -3.742188 1.457031 -3.503906 1.5625 -3.203125 C 1.664062 -2.898438 1.71875 -2.566406 1.71875 -2.203125 C 1.71875 -1.597656 1.617188 -1.140625 1.421875 -0.828125 C 1.234375 -0.523438 0.984375 -0.375 0.671875 -0.375 Z M 0.53125 -0.96875 C 0.738281 -0.96875 0.898438 -1.078125 1.015625 -1.296875 C 1.128906 -1.523438 1.1875 -1.851562 1.1875 -2.28125 C 1.1875 -2.6875 1.117188 -3.003906 0.984375 -3.234375 C 0.859375 -3.472656 0.703125 -3.59375 0.515625 -3.59375 C 0.359375 -3.59375 0.238281 -3.53125 0.15625 -3.40625 C 0.0820312 -3.289062 0.046875 -3.085938 0.046875 -2.796875 L 0.046875 -1.734375 C 0.046875 -1.484375 0.0859375 -1.289062 0.171875 -1.15625 C 0.265625 -1.03125 0.382812 -0.96875 0.53125 -0.96875 Z M -2.734375 -1.203125 C -2.484375 -1.203125 -2.28125 -1.296875 -2.125 -1.484375 C -1.96875 -1.671875 -1.890625 -1.90625 -1.890625 -2.1875 C -1.890625 -2.457031 -1.96875 -2.6875 -2.125 -2.875 C -2.28125 -3.0625 -2.484375 -3.15625 -2.734375 -3.15625 C -2.972656 -3.15625 -3.171875 -3.0625 -3.328125 -2.875 C -3.484375 -2.695312 -3.5625 -2.46875 -3.5625 -2.1875 C -3.5625 -1.90625 -3.484375 -1.671875 -3.328125 -1.484375 C -3.171875 -1.296875 -2.972656 -1.203125 -2.734375 -1.203125 Z M -2.734375 -1.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2 -0.5 C -2.65625 -0.5 -3.164062 -0.660156 -3.53125 -0.984375 C -3.894531 -1.316406 -4.078125 -1.785156 -4.078125 -2.390625 C -4.078125 -2.753906 -3.992188 -3.070312 -3.828125 -3.34375 C -3.671875 -3.625 -3.445312 -3.832031 -3.15625 -3.96875 C -2.875 -4.101562 -2.554688 -4.171875 -2.203125 -4.171875 C -2.054688 -4.171875 -1.910156 -4.160156 -1.765625 -4.140625 L -1.765625 -1.125 C -1.359375 -1.164062 -1.039062 -1.300781 -0.8125 -1.53125 C -0.59375 -1.757812 -0.484375 -2.0625 -0.484375 -2.4375 C -0.484375 -2.726562 -0.53125 -2.96875 -0.625 -3.15625 C -0.726562 -3.351562 -0.878906 -3.488281 -1.078125 -3.5625 L -0.796875 -4.09375 C -0.515625 -3.9375 -0.296875 -3.722656 -0.140625 -3.453125 C 0.00390625 -3.191406 0.078125 -2.851562 0.078125 -2.4375 C 0.078125 -1.832031 -0.101562 -1.359375 -0.46875 -1.015625 C -0.84375 -0.671875 -1.351562 -0.5 -2 -0.5 Z M -2.328125 -1.140625 L -2.328125 -3.5625 C -2.703125 -3.519531 -2.992188 -3.394531 -3.203125 -3.1875 C -3.410156 -2.988281 -3.515625 -2.722656 -3.515625 -2.390625 C -3.515625 -2.035156 -3.410156 -1.75 -3.203125 -1.53125 C -2.992188 -1.3125 -2.703125 -1.179688 -2.328125 -1.140625 Z M -4.671875 -1.96875 L -6 -2.578125 L -6 -3.28125 L -4.671875 -2.484375 Z M -4.671875 -1.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.75 L -4 -0.75 L -4 -1.265625 L -3.34375 -1.359375 C -3.832031 -1.578125 -4.078125 -2.003906 -4.078125 -2.640625 C -4.078125 -2.828125 -4.050781 -2.972656 -4 -3.078125 L -3.375 -2.953125 C -3.445312 -2.816406 -3.484375 -2.644531 -3.484375 -2.4375 C -3.484375 -2.269531 -3.429688 -2.101562 -3.328125 -1.9375 C -3.234375 -1.78125 -3.085938 -1.648438 -2.890625 -1.546875 C -2.691406 -1.441406 -2.445312 -1.390625 -2.15625 -1.390625 L 0 -1.390625 Z M 0 -0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.6875 -0.75 L -4 -0.75 L -4 -1.3125 L -3.3125 -1.34375 C -3.539062 -1.457031 -3.722656 -1.632812 -3.859375 -1.875 C -4.003906 -2.125 -4.078125 -2.40625 -4.078125 -2.71875 C -4.078125 -3.269531 -3.890625 -3.707031 -3.515625 -4.03125 C -3.148438 -4.363281 -2.644531 -4.53125 -2 -4.53125 C -1.351562 -4.53125 -0.84375 -4.363281 -0.46875 -4.03125 C -0.101562 -3.707031 0.078125 -3.269531 0.078125 -2.71875 C 0.078125 -2.414062 0.015625 -2.148438 -0.109375 -1.921875 C -0.242188 -1.691406 -0.414062 -1.515625 -0.625 -1.390625 L 1.6875 -1.390625 Z M -1.953125 -1.390625 C -1.503906 -1.390625 -1.144531 -1.5 -0.875 -1.71875 C -0.613281 -1.945312 -0.484375 -2.253906 -0.484375 -2.640625 C -0.484375 -3.023438 -0.617188 -3.328125 -0.890625 -3.546875 C -1.171875 -3.773438 -1.539062 -3.890625 -2 -3.890625 C -2.46875 -3.890625 -2.835938 -3.773438 -3.109375 -3.546875 C -3.378906 -3.328125 -3.515625 -3.023438 -3.515625 -2.640625 C -3.515625 -2.253906 -3.378906 -1.945312 -3.109375 -1.71875 C -2.847656 -1.5 -2.492188 -1.390625 -2.046875 -1.390625 Z M -1.953125 -1.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2 -0.5 C -2.644531 -0.5 -3.148438 -0.660156 -3.515625 -0.984375 C -3.890625 -1.316406 -4.078125 -1.765625 -4.078125 -2.328125 C -4.078125 -2.617188 -4.015625 -2.878906 -3.890625 -3.109375 C -3.765625 -3.347656 -3.59375 -3.53125 -3.375 -3.65625 L -5.84375 -3.65625 L -5.84375 -4.296875 L 0 -4.296875 L 0 -3.734375 L -0.703125 -3.703125 C -0.460938 -3.578125 -0.269531 -3.394531 -0.125 -3.15625 C 0.0078125 -2.914062 0.078125 -2.640625 0.078125 -2.328125 C 0.078125 -1.765625 -0.101562 -1.316406 -0.46875 -0.984375 C -0.84375 -0.660156 -1.351562 -0.5 -2 -0.5 Z M -2 -1.140625 C -1.539062 -1.140625 -1.171875 -1.25 -0.890625 -1.46875 C -0.617188 -1.695312 -0.484375 -2.007812 -0.484375 -2.40625 C -0.484375 -2.789062 -0.613281 -3.09375 -0.875 -3.3125 C -1.144531 -3.539062 -1.503906 -3.65625 -1.953125 -3.65625 L -2.046875 -3.65625 C -2.492188 -3.65625 -2.847656 -3.539062 -3.109375 -3.3125 C -3.378906 -3.09375 -3.515625 -2.789062 -3.515625 -2.40625 C -3.515625 -2.007812 -3.378906 -1.695312 -3.109375 -1.46875 C -2.835938 -1.25 -2.46875 -1.140625 -2 -1.140625 Z M -2 -1.140625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1 -0.71875 L -5.84375 -0.71875 L -5.84375 -1.359375 L -1.078125 -1.359375 C -0.867188 -1.359375 -0.722656 -1.382812 -0.640625 -1.4375 C -0.566406 -1.5 -0.53125 -1.613281 -0.53125 -1.78125 C -0.53125 -1.894531 -0.539062 -1.992188 -0.5625 -2.078125 C -0.582031 -2.160156 -0.613281 -2.257812 -0.65625 -2.375 L -0.03125 -2.265625 C 0.0390625 -2.097656 0.078125 -1.910156 0.078125 -1.703125 C 0.078125 -1.691406 0.078125 -1.679688 0.078125 -1.671875 C 0.078125 -1.347656 -0.0078125 -1.109375 -0.1875 -0.953125 C -0.363281 -0.796875 -0.632812 -0.71875 -1 -0.71875 Z M -1 -0.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.75 L -4 -0.75 L -4 -1.3125 L -3.375 -1.34375 C -3.613281 -1.476562 -3.789062 -1.660156 -3.90625 -1.890625 C -4.019531 -2.117188 -4.078125 -2.363281 -4.078125 -2.625 C -4.078125 -2.914062 -4.007812 -3.1875 -3.875 -3.4375 C -3.75 -3.6875 -3.554688 -3.875 -3.296875 -4 C -3.554688 -4.113281 -3.75 -4.304688 -3.875 -4.578125 C -4.007812 -4.847656 -4.078125 -5.117188 -4.078125 -5.390625 C -4.078125 -5.660156 -4.019531 -5.910156 -3.90625 -6.140625 C -3.800781 -6.367188 -3.632812 -6.554688 -3.40625 -6.703125 C -3.175781 -6.847656 -2.894531 -6.921875 -2.5625 -6.921875 L 0 -6.921875 L 0 -6.28125 L -2.5 -6.28125 C -2.84375 -6.28125 -3.097656 -6.191406 -3.265625 -6.015625 C -3.429688 -5.847656 -3.515625 -5.625 -3.515625 -5.34375 C -3.515625 -5.125 -3.460938 -4.925781 -3.359375 -4.75 C -3.253906 -4.570312 -3.101562 -4.425781 -2.90625 -4.3125 C -2.707031 -4.207031 -2.46875 -4.15625 -2.1875 -4.15625 L 0 -4.15625 L 0 -3.515625 L -2.5 -3.515625 C -2.84375 -3.515625 -3.097656 -3.425781 -3.265625 -3.25 C -3.429688 -3.082031 -3.515625 -2.851562 -3.515625 -2.5625 C -3.515625 -2.375 -3.460938 -2.1875 -3.359375 -2 C -3.265625 -1.820312 -3.113281 -1.675781 -2.90625 -1.5625 C -2.707031 -1.445312 -2.453125 -1.390625 -2.140625 -1.390625 L 0 -1.390625 Z M 0 -0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -0.4375 -0.546875 C -0.59375 -0.546875 -0.71875 -0.59375 -0.8125 -0.6875 C -0.914062 -0.78125 -0.96875 -0.90625 -0.96875 -1.0625 C -0.96875 -1.21875 -0.914062 -1.34375 -0.8125 -1.4375 C -0.71875 -1.539062 -0.59375 -1.59375 -0.4375 -1.59375 C -0.289062 -1.59375 -0.164062 -1.539062 -0.0625 -1.4375 C 0.03125 -1.34375 0.078125 -1.21875 0.078125 -1.0625 C 0.078125 -0.90625 0.03125 -0.78125 -0.0625 -0.6875 C -0.15625 -0.59375 -0.28125 -0.546875 -0.4375 -0.546875 Z M -0.4375 -0.546875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.390625 -0.703125 L -4 -0.703125 L -4 -1.34375 L -1.546875 -1.34375 C -1.160156 -1.34375 -0.882812 -1.421875 -0.71875 -1.578125 C -0.5625 -1.742188 -0.484375 -1.984375 -0.484375 -2.296875 C -0.484375 -2.660156 -0.59375 -2.960938 -0.8125 -3.203125 C -1.039062 -3.441406 -1.378906 -3.5625 -1.828125 -3.5625 L -4 -3.5625 L -4 -4.203125 L 0 -4.203125 L 0 -3.65625 L -0.609375 -3.609375 C -0.148438 -3.347656 0.078125 -2.867188 0.078125 -2.171875 C 0.078125 -1.742188 -0.0390625 -1.390625 -0.28125 -1.109375 C -0.519531 -0.835938 -0.890625 -0.703125 -1.390625 -0.703125 Z M -1.390625 -0.703125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -4 -0.09375 L -4 -0.828125 L -0.65625 -2.09375 L -4 -3.390625 L -4 -4.0625 L 0 -2.40625 L 0 -1.765625 Z M -4 -0.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.453125 -0.265625 L -4 -0.265625 L -4 -1.0625 L -4.671875 -1.0625 C -5.035156 -1.0625 -5.328125 -1.171875 -5.546875 -1.390625 C -5.765625 -1.617188 -5.875 -1.945312 -5.875 -2.375 C -5.875 -2.507812 -5.859375 -2.640625 -5.828125 -2.765625 C -5.796875 -2.890625 -5.753906 -2.984375 -5.703125 -3.046875 L -5.171875 -2.875 C -5.253906 -2.75 -5.296875 -2.597656 -5.296875 -2.421875 C -5.296875 -1.941406 -5.066406 -1.703125 -4.609375 -1.703125 L -4 -1.703125 L -4 -3.03125 L -3.453125 -3.03125 L -3.453125 -1.703125 L 0 -1.703125 L 0 -1.0625 L -3.453125 -1.0625 Z M -3.453125 -0.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -2.640625 -0.515625 C -3.523438 -0.515625 -4.195312 -0.679688 -4.65625 -1.015625 C -5.125 -1.359375 -5.359375 -1.847656 -5.359375 -2.484375 C -5.359375 -3.128906 -5.125 -3.617188 -4.65625 -3.953125 C -4.195312 -4.285156 -3.523438 -4.453125 -2.640625 -4.453125 C -1.753906 -4.453125 -1.078125 -4.285156 -0.609375 -3.953125 C -0.148438 -3.617188 0.078125 -3.128906 0.078125 -2.484375 C 0.078125 -1.847656 -0.148438 -1.359375 -0.609375 -1.015625 C -1.078125 -0.679688 -1.753906 -0.515625 -2.640625 -0.515625 Z M -2.640625 -1.1875 C -1.941406 -1.1875 -1.410156 -1.296875 -1.046875 -1.515625 C -0.679688 -1.742188 -0.5 -2.066406 -0.5 -2.484375 C -0.5 -2.910156 -0.679688 -3.234375 -1.046875 -3.453125 C -1.410156 -3.679688 -1.941406 -3.796875 -2.640625 -3.796875 C -3.335938 -3.796875 -3.867188 -3.679688 -4.234375 -3.453125 C -4.597656 -3.234375 -4.78125 -2.910156 -4.78125 -2.484375 C -4.78125 -2.066406 -4.597656 -1.742188 -4.234375 -1.515625 C -3.867188 -1.296875 -3.335938 -1.1875 -2.640625 -1.1875 Z M -2.640625 -1.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -3.796875 -0.421875 C -4.265625 -0.492188 -4.640625 -0.6875 -4.921875 -1 C -5.210938 -1.320312 -5.359375 -1.742188 -5.359375 -2.265625 C -5.359375 -2.617188 -5.289062 -2.929688 -5.15625 -3.203125 C -5.019531 -3.472656 -4.820312 -3.675781 -4.5625 -3.8125 C -4.3125 -3.957031 -4.023438 -4.03125 -3.703125 -4.03125 C -3.359375 -4.03125 -3.03125 -3.945312 -2.71875 -3.78125 C -2.40625 -3.625 -2.070312 -3.359375 -1.71875 -2.984375 C -1.375 -2.617188 -1 -2.125 -0.59375 -1.5 L -0.578125 -1.5 C -0.585938 -1.851562 -0.597656 -2.117188 -0.609375 -2.296875 L -0.609375 -4.140625 L 0 -4.140625 L 0 -0.59375 L -0.515625 -0.59375 C -1.054688 -1.320312 -1.5 -1.878906 -1.84375 -2.265625 C -2.195312 -2.660156 -2.515625 -2.941406 -2.796875 -3.109375 C -3.085938 -3.273438 -3.390625 -3.359375 -3.703125 -3.359375 C -4.015625 -3.359375 -4.269531 -3.253906 -4.46875 -3.046875 C -4.664062 -2.847656 -4.765625 -2.578125 -4.765625 -2.234375 C -4.765625 -1.878906 -4.644531 -1.59375 -4.40625 -1.375 C -4.175781 -1.15625 -3.859375 -1.023438 -3.453125 -0.984375 Z M -3.796875 -0.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.5625 -0.21875 L -5.84375 -2.671875 L -5.84375 -3.28125 L 0.5625 -0.828125 Z M 0.5625 -0.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-24"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.1875 -0.421875 L -1.5 -1.015625 C -1.175781 -1.117188 -0.929688 -1.265625 -0.765625 -1.453125 C -0.597656 -1.640625 -0.515625 -1.921875 -0.515625 -2.296875 C -0.515625 -2.648438 -0.601562 -2.925781 -0.78125 -3.125 C -0.96875 -3.332031 -1.203125 -3.4375 -1.484375 -3.4375 C -1.804688 -3.4375 -2.03125 -3.335938 -2.15625 -3.140625 C -2.289062 -2.941406 -2.359375 -2.632812 -2.359375 -2.21875 L -2.359375 -2.015625 L -2.96875 -2.015625 L -2.96875 -2.21875 C -2.96875 -2.945312 -3.265625 -3.3125 -3.859375 -3.3125 C -4.160156 -3.3125 -4.382812 -3.226562 -4.53125 -3.0625 C -4.6875 -2.894531 -4.765625 -2.65625 -4.765625 -2.34375 C -4.765625 -2.03125 -4.691406 -1.78125 -4.546875 -1.59375 C -4.410156 -1.414062 -4.210938 -1.289062 -3.953125 -1.21875 L -4.234375 -0.625 C -4.578125 -0.75 -4.847656 -0.960938 -5.046875 -1.265625 C -5.253906 -1.578125 -5.359375 -1.929688 -5.359375 -2.328125 C -5.359375 -2.671875 -5.296875 -2.96875 -5.171875 -3.21875 C -5.046875 -3.46875 -4.878906 -3.65625 -4.671875 -3.78125 C -4.460938 -3.914062 -4.234375 -3.984375 -3.984375 -3.984375 C -3.742188 -3.984375 -3.523438 -3.9375 -3.328125 -3.84375 C -3.128906 -3.75 -2.972656 -3.625 -2.859375 -3.46875 C -2.742188 -3.320312 -2.6875 -3.160156 -2.6875 -2.984375 L -2.671875 -2.984375 C -2.671875 -3.316406 -2.546875 -3.582031 -2.296875 -3.78125 C -2.054688 -3.988281 -1.765625 -4.09375 -1.421875 -4.09375 C -1.128906 -4.09375 -0.867188 -4.015625 -0.640625 -3.859375 C -0.421875 -3.710938 -0.242188 -3.5 -0.109375 -3.21875 C 0.015625 -2.9375 0.078125 -2.609375 0.078125 -2.234375 C 0.078125 -1.359375 -0.34375 -0.753906 -1.1875 -0.421875 Z M -1.1875 -0.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-25"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1 -0.453125 C -1.300781 -0.453125 -1.5625 -0.585938 -1.78125 -0.859375 C -2 -1.128906 -2.148438 -1.515625 -2.234375 -2.015625 L -2.421875 -3.078125 L -2.640625 -3.078125 C -2.910156 -3.078125 -3.125 -2.992188 -3.28125 -2.828125 C -3.4375 -2.671875 -3.515625 -2.441406 -3.515625 -2.140625 C -3.515625 -1.878906 -3.453125 -1.648438 -3.328125 -1.453125 C -3.203125 -1.253906 -3.015625 -1.101562 -2.765625 -1 L -3.109375 -0.53125 C -3.410156 -0.632812 -3.644531 -0.832031 -3.8125 -1.125 C -3.988281 -1.414062 -4.078125 -1.753906 -4.078125 -2.140625 C -4.078125 -2.617188 -3.960938 -3 -3.734375 -3.28125 C -3.503906 -3.570312 -3.164062 -3.71875 -2.71875 -3.71875 L -0.75 -3.71875 C -0.65625 -3.71875 -0.582031 -3.738281 -0.53125 -3.78125 C -0.488281 -3.832031 -0.46875 -3.914062 -0.46875 -4.03125 C -0.46875 -4.132812 -0.476562 -4.238281 -0.5 -4.34375 L 0 -4.3125 C 0.0507812 -4.15625 0.078125 -3.992188 0.078125 -3.828125 C 0.078125 -3.617188 0.0351562 -3.453125 -0.046875 -3.328125 C -0.140625 -3.210938 -0.296875 -3.140625 -0.515625 -3.109375 C -0.328125 -2.984375 -0.179688 -2.800781 -0.078125 -2.5625 C 0.0234375 -2.320312 0.078125 -2.070312 0.078125 -1.8125 C 0.078125 -1.414062 -0.0078125 -1.085938 -0.1875 -0.828125 C -0.375 -0.578125 -0.644531 -0.453125 -1 -0.453125 Z M -1 -1.125 C -0.832031 -1.125 -0.703125 -1.1875 -0.609375 -1.3125 C -0.523438 -1.4375 -0.484375 -1.613281 -0.484375 -1.84375 C -0.484375 -2.1875 -0.5625 -2.476562 -0.71875 -2.71875 C -0.882812 -2.957031 -1.09375 -3.078125 -1.34375 -3.078125 L -1.890625 -3.078125 L -1.734375 -2.1875 C -1.660156 -1.832031 -1.566406 -1.566406 -1.453125 -1.390625 C -1.335938 -1.210938 -1.1875 -1.125 -1 -1.125 Z M -6 -1.234375 L -6 -1.9375 L -4.671875 -2.546875 L -4.671875 -2.03125 Z M -6 -1.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-26"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -4.328125 -0.296875 C -4.347656 -0.421875 -4.410156 -0.59375 -4.515625 -0.8125 C -4.617188 -1.03125 -4.738281 -1.238281 -4.875 -1.4375 C -5.019531 -1.644531 -5.15625 -1.796875 -5.28125 -1.890625 L -5.28125 -2.453125 L 0 -2.453125 L 0 -1.8125 L -3.875 -1.8125 C -3.988281 -1.8125 -4.191406 -1.816406 -4.484375 -1.828125 C -4.304688 -1.648438 -4.148438 -1.441406 -4.015625 -1.203125 C -3.890625 -0.960938 -3.800781 -0.71875 -3.75 -0.46875 Z M -4.328125 -0.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-27"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0 -0.75 L -5.84375 -0.75 L -5.84375 -1.390625 L -3.40625 -1.390625 C -3.632812 -1.515625 -3.800781 -1.691406 -3.90625 -1.921875 C -4.019531 -2.148438 -4.078125 -2.40625 -4.078125 -2.6875 C -4.078125 -3.144531 -3.945312 -3.519531 -3.6875 -3.8125 C -3.425781 -4.101562 -3.050781 -4.25 -2.5625 -4.25 L 0 -4.25 L 0 -3.609375 L -2.34375 -3.609375 C -2.757812 -3.609375 -3.054688 -3.519531 -3.234375 -3.34375 C -3.421875 -3.164062 -3.515625 -2.925781 -3.515625 -2.625 C -3.515625 -2.414062 -3.46875 -2.21875 -3.375 -2.03125 C -3.28125 -1.84375 -3.128906 -1.6875 -2.921875 -1.5625 C -2.710938 -1.445312 -2.445312 -1.390625 -2.125 -1.390625 L 0 -1.390625 Z M 0 -0.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-28"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -4.6875 -0.328125 L -5.28125 -0.328125 L -5.28125 -4.203125 L -4.6875 -4.203125 C -4 -3.546875 -3.269531 -3.066406 -2.5 -2.765625 C -1.738281 -2.472656 -0.90625 -2.328125 0 -2.328125 L 0 -1.671875 C -0.863281 -1.671875 -1.691406 -1.828125 -2.484375 -2.140625 C -3.285156 -2.453125 -4.019531 -2.910156 -4.6875 -3.515625 Z M -4.6875 -0.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.328125 0 L 0.328125 -6.671875 L 2.984375 -6.671875 L 2.984375 0 Z M 0.671875 -0.328125 L 2.65625 -0.328125 L 2.65625 -6.328125 L 0.671875 -6.328125 Z M 0.671875 -0.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.28125 -6.609375 L 1.140625 -6.609375 L 2.828125 -2.046875 L 3.25 -0.734375 L 3.65625 -2.03125 L 5.34375 -6.609375 L 6.203125 -6.609375 L 3.703125 0 L 2.78125 0 Z M 0.28125 -6.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.835938 -3.945312 1.265625 -4.40625 C 1.691406 -4.863281 2.285156 -5.09375 3.046875 -5.09375 C 3.796875 -5.09375 4.382812 -4.863281 4.8125 -4.40625 C 5.238281 -3.945312 5.453125 -3.3125 5.453125 -2.5 C 5.453125 -1.6875 5.238281 -1.050781 4.8125 -0.59375 C 4.382812 -0.132812 3.796875 0.09375 3.046875 0.09375 C 2.296875 0.09375 1.703125 -0.132812 1.265625 -0.59375 C 0.835938 -1.050781 0.625 -1.6875 0.625 -2.5 Z M 1.421875 -2.5 C 1.421875 -1.90625 1.5625 -1.4375 1.84375 -1.09375 C 2.132812 -0.757812 2.535156 -0.59375 3.046875 -0.59375 C 3.546875 -0.59375 3.9375 -0.757812 4.21875 -1.09375 C 4.507812 -1.4375 4.65625 -1.90625 4.65625 -2.5 C 4.65625 -3.09375 4.507812 -3.554688 4.21875 -3.890625 C 3.9375 -4.234375 3.546875 -4.40625 3.046875 -4.40625 C 2.535156 -4.40625 2.132812 -4.234375 1.84375 -3.890625 C 1.5625 -3.554688 1.421875 -3.09375 1.421875 -2.5 Z M 1.421875 -2.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -1.734375 L 0.875 -5 L 1.6875 -5 L 1.6875 -1.9375 C 1.6875 -1.445312 1.785156 -1.097656 1.984375 -0.890625 C 2.179688 -0.691406 2.472656 -0.59375 2.859375 -0.59375 C 3.316406 -0.59375 3.695312 -0.734375 4 -1.015625 C 4.300781 -1.296875 4.453125 -1.71875 4.453125 -2.28125 L 4.453125 -5 L 5.265625 -5 L 5.265625 0 L 4.5625 0 L 4.515625 -0.765625 C 4.179688 -0.191406 3.582031 0.09375 2.71875 0.09375 C 2.175781 0.09375 1.734375 -0.0507812 1.390625 -0.34375 C 1.046875 -0.644531 0.875 -1.109375 0.875 -1.734375 Z M 0.875 -1.734375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.484375 -1.03125 L 1.125 -1.484375 C 1.238281 -1.191406 1.4375 -0.96875 1.71875 -0.8125 C 2 -0.664062 2.328125 -0.59375 2.703125 -0.59375 C 3.097656 -0.59375 3.398438 -0.660156 3.609375 -0.796875 C 3.816406 -0.941406 3.921875 -1.125 3.921875 -1.34375 C 3.921875 -1.53125 3.820312 -1.679688 3.625 -1.796875 C 3.4375 -1.921875 3.097656 -2.023438 2.609375 -2.109375 C 2.128906 -2.191406 1.75 -2.296875 1.46875 -2.421875 C 1.1875 -2.546875 0.984375 -2.703125 0.859375 -2.890625 C 0.734375 -3.078125 0.671875 -3.3125 0.671875 -3.59375 C 0.671875 -3.875 0.75 -4.125 0.90625 -4.34375 C 1.070312 -4.570312 1.300781 -4.753906 1.59375 -4.890625 C 1.894531 -5.023438 2.242188 -5.09375 2.640625 -5.09375 C 3.171875 -5.09375 3.597656 -4.992188 3.921875 -4.796875 C 4.242188 -4.609375 4.476562 -4.3125 4.625 -3.90625 L 3.9375 -3.5 C 3.832031 -3.820312 3.671875 -4.050781 3.453125 -4.1875 C 3.234375 -4.332031 2.960938 -4.40625 2.640625 -4.40625 C 2.316406 -4.40625 2.039062 -4.328125 1.8125 -4.171875 C 1.582031 -4.023438 1.46875 -3.859375 1.46875 -3.671875 C 1.46875 -3.453125 1.566406 -3.28125 1.765625 -3.15625 C 1.960938 -3.039062 2.316406 -2.941406 2.828125 -2.859375 C 3.515625 -2.742188 4 -2.570312 4.28125 -2.34375 C 4.570312 -2.113281 4.71875 -1.789062 4.71875 -1.375 C 4.71875 -1.09375 4.628906 -0.835938 4.453125 -0.609375 C 4.285156 -0.390625 4.046875 -0.21875 3.734375 -0.09375 C 3.421875 0.03125 3.050781 0.09375 2.625 0.09375 C 2.144531 0.09375 1.710938 0 1.328125 -0.1875 C 0.941406 -0.375 0.660156 -0.65625 0.484375 -1.03125 Z M 0.484375 -1.03125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.921875 2.09375 L 0.921875 -5 L 1.625 -5 L 1.6875 -4.125 C 1.832031 -4.425781 2.054688 -4.660156 2.359375 -4.828125 C 2.660156 -5.003906 3.003906 -5.09375 3.390625 -5.09375 C 4.085938 -5.09375 4.640625 -4.863281 5.046875 -4.40625 C 5.460938 -3.945312 5.671875 -3.3125 5.671875 -2.5 C 5.671875 -1.695312 5.460938 -1.0625 5.046875 -0.59375 C 4.640625 -0.132812 4.085938 0.09375 3.390625 0.09375 C 3.023438 0.09375 2.695312 0.015625 2.40625 -0.140625 C 2.113281 -0.296875 1.890625 -0.507812 1.734375 -0.78125 L 1.734375 2.09375 Z M 1.734375 -2.4375 C 1.734375 -1.882812 1.875 -1.4375 2.15625 -1.09375 C 2.4375 -0.757812 2.816406 -0.59375 3.296875 -0.59375 C 3.785156 -0.59375 4.171875 -0.765625 4.453125 -1.109375 C 4.734375 -1.453125 4.875 -1.914062 4.875 -2.5 C 4.875 -3.082031 4.734375 -3.546875 4.453125 -3.890625 C 4.171875 -4.234375 3.785156 -4.40625 3.296875 -4.40625 C 2.816406 -4.40625 2.4375 -4.238281 2.15625 -3.90625 C 1.875 -3.570312 1.734375 -3.125 1.734375 -2.5625 Z M 1.734375 -2.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.125 -5 L 1.03125 -5 L 2.609375 -0.8125 L 4.234375 -5 L 5.078125 -5 L 3 0 L 2.203125 0 Z M 0.125 -5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.828125 -3.945312 1.234375 -4.40625 C 1.640625 -4.863281 2.222656 -5.09375 2.984375 -5.09375 C 3.441406 -5.09375 3.84375 -4.988281 4.1875 -4.78125 C 4.53125 -4.582031 4.785156 -4.304688 4.953125 -3.953125 C 5.128906 -3.597656 5.21875 -3.203125 5.21875 -2.765625 C 5.21875 -2.578125 5.207031 -2.390625 5.1875 -2.203125 L 1.40625 -2.203125 C 1.457031 -1.691406 1.625 -1.296875 1.90625 -1.015625 C 2.195312 -0.734375 2.578125 -0.59375 3.046875 -0.59375 C 3.410156 -0.59375 3.710938 -0.65625 3.953125 -0.78125 C 4.203125 -0.914062 4.367188 -1.101562 4.453125 -1.34375 L 5.125 -0.984375 C 4.925781 -0.628906 4.65625 -0.359375 4.3125 -0.171875 C 3.976562 0.00390625 3.554688 0.09375 3.046875 0.09375 C 2.296875 0.09375 1.703125 -0.132812 1.265625 -0.59375 C 0.835938 -1.050781 0.625 -1.6875 0.625 -2.5 Z M 1.421875 -2.90625 L 4.453125 -2.90625 C 4.398438 -3.375 4.242188 -3.738281 3.984375 -4 C 3.734375 -4.269531 3.398438 -4.40625 2.984375 -4.40625 C 2.535156 -4.40625 2.175781 -4.273438 1.90625 -4.015625 C 1.644531 -3.753906 1.484375 -3.382812 1.421875 -2.90625 Z M 1.421875 -2.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.578125 0 L 0.578125 -0.609375 L 3.1875 -3.6875 L 3.8125 -4.328125 L 2.9375 -4.3125 L 0.59375 -4.3125 L 0.59375 -5 L 4.71875 -5 L 4.71875 -4.390625 L 2.09375 -1.3125 L 1.46875 -0.671875 L 2.4375 -0.6875 L 4.796875 -0.6875 L 4.796875 0 Z M 0.578125 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.835938 -3.945312 1.265625 -4.40625 C 1.691406 -4.863281 2.285156 -5.09375 3.046875 -5.09375 C 3.546875 -5.09375 3.960938 -4.976562 4.296875 -4.75 C 4.640625 -4.519531 4.910156 -4.191406 5.109375 -3.765625 L 4.34375 -3.40625 C 4.132812 -4.070312 3.691406 -4.40625 3.015625 -4.40625 C 2.515625 -4.40625 2.125 -4.234375 1.84375 -3.890625 C 1.5625 -3.554688 1.421875 -3.09375 1.421875 -2.5 C 1.421875 -1.90625 1.5625 -1.4375 1.84375 -1.09375 C 2.125 -0.757812 2.515625 -0.59375 3.015625 -0.59375 C 3.398438 -0.59375 3.710938 -0.679688 3.953125 -0.859375 C 4.191406 -1.035156 4.347656 -1.289062 4.421875 -1.625 L 5.15625 -1.375 C 4.988281 -0.90625 4.722656 -0.539062 4.359375 -0.28125 C 3.992188 -0.03125 3.554688 0.09375 3.046875 0.09375 C 2.296875 0.09375 1.703125 -0.132812 1.265625 -0.59375 C 0.835938 -1.050781 0.625 -1.6875 0.625 -2.5 Z M 0.625 -2.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.921875 0 L 0.921875 -5 L 1.625 -5 L 1.6875 -4.21875 C 1.84375 -4.519531 2.066406 -4.738281 2.359375 -4.875 C 2.660156 -5.019531 2.992188 -5.09375 3.359375 -5.09375 C 3.921875 -5.09375 4.382812 -4.929688 4.75 -4.609375 C 5.125 -4.285156 5.3125 -3.816406 5.3125 -3.203125 L 5.3125 0 L 4.515625 0 L 4.515625 -2.921875 C 4.515625 -3.441406 4.398438 -3.816406 4.171875 -4.046875 C 3.953125 -4.285156 3.65625 -4.40625 3.28125 -4.40625 C 3.007812 -4.40625 2.753906 -4.34375 2.515625 -4.21875 C 2.285156 -4.101562 2.097656 -3.914062 1.953125 -3.65625 C 1.804688 -3.394531 1.734375 -3.0625 1.734375 -2.65625 L 1.734375 0 Z M 0.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.3125 -4.3125 L 0.3125 -5 L 1.3125 -5 L 1.3125 -6.203125 L 2.109375 -6.421875 L 2.109375 -5 L 3.953125 -5 L 3.953125 -4.3125 L 2.109375 -4.3125 L 2.109375 -1.375 C 2.109375 -1.132812 2.175781 -0.953125 2.3125 -0.828125 C 2.445312 -0.710938 2.628906 -0.65625 2.859375 -0.65625 C 3.179688 -0.65625 3.46875 -0.773438 3.71875 -1.015625 L 3.984375 -0.359375 C 3.648438 -0.0546875 3.222656 0.09375 2.703125 0.09375 C 2.296875 0.09375 1.960938 -0.015625 1.703125 -0.234375 C 1.441406 -0.453125 1.3125 -0.785156 1.3125 -1.234375 L 1.3125 -4.3125 Z M 0.3125 -4.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.921875 0 L 0.921875 -5 L 1.578125 -5 L 1.6875 -4.1875 C 1.96875 -4.789062 2.503906 -5.09375 3.296875 -5.09375 C 3.523438 -5.09375 3.707031 -5.0625 3.84375 -5 L 3.6875 -4.21875 C 3.519531 -4.300781 3.304688 -4.34375 3.046875 -4.34375 C 2.835938 -4.34375 2.628906 -4.28125 2.421875 -4.15625 C 2.222656 -4.039062 2.054688 -3.859375 1.921875 -3.609375 C 1.796875 -3.359375 1.734375 -3.054688 1.734375 -2.703125 L 1.734375 0 Z M 0.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.835938 -3.945312 1.265625 -4.40625 C 1.691406 -4.863281 2.285156 -5.09375 3.046875 -5.09375 C 3.796875 -5.09375 4.382812 -4.863281 4.8125 -4.40625 C 5.238281 -3.945312 5.453125 -3.3125 5.453125 -2.5 C 5.453125 -1.6875 5.238281 -1.050781 4.8125 -0.59375 C 4.382812 -0.132812 3.796875 0.09375 3.046875 0.09375 C 2.296875 0.09375 1.703125 -0.132812 1.265625 -0.59375 C 0.835938 -1.050781 0.625 -1.6875 0.625 -2.5 Z M 1.421875 -2.5 C 1.421875 -1.90625 1.5625 -1.4375 1.84375 -1.09375 C 2.132812 -0.757812 2.535156 -0.59375 3.046875 -0.59375 C 3.546875 -0.59375 3.9375 -0.757812 4.21875 -1.09375 C 4.507812 -1.4375 4.65625 -1.90625 4.65625 -2.5 C 4.65625 -3.09375 4.507812 -3.554688 4.21875 -3.890625 C 3.9375 -4.234375 3.546875 -4.40625 3.046875 -4.40625 C 2.535156 -4.40625 2.132812 -4.234375 1.84375 -3.890625 C 1.5625 -3.554688 1.421875 -3.09375 1.421875 -2.5 Z M 1.453125 -5.765625 L 2.578125 -7.4375 L 3.5 -7.4375 L 4.625 -5.765625 L 3.890625 -5.765625 L 3.046875 -6.875 L 2.1875 -5.765625 Z M 1.453125 -5.765625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.890625 -1.234375 L 0.890625 -7.296875 L 1.6875 -7.296875 L 1.6875 -1.34375 C 1.6875 -1.082031 1.722656 -0.90625 1.796875 -0.8125 C 1.878906 -0.71875 2.023438 -0.671875 2.234375 -0.671875 C 2.367188 -0.671875 2.488281 -0.679688 2.59375 -0.703125 C 2.695312 -0.722656 2.816406 -0.757812 2.953125 -0.8125 L 2.828125 -0.046875 C 2.617188 0.046875 2.382812 0.09375 2.125 0.09375 C 2.113281 0.09375 2.101562 0.09375 2.09375 0.09375 C 1.6875 0.09375 1.382812 -0.015625 1.1875 -0.234375 C 0.988281 -0.453125 0.890625 -0.785156 0.890625 -1.234375 Z M 0.890625 -1.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.578125 -1.234375 C 0.578125 -1.617188 0.742188 -1.945312 1.078125 -2.21875 C 1.410156 -2.5 1.890625 -2.691406 2.515625 -2.796875 L 3.84375 -3.015625 L 3.84375 -3.296875 C 3.84375 -3.628906 3.738281 -3.894531 3.53125 -4.09375 C 3.332031 -4.300781 3.050781 -4.40625 2.6875 -4.40625 C 2.351562 -4.40625 2.0625 -4.320312 1.8125 -4.15625 C 1.570312 -4 1.382812 -3.765625 1.25 -3.453125 L 0.65625 -3.875 C 0.789062 -4.25 1.039062 -4.546875 1.40625 -4.765625 C 1.769531 -4.984375 2.195312 -5.09375 2.6875 -5.09375 C 3.269531 -5.09375 3.742188 -4.945312 4.109375 -4.65625 C 4.472656 -4.375 4.65625 -3.957031 4.65625 -3.40625 L 4.65625 -0.9375 C 4.65625 -0.820312 4.679688 -0.734375 4.734375 -0.671875 C 4.796875 -0.609375 4.894531 -0.578125 5.03125 -0.578125 C 5.164062 -0.578125 5.300781 -0.59375 5.4375 -0.625 L 5.375 0 C 5.195312 0.0625 5 0.09375 4.78125 0.09375 C 4.519531 0.09375 4.3125 0.0390625 4.15625 -0.0625 C 4.007812 -0.175781 3.914062 -0.367188 3.875 -0.640625 C 3.726562 -0.398438 3.503906 -0.21875 3.203125 -0.09375 C 2.910156 0.03125 2.597656 0.09375 2.265625 0.09375 C 1.773438 0.09375 1.367188 -0.0195312 1.046875 -0.25 C 0.734375 -0.476562 0.578125 -0.804688 0.578125 -1.234375 Z M 1.40625 -1.234375 C 1.40625 -1.035156 1.484375 -0.878906 1.640625 -0.765625 C 1.796875 -0.648438 2.019531 -0.59375 2.3125 -0.59375 C 2.726562 -0.59375 3.085938 -0.691406 3.390625 -0.890625 C 3.691406 -1.097656 3.84375 -1.363281 3.84375 -1.6875 L 3.84375 -2.375 L 2.734375 -2.15625 C 2.285156 -2.070312 1.953125 -1.957031 1.734375 -1.8125 C 1.515625 -1.664062 1.40625 -1.472656 1.40625 -1.234375 Z M 1.40625 -1.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.734375 -6.5625 C 0.734375 -6.738281 0.785156 -6.878906 0.890625 -6.984375 C 1.003906 -7.097656 1.148438 -7.15625 1.328125 -7.15625 C 1.503906 -7.15625 1.644531 -7.097656 1.75 -6.984375 C 1.863281 -6.878906 1.921875 -6.738281 1.921875 -6.5625 C 1.921875 -6.382812 1.867188 -6.238281 1.765625 -6.125 C 1.660156 -6.019531 1.515625 -5.96875 1.328125 -5.96875 C 1.148438 -5.96875 1.003906 -6.019531 0.890625 -6.125 C 0.785156 -6.238281 0.734375 -6.382812 0.734375 -6.5625 Z M 0.921875 0 L 0.921875 -5 L 1.734375 -5 L 1.734375 0 Z M 0.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.828125 -3.945312 1.234375 -4.40625 C 1.648438 -4.863281 2.207031 -5.09375 2.90625 -5.09375 C 3.28125 -5.09375 3.609375 -5.015625 3.890625 -4.859375 C 4.179688 -4.703125 4.410156 -4.488281 4.578125 -4.21875 L 4.578125 -7.296875 L 5.375 -7.296875 L 5.375 0 L 4.671875 0 L 4.625 -0.875 C 4.476562 -0.582031 4.25 -0.347656 3.9375 -0.171875 C 3.632812 0.00390625 3.289062 0.09375 2.90625 0.09375 C 2.207031 0.09375 1.648438 -0.132812 1.234375 -0.59375 C 0.828125 -1.0625 0.625 -1.695312 0.625 -2.5 Z M 1.4375 -2.5 C 1.4375 -1.914062 1.570312 -1.453125 1.84375 -1.109375 C 2.125 -0.765625 2.507812 -0.59375 3 -0.59375 C 3.476562 -0.59375 3.859375 -0.757812 4.140625 -1.09375 C 4.429688 -1.4375 4.578125 -1.882812 4.578125 -2.4375 L 4.578125 -2.5625 C 4.578125 -3.125 4.429688 -3.570312 4.140625 -3.90625 C 3.859375 -4.238281 3.476562 -4.40625 3 -4.40625 C 2.507812 -4.40625 2.125 -4.234375 1.84375 -3.890625 C 1.570312 -3.546875 1.4375 -3.082031 1.4375 -2.5 Z M 1.4375 -2.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -2.5 C 0.625 -3.3125 0.828125 -3.945312 1.234375 -4.40625 C 1.640625 -4.863281 2.222656 -5.09375 2.984375 -5.09375 C 3.441406 -5.09375 3.84375 -4.988281 4.1875 -4.78125 C 4.53125 -4.582031 4.785156 -4.304688 4.953125 -3.953125 C 5.128906 -3.597656 5.21875 -3.203125 5.21875 -2.765625 C 5.21875 -2.578125 5.207031 -2.390625 5.1875 -2.203125 L 1.40625 -2.203125 C 1.457031 -1.691406 1.625 -1.296875 1.90625 -1.015625 C 2.195312 -0.734375 2.578125 -0.59375 3.046875 -0.59375 C 3.410156 -0.59375 3.710938 -0.65625 3.953125 -0.78125 C 4.203125 -0.914062 4.367188 -1.101562 4.453125 -1.34375 L 5.125 -0.984375 C 4.925781 -0.628906 4.65625 -0.359375 4.3125 -0.171875 C 3.976562 0.00390625 3.554688 0.09375 3.046875 0.09375 C 2.296875 0.09375 1.703125 -0.132812 1.265625 -0.59375 C 0.835938 -1.050781 0.625 -1.6875 0.625 -2.5 Z M 1.421875 -2.90625 L 4.453125 -2.90625 C 4.398438 -3.375 4.242188 -3.738281 3.984375 -4 C 3.734375 -4.269531 3.398438 -4.40625 2.984375 -4.40625 C 2.535156 -4.40625 2.175781 -4.273438 1.90625 -4.015625 C 1.644531 -3.753906 1.484375 -3.382812 1.421875 -2.90625 Z M 2.46875 -5.828125 L 3.21875 -7.5 L 4.09375 -7.5 L 3.109375 -5.828125 Z M 2.46875 -5.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.921875 0 L 0.921875 -5 L 1.625 -5 L 1.6875 -4.21875 C 1.851562 -4.507812 2.078125 -4.726562 2.359375 -4.875 C 2.640625 -5.019531 2.945312 -5.09375 3.28125 -5.09375 C 3.644531 -5.09375 3.984375 -5.007812 4.296875 -4.84375 C 4.609375 -4.675781 4.84375 -4.4375 5 -4.125 C 5.144531 -4.4375 5.382812 -4.675781 5.71875 -4.84375 C 6.050781 -5.007812 6.390625 -5.09375 6.734375 -5.09375 C 7.066406 -5.09375 7.378906 -5.023438 7.671875 -4.890625 C 7.960938 -4.753906 8.195312 -4.539062 8.375 -4.25 C 8.5625 -3.96875 8.65625 -3.617188 8.65625 -3.203125 L 8.65625 0 L 7.859375 0 L 7.859375 -3.125 C 7.859375 -3.550781 7.75 -3.867188 7.53125 -4.078125 C 7.3125 -4.296875 7.023438 -4.40625 6.671875 -4.40625 C 6.398438 -4.40625 6.148438 -4.335938 5.921875 -4.203125 C 5.703125 -4.078125 5.523438 -3.890625 5.390625 -3.640625 C 5.253906 -3.390625 5.1875 -3.085938 5.1875 -2.734375 L 5.1875 0 L 4.390625 0 L 4.390625 -3.125 C 4.390625 -3.550781 4.28125 -3.867188 4.0625 -4.078125 C 3.84375 -4.296875 3.554688 -4.40625 3.203125 -4.40625 C 2.960938 -4.40625 2.726562 -4.34375 2.5 -4.21875 C 2.28125 -4.09375 2.097656 -3.898438 1.953125 -3.640625 C 1.804688 -3.378906 1.734375 -3.054688 1.734375 -2.671875 L 1.734375 0 Z M 0.921875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -0.546875 C 0.671875 -0.742188 0.734375 -0.898438 0.859375 -1.015625 C 0.984375 -1.140625 1.140625 -1.203125 1.328125 -1.203125 C 1.523438 -1.203125 1.679688 -1.140625 1.796875 -1.015625 C 1.921875 -0.898438 1.984375 -0.742188 1.984375 -0.546875 C 1.984375 -0.359375 1.921875 -0.203125 1.796875 -0.078125 C 1.679688 0.0351562 1.523438 0.09375 1.328125 0.09375 C 1.140625 0.09375 0.984375 0.0351562 0.859375 -0.078125 C 0.734375 -0.203125 0.671875 -0.359375 0.671875 -0.546875 Z M 0.671875 -0.546875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.453125 0.828125 C 0.453125 0.597656 0.53125 0.394531 0.6875 0.21875 C 0.84375 0.0507812 1.0625 -0.0664062 1.34375 -0.140625 C 1.132812 -0.242188 0.96875 -0.367188 0.84375 -0.515625 C 0.71875 -0.671875 0.65625 -0.851562 0.65625 -1.0625 C 0.65625 -1.3125 0.722656 -1.515625 0.859375 -1.671875 C 0.992188 -1.835938 1.175781 -1.960938 1.40625 -2.046875 C 1.164062 -2.191406 0.984375 -2.378906 0.859375 -2.609375 C 0.734375 -2.847656 0.671875 -3.113281 0.671875 -3.40625 C 0.671875 -3.726562 0.757812 -4.019531 0.9375 -4.28125 C 1.113281 -4.539062 1.359375 -4.738281 1.671875 -4.875 C 1.984375 -5.019531 2.335938 -5.09375 2.734375 -5.09375 C 3.109375 -5.09375 3.445312 -5.03125 3.75 -4.90625 C 3.9375 -5.582031 4.40625 -5.921875 5.15625 -5.921875 L 5.34375 -5.21875 C 4.6875 -5.21875 4.289062 -5.035156 4.15625 -4.671875 C 4.351562 -4.515625 4.503906 -4.328125 4.609375 -4.109375 C 4.722656 -3.898438 4.78125 -3.664062 4.78125 -3.40625 C 4.78125 -3.082031 4.691406 -2.789062 4.515625 -2.53125 C 4.347656 -2.28125 4.109375 -2.082031 3.796875 -1.9375 C 3.484375 -1.789062 3.128906 -1.71875 2.734375 -1.71875 C 2.441406 -1.71875 2.179688 -1.75 1.953125 -1.8125 C 1.753906 -1.769531 1.613281 -1.695312 1.53125 -1.59375 C 1.445312 -1.488281 1.40625 -1.351562 1.40625 -1.1875 C 1.40625 -1.007812 1.460938 -0.875 1.578125 -0.78125 C 1.703125 -0.6875 1.863281 -0.640625 2.0625 -0.640625 L 3.71875 -0.640625 C 4.1875 -0.640625 4.554688 -0.53125 4.828125 -0.3125 C 5.097656 -0.101562 5.234375 0.179688 5.234375 0.546875 C 5.234375 0.867188 5.125 1.148438 4.90625 1.390625 C 4.6875 1.640625 4.382812 1.828125 4 1.953125 C 3.625 2.085938 3.210938 2.15625 2.765625 2.15625 C 2.003906 2.15625 1.425781 2.03125 1.03125 1.78125 C 0.644531 1.539062 0.453125 1.222656 0.453125 0.828125 Z M 1.203125 0.671875 C 1.203125 0.921875 1.34375 1.117188 1.625 1.265625 C 1.90625 1.410156 2.316406 1.484375 2.859375 1.484375 C 3.359375 1.484375 3.753906 1.398438 4.046875 1.234375 C 4.347656 1.066406 4.5 0.867188 4.5 0.640625 C 4.5 0.453125 4.421875 0.304688 4.265625 0.203125 C 4.109375 0.0976562 3.851562 0.046875 3.5 0.046875 L 2.15625 0.046875 C 1.851562 0.046875 1.617188 0.0976562 1.453125 0.203125 C 1.285156 0.316406 1.203125 0.472656 1.203125 0.671875 Z M 1.515625 -3.40625 C 1.515625 -3.101562 1.628906 -2.851562 1.859375 -2.65625 C 2.097656 -2.46875 2.390625 -2.375 2.734375 -2.375 C 3.078125 -2.375 3.363281 -2.46875 3.59375 -2.65625 C 3.832031 -2.851562 3.953125 -3.101562 3.953125 -3.40625 C 3.953125 -3.71875 3.832031 -3.96875 3.59375 -4.15625 C 3.363281 -4.351562 3.078125 -4.453125 2.734375 -4.453125 C 2.390625 -4.453125 2.097656 -4.351562 1.859375 -4.15625 C 1.628906 -3.96875 1.515625 -3.71875 1.515625 -3.40625 Z M 1.515625 -3.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.328125 -4.3125 L 0.328125 -5 L 1.3125 -5 L 1.3125 -5.84375 C 1.3125 -6.300781 1.453125 -6.664062 1.734375 -6.9375 C 2.015625 -7.207031 2.421875 -7.34375 2.953125 -7.34375 C 3.140625 -7.34375 3.304688 -7.320312 3.453125 -7.28125 C 3.609375 -7.25 3.726562 -7.195312 3.8125 -7.125 L 3.59375 -6.46875 C 3.4375 -6.570312 3.25 -6.625 3.03125 -6.625 C 2.425781 -6.625 2.125 -6.335938 2.125 -5.765625 L 2.125 -5 L 3.796875 -5 L 3.796875 -4.3125 L 2.125 -4.3125 L 2.125 0 L 1.3125 0 L 1.3125 -4.3125 Z M 0.328125 -4.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.328125 0 L 0.328125 -6.671875 L 2.984375 -6.671875 L 2.984375 0 Z M 0.671875 -0.328125 L 2.65625 -0.328125 L 2.65625 -6.328125 L 0.671875 -6.328125 Z M 0.671875 -0.328125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.578125 -1.65625 L 0.578125 -5 L 2.28125 -5 L 2.28125 -2.09375 C 2.28125 -1.769531 2.335938 -1.539062 2.453125 -1.40625 C 2.566406 -1.269531 2.738281 -1.203125 2.96875 -1.203125 C 3.25 -1.203125 3.472656 -1.296875 3.640625 -1.484375 C 3.804688 -1.671875 3.890625 -1.957031 3.890625 -2.34375 L 3.890625 -5 L 5.59375 -5 L 5.59375 0 L 4.078125 0 L 4.015625 -0.921875 C 3.703125 -0.242188 3.128906 0.09375 2.296875 0.09375 C 1.753906 0.09375 1.332031 -0.046875 1.03125 -0.328125 C 0.726562 -0.609375 0.578125 -1.050781 0.578125 -1.65625 Z M 0.578125 -1.65625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.125 -3.796875 L 0.125 -5 L 0.984375 -5 L 0.984375 -6.125 L 2.6875 -6.59375 L 2.6875 -5 L 4.1875 -5 L 4.1875 -3.796875 L 2.6875 -3.796875 L 2.6875 -1.78125 C 2.6875 -1.332031 2.90625 -1.109375 3.34375 -1.109375 C 3.625 -1.109375 3.867188 -1.179688 4.078125 -1.328125 L 4.234375 -0.28125 C 4.066406 -0.164062 3.851562 -0.0703125 3.59375 0 C 3.34375 0.0625 3.085938 0.09375 2.828125 0.09375 C 2.234375 0.09375 1.78125 -0.03125 1.46875 -0.28125 C 1.15625 -0.53125 0.992188 -0.9375 0.984375 -1.5 L 0.984375 -3.796875 Z M 0.125 -3.796875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.09375 -6.609375 L 1.875 -6.609375 L 2.796875 -4.796875 L 3.296875 -3.6875 L 3.796875 -4.796875 L 4.71875 -6.609375 L 6.46875 -6.609375 L 4.140625 -2.40625 L 4.140625 0 L 2.421875 0 L 2.421875 -2.40625 Z M 0.09375 -6.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.234375 0.96875 C 0.234375 0.75 0.304688 0.554688 0.453125 0.390625 C 0.609375 0.222656 0.84375 0.101562 1.15625 0.03125 C 0.644531 -0.1875 0.390625 -0.535156 0.390625 -1.015625 C 0.390625 -1.242188 0.460938 -1.445312 0.609375 -1.625 C 0.753906 -1.8125 0.957031 -1.945312 1.21875 -2.03125 C 0.664062 -2.320312 0.390625 -2.78125 0.390625 -3.40625 C 0.390625 -3.9375 0.601562 -4.347656 1.03125 -4.640625 C 1.457031 -4.941406 2.054688 -5.09375 2.828125 -5.09375 C 3.191406 -5.09375 3.523438 -5.054688 3.828125 -4.984375 C 3.890625 -5.390625 4.035156 -5.71875 4.265625 -5.96875 C 4.503906 -6.21875 4.832031 -6.34375 5.25 -6.34375 L 5.40625 -6.34375 L 5.59375 -5.203125 C 5.46875 -5.222656 5.378906 -5.234375 5.328125 -5.234375 C 5.097656 -5.234375 4.90625 -5.191406 4.75 -5.109375 C 4.601562 -5.023438 4.492188 -4.914062 4.421875 -4.78125 C 4.984375 -4.488281 5.265625 -4.03125 5.265625 -3.40625 C 5.265625 -2.863281 5.050781 -2.441406 4.625 -2.140625 C 4.195312 -1.847656 3.597656 -1.703125 2.828125 -1.703125 C 2.472656 -1.703125 2.15625 -1.734375 1.875 -1.796875 C 1.664062 -1.742188 1.5625 -1.628906 1.5625 -1.453125 C 1.5625 -1.222656 1.734375 -1.109375 2.078125 -1.109375 L 3.78125 -1.109375 C 4.363281 -1.109375 4.8125 -0.984375 5.125 -0.734375 C 5.4375 -0.484375 5.59375 -0.109375 5.59375 0.390625 C 5.59375 0.953125 5.34375 1.382812 4.84375 1.6875 C 4.34375 2 3.65625 2.15625 2.78125 2.15625 C 1.914062 2.15625 1.273438 2.050781 0.859375 1.84375 C 0.441406 1.632812 0.234375 1.34375 0.234375 0.96875 Z M 1.515625 0.59375 C 1.515625 0.894531 1.976562 1.046875 2.90625 1.046875 C 3.34375 1.046875 3.675781 1 3.90625 0.90625 C 4.144531 0.820312 4.265625 0.707031 4.265625 0.5625 C 4.265625 0.457031 4.21875 0.375 4.125 0.3125 C 4.03125 0.257812 3.875 0.234375 3.65625 0.234375 L 2.28125 0.234375 C 2.007812 0.234375 1.8125 0.257812 1.6875 0.3125 C 1.570312 0.375 1.515625 0.46875 1.515625 0.59375 Z M 2.09375 -3.40625 C 2.09375 -3.175781 2.160156 -3 2.296875 -2.875 C 2.429688 -2.75 2.609375 -2.6875 2.828125 -2.6875 C 3.054688 -2.6875 3.234375 -2.75 3.359375 -2.875 C 3.492188 -3.007812 3.5625 -3.1875 3.5625 -3.40625 C 3.5625 -3.625 3.492188 -3.796875 3.359375 -3.921875 C 3.222656 -4.054688 3.046875 -4.125 2.828125 -4.125 C 2.609375 -4.125 2.429688 -4.054688 2.296875 -3.921875 C 2.160156 -3.796875 2.09375 -3.625 2.09375 -3.40625 Z M 2.09375 -3.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.453125 -1.75 C 0.453125 -2.144531 0.554688 -2.476562 0.765625 -2.75 C 0.984375 -3.03125 1.296875 -3.238281 1.703125 -3.375 C 1.378906 -3.5 1.125 -3.6875 0.9375 -3.9375 C 0.75 -4.195312 0.65625 -4.492188 0.65625 -4.828125 C 0.65625 -5.398438 0.878906 -5.851562 1.328125 -6.1875 C 1.773438 -6.519531 2.375 -6.6875 3.125 -6.6875 C 3.894531 -6.6875 4.5 -6.519531 4.9375 -6.1875 C 5.382812 -5.851562 5.609375 -5.398438 5.609375 -4.828125 C 5.609375 -4.492188 5.515625 -4.195312 5.328125 -3.9375 C 5.148438 -3.6875 4.894531 -3.5 4.5625 -3.375 C 4.96875 -3.238281 5.28125 -3.03125 5.5 -2.75 C 5.71875 -2.476562 5.828125 -2.144531 5.828125 -1.75 C 5.828125 -1.175781 5.585938 -0.722656 5.109375 -0.390625 C 4.628906 -0.0664062 3.96875 0.09375 3.125 0.09375 C 2.300781 0.09375 1.648438 -0.0664062 1.171875 -0.390625 C 0.691406 -0.722656 0.453125 -1.175781 0.453125 -1.75 Z M 2.125 -1.96875 C 2.125 -1.71875 2.210938 -1.519531 2.390625 -1.375 C 2.566406 -1.226562 2.8125 -1.15625 3.125 -1.15625 C 3.445312 -1.15625 3.695312 -1.226562 3.875 -1.375 C 4.0625 -1.519531 4.15625 -1.71875 4.15625 -1.96875 C 4.15625 -2.226562 4.0625 -2.425781 3.875 -2.5625 C 3.695312 -2.707031 3.445312 -2.78125 3.125 -2.78125 C 2.8125 -2.78125 2.566406 -2.707031 2.390625 -2.5625 C 2.210938 -2.425781 2.125 -2.226562 2.125 -1.96875 Z M 2.265625 -4.671875 C 2.265625 -4.429688 2.34375 -4.242188 2.5 -4.109375 C 2.65625 -3.972656 2.863281 -3.90625 3.125 -3.90625 C 3.40625 -3.90625 3.625 -3.972656 3.78125 -4.109375 C 3.9375 -4.253906 4.015625 -4.441406 4.015625 -4.671875 C 4.015625 -4.910156 3.9375 -5.097656 3.78125 -5.234375 C 3.625 -5.367188 3.40625 -5.4375 3.125 -5.4375 C 2.851562 -5.4375 2.640625 -5.367188 2.484375 -5.234375 C 2.335938 -5.097656 2.265625 -4.910156 2.265625 -4.671875 Z M 2.265625 -4.671875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.6875 0.09375 C 1.53125 0.09375 0.710938 -0.195312 0.234375 -0.78125 L 1.125 -1.734375 C 1.40625 -1.265625 1.894531 -1.03125 2.59375 -1.03125 C 2.832031 -1.03125 3.015625 -1.0625 3.140625 -1.125 C 3.273438 -1.1875 3.34375 -1.269531 3.34375 -1.375 C 3.34375 -1.476562 3.273438 -1.5625 3.140625 -1.625 C 3.003906 -1.695312 2.769531 -1.765625 2.4375 -1.828125 C 1.695312 -1.972656 1.164062 -2.171875 0.84375 -2.421875 C 0.53125 -2.679688 0.375 -3.019531 0.375 -3.4375 C 0.375 -3.726562 0.460938 -4 0.640625 -4.25 C 0.816406 -4.5 1.085938 -4.703125 1.453125 -4.859375 C 1.816406 -5.015625 2.257812 -5.09375 2.78125 -5.09375 C 3.351562 -5.09375 3.820312 -5.015625 4.1875 -4.859375 C 4.550781 -4.703125 4.84375 -4.46875 5.0625 -4.15625 L 4.1875 -3.296875 C 4.03125 -3.535156 3.84375 -3.707031 3.625 -3.8125 C 3.40625 -3.914062 3.140625 -3.96875 2.828125 -3.96875 C 2.585938 -3.96875 2.398438 -3.929688 2.265625 -3.859375 C 2.140625 -3.785156 2.078125 -3.695312 2.078125 -3.59375 C 2.078125 -3.488281 2.144531 -3.398438 2.28125 -3.328125 C 2.414062 -3.265625 2.648438 -3.195312 2.984375 -3.125 C 3.722656 -3 4.253906 -2.8125 4.578125 -2.5625 C 4.898438 -2.3125 5.0625 -1.96875 5.0625 -1.53125 C 5.0625 -1.050781 4.859375 -0.660156 4.453125 -0.359375 C 4.046875 -0.0546875 3.457031 0.09375 2.6875 0.09375 Z M 2.6875 0.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -0.9375 1.828125 L -0.703125 0.734375 C -0.546875 0.859375 -0.34375 0.921875 -0.09375 0.921875 C -0.0820312 0.921875 -0.0703125 0.921875 -0.0625 0.921875 C 0.15625 0.921875 0.320312 0.859375 0.4375 0.734375 C 0.550781 0.617188 0.609375 0.414062 0.609375 0.125 L 0.609375 -5 L 2.3125 -5 L 2.3125 0.28125 C 2.3125 0.9375 2.144531 1.410156 1.8125 1.703125 C 1.476562 2.003906 1 2.15625 0.375 2.15625 C -0.15625 2.15625 -0.59375 2.046875 -0.9375 1.828125 Z M 0.46875 -6.390625 C 0.46875 -6.671875 0.546875 -6.878906 0.703125 -7.015625 C 0.859375 -7.148438 1.109375 -7.21875 1.453125 -7.21875 C 1.785156 -7.21875 2.035156 -7.148438 2.203125 -7.015625 C 2.367188 -6.878906 2.453125 -6.671875 2.453125 -6.390625 C 2.453125 -6.117188 2.367188 -5.914062 2.203125 -5.78125 C 2.046875 -5.644531 1.796875 -5.578125 1.453125 -5.578125 C 1.109375 -5.578125 0.859375 -5.644531 0.703125 -5.78125 C 0.546875 -5.914062 0.46875 -6.117188 0.46875 -6.390625 Z M 0.46875 -6.390625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.375 -2.5 C 0.375 -3.320312 0.597656 -3.957031 1.046875 -4.40625 C 1.503906 -4.863281 2.148438 -5.09375 2.984375 -5.09375 C 3.785156 -5.09375 4.398438 -4.867188 4.828125 -4.421875 C 5.265625 -3.984375 5.484375 -3.363281 5.484375 -2.5625 C 5.484375 -2.34375 5.46875 -2.160156 5.4375 -2.015625 L 2.015625 -2.015625 C 2.066406 -1.703125 2.179688 -1.46875 2.359375 -1.3125 C 2.535156 -1.164062 2.773438 -1.09375 3.078125 -1.09375 C 3.316406 -1.09375 3.515625 -1.140625 3.671875 -1.234375 C 3.828125 -1.328125 3.929688 -1.46875 3.984375 -1.65625 L 5.375 -1.21875 C 5.226562 -0.789062 4.953125 -0.460938 4.546875 -0.234375 C 4.148438 -0.015625 3.660156 0.09375 3.078125 0.09375 C 2.203125 0.09375 1.53125 -0.128906 1.0625 -0.578125 C 0.601562 -1.035156 0.375 -1.675781 0.375 -2.5 Z M 2.96875 -3.90625 C 2.425781 -3.90625 2.109375 -3.582031 2.015625 -2.9375 L 3.890625 -2.9375 C 3.804688 -3.582031 3.5 -3.90625 2.96875 -3.90625 Z M 2.96875 -3.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.359375 0 L 0.359375 -7.328125 L 3.28125 -7.328125 L 3.28125 0 Z M 0.734375 -0.359375 L 2.921875 -0.359375 L 2.921875 -6.96875 L 0.734375 -6.96875 Z M 0.734375 -0.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 -2.75 C 0.6875 -3.632812 0.910156 -4.332031 1.359375 -4.84375 C 1.816406 -5.351562 2.429688 -5.609375 3.203125 -5.609375 C 3.609375 -5.609375 3.96875 -5.519531 4.28125 -5.34375 C 4.601562 -5.164062 4.851562 -4.929688 5.03125 -4.640625 L 5.03125 -8.03125 L 5.90625 -8.03125 L 5.90625 0 L 5.140625 0 L 5.078125 -0.953125 C 4.921875 -0.628906 4.675781 -0.367188 4.34375 -0.171875 C 4.007812 0.015625 3.628906 0.109375 3.203125 0.109375 C 2.429688 0.109375 1.816406 -0.144531 1.359375 -0.65625 C 0.910156 -1.164062 0.6875 -1.863281 0.6875 -2.75 Z M 1.578125 -2.75 C 1.578125 -2.113281 1.726562 -1.601562 2.03125 -1.21875 C 2.34375 -0.84375 2.765625 -0.65625 3.296875 -0.65625 C 3.828125 -0.65625 4.25 -0.835938 4.5625 -1.203125 C 4.875 -1.578125 5.03125 -2.070312 5.03125 -2.6875 L 5.03125 -2.8125 C 5.03125 -3.425781 4.875 -3.914062 4.5625 -4.28125 C 4.25 -4.65625 3.828125 -4.84375 3.296875 -4.84375 C 2.765625 -4.84375 2.34375 -4.648438 2.03125 -4.265625 C 1.726562 -3.890625 1.578125 -3.382812 1.578125 -2.75 Z M 1.578125 -2.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.8125 -7.21875 C 0.8125 -7.414062 0.867188 -7.570312 0.984375 -7.6875 C 1.109375 -7.8125 1.269531 -7.875 1.46875 -7.875 C 1.65625 -7.875 1.8125 -7.8125 1.9375 -7.6875 C 2.0625 -7.570312 2.125 -7.414062 2.125 -7.21875 C 2.125 -7.019531 2.0625 -6.859375 1.9375 -6.734375 C 1.820312 -6.617188 1.664062 -6.5625 1.46875 -6.5625 C 1.269531 -6.5625 1.109375 -6.617188 0.984375 -6.734375 C 0.867188 -6.859375 0.8125 -7.019531 0.8125 -7.21875 Z M 1.015625 0 L 1.015625 -5.5 L 1.90625 -5.5 L 1.90625 0 Z M 1.015625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.015625 2.3125 L 1.015625 -5.5 L 1.796875 -5.5 L 1.84375 -4.546875 C 2.007812 -4.867188 2.257812 -5.125 2.59375 -5.3125 C 2.925781 -5.507812 3.304688 -5.609375 3.734375 -5.609375 C 4.492188 -5.609375 5.097656 -5.351562 5.546875 -4.84375 C 6.003906 -4.332031 6.234375 -3.632812 6.234375 -2.75 C 6.234375 -1.863281 6.003906 -1.164062 5.546875 -0.65625 C 5.097656 -0.144531 4.492188 0.109375 3.734375 0.109375 C 3.328125 0.109375 2.960938 0.0195312 2.640625 -0.15625 C 2.328125 -0.332031 2.082031 -0.566406 1.90625 -0.859375 L 1.90625 2.3125 Z M 1.90625 -2.6875 C 1.90625 -2.070312 2.0625 -1.578125 2.375 -1.203125 C 2.6875 -0.835938 3.101562 -0.65625 3.625 -0.65625 C 4.164062 -0.65625 4.585938 -0.84375 4.890625 -1.21875 C 5.203125 -1.601562 5.359375 -2.113281 5.359375 -2.75 C 5.359375 -3.382812 5.203125 -3.890625 4.890625 -4.265625 C 4.585938 -4.648438 4.164062 -4.84375 3.625 -4.84375 C 3.101562 -4.84375 2.6875 -4.65625 2.375 -4.28125 C 2.0625 -3.914062 1.90625 -3.425781 1.90625 -2.8125 Z M 1.90625 -2.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -1.359375 L 0.984375 -8.03125 L 1.859375 -8.03125 L 1.859375 -1.46875 C 1.859375 -1.1875 1.898438 -0.992188 1.984375 -0.890625 C 2.066406 -0.785156 2.222656 -0.734375 2.453125 -0.734375 C 2.609375 -0.734375 2.742188 -0.742188 2.859375 -0.765625 C 2.972656 -0.796875 3.101562 -0.835938 3.25 -0.890625 L 3.109375 -0.046875 C 2.878906 0.0546875 2.617188 0.109375 2.328125 0.109375 C 2.316406 0.109375 2.304688 0.109375 2.296875 0.109375 C 1.847656 0.109375 1.515625 -0.0078125 1.296875 -0.25 C 1.085938 -0.5 0.984375 -0.867188 0.984375 -1.359375 Z M 0.984375 -1.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 -2.75 C 0.6875 -3.644531 0.921875 -4.34375 1.390625 -4.84375 C 1.859375 -5.351562 2.507812 -5.609375 3.34375 -5.609375 C 4.175781 -5.609375 4.828125 -5.351562 5.296875 -4.84375 C 5.765625 -4.34375 6 -3.644531 6 -2.75 C 6 -1.851562 5.765625 -1.148438 5.296875 -0.640625 C 4.828125 -0.140625 4.175781 0.109375 3.34375 0.109375 C 2.519531 0.109375 1.867188 -0.140625 1.390625 -0.640625 C 0.921875 -1.148438 0.6875 -1.851562 0.6875 -2.75 Z M 1.5625 -2.75 C 1.5625 -2.09375 1.71875 -1.578125 2.03125 -1.203125 C 2.351562 -0.835938 2.789062 -0.65625 3.34375 -0.65625 C 3.90625 -0.65625 4.34375 -0.835938 4.65625 -1.203125 C 4.96875 -1.578125 5.125 -2.09375 5.125 -2.75 C 5.125 -3.40625 4.960938 -3.914062 4.640625 -4.28125 C 4.328125 -4.65625 3.894531 -4.84375 3.34375 -4.84375 C 2.789062 -4.84375 2.351562 -4.65625 2.03125 -4.28125 C 1.71875 -3.914062 1.5625 -3.40625 1.5625 -2.75 Z M 1.5625 -2.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.015625 0 L 1.015625 -5.5 L 1.796875 -5.5 L 1.84375 -4.640625 C 2.03125 -4.960938 2.28125 -5.203125 2.59375 -5.359375 C 2.90625 -5.523438 3.242188 -5.609375 3.609375 -5.609375 C 4.015625 -5.609375 4.382812 -5.515625 4.71875 -5.328125 C 5.0625 -5.148438 5.320312 -4.882812 5.5 -4.53125 C 5.65625 -4.882812 5.914062 -5.148438 6.28125 -5.328125 C 6.65625 -5.515625 7.03125 -5.609375 7.40625 -5.609375 C 7.78125 -5.609375 8.125 -5.53125 8.4375 -5.375 C 8.757812 -5.226562 9.019531 -5 9.21875 -4.6875 C 9.414062 -4.375 9.515625 -3.984375 9.515625 -3.515625 L 9.515625 0 L 8.640625 0 L 8.640625 -3.4375 C 8.640625 -3.90625 8.519531 -4.253906 8.28125 -4.484375 C 8.039062 -4.722656 7.726562 -4.84375 7.34375 -4.84375 C 7.039062 -4.84375 6.765625 -4.769531 6.515625 -4.625 C 6.273438 -4.476562 6.078125 -4.269531 5.921875 -4 C 5.773438 -3.726562 5.703125 -3.398438 5.703125 -3.015625 L 5.703125 0 L 4.828125 0 L 4.828125 -3.4375 C 4.828125 -3.90625 4.707031 -4.253906 4.46875 -4.484375 C 4.226562 -4.722656 3.914062 -4.84375 3.53125 -4.84375 C 3.257812 -4.84375 3 -4.773438 2.75 -4.640625 C 2.507812 -4.503906 2.304688 -4.289062 2.140625 -4 C 1.984375 -3.71875 1.90625 -3.363281 1.90625 -2.9375 L 1.90625 0 Z M 1.015625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 -2.75 C 0.6875 -3.644531 0.910156 -4.34375 1.359375 -4.84375 C 1.804688 -5.351562 2.445312 -5.609375 3.28125 -5.609375 C 3.789062 -5.609375 4.234375 -5.492188 4.609375 -5.265625 C 4.984375 -5.046875 5.265625 -4.738281 5.453125 -4.34375 C 5.640625 -3.957031 5.734375 -3.519531 5.734375 -3.03125 C 5.734375 -2.832031 5.722656 -2.628906 5.703125 -2.421875 L 1.546875 -2.421875 C 1.597656 -1.859375 1.78125 -1.421875 2.09375 -1.109375 C 2.414062 -0.804688 2.832031 -0.65625 3.34375 -0.65625 C 3.75 -0.65625 4.082031 -0.722656 4.34375 -0.859375 C 4.613281 -1.003906 4.796875 -1.207031 4.890625 -1.46875 L 5.640625 -1.09375 C 5.421875 -0.695312 5.125 -0.394531 4.75 -0.1875 C 4.382812 0.0078125 3.914062 0.109375 3.34375 0.109375 C 2.519531 0.109375 1.867188 -0.140625 1.390625 -0.640625 C 0.921875 -1.148438 0.6875 -1.851562 0.6875 -2.75 Z M 1.5625 -3.203125 L 4.890625 -3.203125 C 4.835938 -3.710938 4.671875 -4.113281 4.390625 -4.40625 C 4.109375 -4.695312 3.738281 -4.84375 3.28125 -4.84375 C 2.789062 -4.84375 2.394531 -4.695312 2.09375 -4.40625 C 1.800781 -4.125 1.625 -3.722656 1.5625 -3.203125 Z M 1.5625 -3.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.75 -0.609375 C 0.75 -0.816406 0.8125 -0.988281 0.9375 -1.125 C 1.070312 -1.257812 1.25 -1.328125 1.46875 -1.328125 C 1.675781 -1.328125 1.847656 -1.257812 1.984375 -1.125 C 2.117188 -0.988281 2.1875 -0.816406 2.1875 -0.609375 C 2.1875 -0.398438 2.117188 -0.226562 1.984375 -0.09375 C 1.847656 0.0390625 1.675781 0.109375 1.46875 0.109375 C 1.25 0.109375 1.070312 0.046875 0.9375 -0.078125 C 0.8125 -0.210938 0.75 -0.390625 0.75 -0.609375 Z M 0.75 -0.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.5 0.90625 C 0.5 0.65625 0.582031 0.4375 0.75 0.25 C 0.925781 0.0625 1.164062 -0.0703125 1.46875 -0.15625 C 1.25 -0.269531 1.066406 -0.410156 0.921875 -0.578125 C 0.785156 -0.742188 0.71875 -0.941406 0.71875 -1.171875 C 0.71875 -1.441406 0.789062 -1.664062 0.9375 -1.84375 C 1.09375 -2.019531 1.296875 -2.15625 1.546875 -2.25 C 1.285156 -2.40625 1.085938 -2.613281 0.953125 -2.875 C 0.816406 -3.132812 0.75 -3.425781 0.75 -3.75 C 0.75 -4.101562 0.84375 -4.421875 1.03125 -4.703125 C 1.226562 -4.992188 1.5 -5.21875 1.84375 -5.375 C 2.1875 -5.53125 2.570312 -5.609375 3 -5.609375 C 3.414062 -5.609375 3.789062 -5.535156 4.125 -5.390625 C 4.332031 -6.140625 4.847656 -6.515625 5.671875 -6.515625 L 5.875 -5.734375 C 5.15625 -5.734375 4.71875 -5.535156 4.5625 -5.140625 C 4.78125 -4.960938 4.953125 -4.753906 5.078125 -4.515625 C 5.203125 -4.285156 5.265625 -4.03125 5.265625 -3.75 C 5.265625 -3.394531 5.164062 -3.070312 4.96875 -2.78125 C 4.78125 -2.5 4.515625 -2.28125 4.171875 -2.125 C 3.828125 -1.96875 3.4375 -1.890625 3 -1.890625 C 2.675781 -1.890625 2.394531 -1.925781 2.15625 -2 C 1.9375 -1.945312 1.78125 -1.863281 1.6875 -1.75 C 1.59375 -1.632812 1.546875 -1.484375 1.546875 -1.296875 C 1.546875 -1.109375 1.609375 -0.960938 1.734375 -0.859375 C 1.867188 -0.753906 2.046875 -0.703125 2.265625 -0.703125 L 4.09375 -0.703125 C 4.613281 -0.703125 5.019531 -0.582031 5.3125 -0.34375 C 5.601562 -0.113281 5.75 0.203125 5.75 0.609375 C 5.75 0.960938 5.628906 1.269531 5.390625 1.53125 C 5.148438 1.800781 4.820312 2.003906 4.40625 2.140625 C 3.988281 2.285156 3.53125 2.359375 3.03125 2.359375 C 2.195312 2.359375 1.566406 2.222656 1.140625 1.953125 C 0.710938 1.691406 0.5 1.34375 0.5 0.90625 Z M 1.328125 0.734375 C 1.328125 1.015625 1.476562 1.234375 1.78125 1.390625 C 2.09375 1.546875 2.546875 1.625 3.140625 1.625 C 3.691406 1.625 4.128906 1.535156 4.453125 1.359375 C 4.773438 1.179688 4.9375 0.960938 4.9375 0.703125 C 4.9375 0.492188 4.851562 0.332031 4.6875 0.21875 C 4.519531 0.101562 4.238281 0.046875 3.84375 0.046875 L 2.375 0.046875 C 2.039062 0.046875 1.78125 0.109375 1.59375 0.234375 C 1.414062 0.359375 1.328125 0.523438 1.328125 0.734375 Z M 1.65625 -3.75 C 1.65625 -3.414062 1.785156 -3.140625 2.046875 -2.921875 C 2.304688 -2.710938 2.625 -2.609375 3 -2.609375 C 3.382812 -2.609375 3.703125 -2.710938 3.953125 -2.921875 C 4.210938 -3.140625 4.34375 -3.414062 4.34375 -3.75 C 4.34375 -4.082031 4.210938 -4.351562 3.953125 -4.5625 C 3.703125 -4.78125 3.382812 -4.890625 3 -4.890625 C 2.625 -4.890625 2.304688 -4.785156 2.046875 -4.578125 C 1.785156 -4.367188 1.65625 -4.09375 1.65625 -3.75 Z M 1.65625 -3.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.96875 -1.90625 L 0.96875 -5.5 L 1.84375 -5.5 L 1.84375 -2.125 C 1.84375 -1.59375 1.953125 -1.210938 2.171875 -0.984375 C 2.398438 -0.765625 2.722656 -0.65625 3.140625 -0.65625 C 3.648438 -0.65625 4.070312 -0.804688 4.40625 -1.109375 C 4.738281 -1.421875 4.90625 -1.890625 4.90625 -2.515625 L 4.90625 -5.5 L 5.78125 -5.5 L 5.78125 0 L 5.015625 0 L 4.96875 -0.84375 C 4.601562 -0.207031 3.941406 0.109375 2.984375 0.109375 C 2.390625 0.109375 1.90625 -0.0507812 1.53125 -0.375 C 1.15625 -0.707031 0.96875 -1.21875 0.96875 -1.90625 Z M 0.96875 -1.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.140625 -5.5 L 1.140625 -5.5 L 2.875 -0.890625 L 4.65625 -5.5 L 5.59375 -5.5 L 3.296875 0 L 2.421875 0 Z M 0.140625 -5.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.359375 -4.75 L 0.359375 -5.5 L 1.453125 -5.5 L 1.453125 -6.421875 C 1.453125 -6.929688 1.601562 -7.332031 1.90625 -7.625 C 2.21875 -7.925781 2.664062 -8.078125 3.25 -8.078125 C 3.445312 -8.078125 3.628906 -8.054688 3.796875 -8.015625 C 3.960938 -7.972656 4.09375 -7.910156 4.1875 -7.828125 L 3.953125 -7.109375 C 3.785156 -7.222656 3.578125 -7.28125 3.328125 -7.28125 C 2.671875 -7.28125 2.335938 -6.96875 2.328125 -6.34375 L 2.328125 -5.5 L 4.171875 -5.5 L 4.171875 -4.75 L 2.328125 -4.75 L 2.328125 0 L 1.453125 0 L 1.453125 -4.75 Z M 0.359375 -4.75 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.015625 0 L 1.015625 -5.5 L 1.734375 -5.5 L 1.859375 -4.59375 C 2.171875 -5.269531 2.757812 -5.609375 3.625 -5.609375 C 3.882812 -5.609375 4.082031 -5.570312 4.21875 -5.5 L 4.046875 -4.640625 C 3.867188 -4.734375 3.640625 -4.78125 3.359375 -4.78125 C 3.117188 -4.78125 2.882812 -4.710938 2.65625 -4.578125 C 2.4375 -4.441406 2.253906 -4.238281 2.109375 -3.96875 C 1.972656 -3.695312 1.90625 -3.363281 1.90625 -2.96875 L 1.90625 0 Z M 1.015625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.40625 0 L 0.40625 -8 L 3.59375 -8 L 3.59375 0 Z M 0.796875 -0.40625 L 3.1875 -0.40625 L 3.1875 -7.59375 L 0.796875 -7.59375 Z M 0.796875 -0.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 4.09375 -7.921875 C 4.894531 -7.921875 5.535156 -7.703125 6.015625 -7.265625 C 6.503906 -6.828125 6.75 -6.242188 6.75 -5.515625 C 6.75 -4.773438 6.503906 -4.1875 6.015625 -3.75 C 5.535156 -3.3125 4.894531 -3.09375 4.09375 -3.09375 L 2.25 -3.09375 L 2.25 0 Z M 2.25 -4 L 3.953125 -4 C 4.566406 -4 5.019531 -4.125 5.3125 -4.375 C 5.601562 -4.625 5.75 -5.003906 5.75 -5.515625 C 5.75 -6.015625 5.601562 -6.390625 5.3125 -6.640625 C 5.019531 -6.890625 4.566406 -7.015625 3.953125 -7.015625 L 2.25 -7.015625 Z M 2.25 -4 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 -1.484375 C 0.6875 -1.941406 0.882812 -2.335938 1.28125 -2.671875 C 1.6875 -3.003906 2.269531 -3.234375 3.03125 -3.359375 L 4.625 -3.625 L 4.625 -3.96875 C 4.625 -4.363281 4.5 -4.679688 4.25 -4.921875 C 4 -5.160156 3.65625 -5.28125 3.21875 -5.28125 C 2.820312 -5.28125 2.472656 -5.179688 2.171875 -4.984375 C 1.878906 -4.796875 1.65625 -4.515625 1.5 -4.140625 L 0.796875 -4.65625 C 0.953125 -5.101562 1.25 -5.457031 1.6875 -5.71875 C 2.125 -5.988281 2.632812 -6.125 3.21875 -6.125 C 3.925781 -6.125 4.492188 -5.953125 4.921875 -5.609375 C 5.359375 -5.265625 5.578125 -4.753906 5.578125 -4.078125 L 5.578125 -1.125 C 5.578125 -0.988281 5.613281 -0.882812 5.6875 -0.8125 C 5.757812 -0.738281 5.875 -0.703125 6.03125 -0.703125 C 6.195312 -0.703125 6.359375 -0.71875 6.515625 -0.75 L 6.453125 0 C 6.234375 0.0820312 5.992188 0.125 5.734375 0.125 C 5.421875 0.125 5.175781 0.0546875 5 -0.078125 C 4.820312 -0.210938 4.707031 -0.441406 4.65625 -0.765625 C 4.476562 -0.484375 4.207031 -0.265625 3.84375 -0.109375 C 3.488281 0.046875 3.113281 0.125 2.71875 0.125 C 2.125 0.125 1.632812 -0.0078125 1.25 -0.28125 C 0.875 -0.5625 0.6875 -0.960938 0.6875 -1.484375 Z M 1.6875 -1.484375 C 1.6875 -1.242188 1.78125 -1.054688 1.96875 -0.921875 C 2.15625 -0.785156 2.421875 -0.71875 2.765625 -0.71875 C 3.273438 -0.71875 3.710938 -0.835938 4.078125 -1.078125 C 4.441406 -1.316406 4.625 -1.628906 4.625 -2.015625 L 4.625 -2.84375 L 3.28125 -2.59375 C 2.738281 -2.488281 2.335938 -2.347656 2.078125 -2.171875 C 1.816406 -1.992188 1.6875 -1.765625 1.6875 -1.484375 Z M 1.6875 -1.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.109375 0 L 1.109375 -6 L 1.90625 -6 L 2.03125 -5.015625 C 2.363281 -5.753906 3.003906 -6.125 3.953125 -6.125 C 4.234375 -6.125 4.453125 -6.082031 4.609375 -6 L 4.421875 -5.0625 C 4.222656 -5.164062 3.96875 -5.21875 3.65625 -5.21875 C 3.40625 -5.21875 3.15625 -5.144531 2.90625 -5 C 2.664062 -4.851562 2.46875 -4.628906 2.3125 -4.328125 C 2.15625 -4.023438 2.078125 -3.660156 2.078125 -3.234375 L 2.078125 0 Z M 1.109375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -7.875 C 0.875 -8.082031 0.9375 -8.253906 1.0625 -8.390625 C 1.195312 -8.523438 1.375 -8.59375 1.59375 -8.59375 C 1.8125 -8.59375 1.984375 -8.523438 2.109375 -8.390625 C 2.242188 -8.265625 2.3125 -8.09375 2.3125 -7.875 C 2.3125 -7.65625 2.242188 -7.476562 2.109375 -7.34375 C 1.984375 -7.21875 1.8125 -7.15625 1.59375 -7.15625 C 1.375 -7.15625 1.195312 -7.21875 1.0625 -7.34375 C 0.9375 -7.476562 0.875 -7.65625 0.875 -7.875 Z M 1.109375 0 L 1.109375 -6 L 2.078125 -6 L 2.078125 0 Z M 1.109375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.578125 -1.234375 L 1.359375 -1.78125 C 1.492188 -1.425781 1.726562 -1.160156 2.0625 -0.984375 C 2.394531 -0.804688 2.789062 -0.71875 3.25 -0.71875 C 3.726562 -0.71875 4.085938 -0.800781 4.328125 -0.96875 C 4.578125 -1.132812 4.703125 -1.347656 4.703125 -1.609375 C 4.703125 -1.835938 4.585938 -2.019531 4.359375 -2.15625 C 4.128906 -2.300781 3.722656 -2.425781 3.140625 -2.53125 C 2.566406 -2.632812 2.109375 -2.757812 1.765625 -2.90625 C 1.429688 -3.0625 1.1875 -3.25 1.03125 -3.46875 C 0.875 -3.695312 0.796875 -3.976562 0.796875 -4.3125 C 0.796875 -4.644531 0.894531 -4.945312 1.09375 -5.21875 C 1.289062 -5.488281 1.566406 -5.707031 1.921875 -5.875 C 2.285156 -6.039062 2.703125 -6.125 3.171875 -6.125 C 3.804688 -6.125 4.316406 -6.003906 4.703125 -5.765625 C 5.097656 -5.535156 5.378906 -5.175781 5.546875 -4.6875 L 4.734375 -4.203125 C 4.597656 -4.585938 4.398438 -4.863281 4.140625 -5.03125 C 3.878906 -5.195312 3.554688 -5.28125 3.171875 -5.28125 C 2.773438 -5.28125 2.441406 -5.191406 2.171875 -5.015625 C 1.898438 -4.835938 1.765625 -4.632812 1.765625 -4.40625 C 1.765625 -4.144531 1.878906 -3.941406 2.109375 -3.796875 C 2.347656 -3.648438 2.773438 -3.523438 3.390625 -3.421875 C 4.222656 -3.285156 4.8125 -3.082031 5.15625 -2.8125 C 5.5 -2.539062 5.671875 -2.15625 5.671875 -1.65625 C 5.671875 -1.3125 5.566406 -1.003906 5.359375 -0.734375 C 5.148438 -0.460938 4.859375 -0.25 4.484375 -0.09375 C 4.109375 0.0507812 3.664062 0.125 3.15625 0.125 C 2.582031 0.125 2.0625 0.0078125 1.59375 -0.21875 C 1.132812 -0.445312 0.796875 -0.785156 0.578125 -1.234375 Z M 0.578125 -1.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 1.28125 C 1 1.175781 1.257812 1.007812 1.46875 0.78125 C 1.675781 0.5625 1.804688 0.320312 1.859375 0.0625 L 1.8125 0.03125 C 1.738281 0.09375 1.628906 0.125 1.484375 0.125 C 1.304688 0.125 1.148438 0.0546875 1.015625 -0.078125 C 0.878906 -0.210938 0.8125 -0.398438 0.8125 -0.640625 C 0.8125 -0.859375 0.882812 -1.046875 1.03125 -1.203125 C 1.1875 -1.359375 1.375 -1.4375 1.59375 -1.4375 C 1.875 -1.4375 2.09375 -1.328125 2.25 -1.109375 C 2.414062 -0.898438 2.5 -0.625 2.5 -0.28125 C 2.5 0.144531 2.390625 0.535156 2.171875 0.890625 C 1.953125 1.253906 1.625 1.539062 1.1875 1.75 Z M 0.6875 1.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.0625 -1.484375 L 1.0625 -8.765625 L 2.03125 -8.765625 L 2.03125 -1.609375 C 2.03125 -1.304688 2.070312 -1.09375 2.15625 -0.96875 C 2.25 -0.851562 2.421875 -0.796875 2.671875 -0.796875 C 2.847656 -0.796875 2.992188 -0.804688 3.109375 -0.828125 C 3.234375 -0.859375 3.378906 -0.90625 3.546875 -0.96875 L 3.40625 -0.046875 C 3.144531 0.0664062 2.859375 0.125 2.546875 0.125 C 2.535156 0.125 2.523438 0.125 2.515625 0.125 C 2.023438 0.125 1.660156 -0.00390625 1.421875 -0.265625 C 1.179688 -0.535156 1.0625 -0.941406 1.0625 -1.484375 Z M 1.0625 -1.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.75 -3 C 0.75 -3.976562 0.992188 -4.742188 1.484375 -5.296875 C 1.972656 -5.847656 2.671875 -6.125 3.578125 -6.125 C 4.128906 -6.125 4.609375 -6 5.015625 -5.75 C 5.429688 -5.5 5.742188 -5.160156 5.953125 -4.734375 C 6.160156 -4.316406 6.265625 -3.84375 6.265625 -3.3125 C 6.265625 -3.09375 6.25 -2.867188 6.21875 -2.640625 L 1.6875 -2.640625 C 1.75 -2.035156 1.953125 -1.5625 2.296875 -1.21875 C 2.640625 -0.882812 3.09375 -0.71875 3.65625 -0.71875 C 4.09375 -0.71875 4.457031 -0.789062 4.75 -0.9375 C 5.039062 -1.09375 5.238281 -1.316406 5.34375 -1.609375 L 6.140625 -1.1875 C 5.910156 -0.757812 5.59375 -0.429688 5.1875 -0.203125 C 4.78125 0.015625 4.269531 0.125 3.65625 0.125 C 2.75 0.125 2.035156 -0.148438 1.515625 -0.703125 C 1.003906 -1.253906 0.75 -2.019531 0.75 -3 Z M 1.703125 -3.5 L 5.34375 -3.5 C 5.28125 -4.050781 5.09375 -4.484375 4.78125 -4.796875 C 4.476562 -5.117188 4.078125 -5.28125 3.578125 -5.28125 C 3.046875 -5.28125 2.617188 -5.125 2.296875 -4.8125 C 1.972656 -4.5 1.773438 -4.0625 1.703125 -3.5 Z M 1.703125 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.640625 -5.6875 C 0.742188 -6.394531 1.03125 -6.960938 1.5 -7.390625 C 1.976562 -7.828125 2.613281 -8.046875 3.40625 -8.046875 C 3.925781 -8.046875 4.390625 -7.941406 4.796875 -7.734375 C 5.203125 -7.523438 5.507812 -7.226562 5.71875 -6.84375 C 5.9375 -6.46875 6.046875 -6.039062 6.046875 -5.5625 C 6.046875 -5.039062 5.921875 -4.546875 5.671875 -4.078125 C 5.429688 -3.609375 5.035156 -3.113281 4.484375 -2.59375 C 3.929688 -2.070312 3.1875 -1.5 2.25 -0.875 L 2.25 -0.859375 C 2.78125 -0.878906 3.179688 -0.894531 3.453125 -0.90625 L 6.21875 -0.90625 L 6.21875 0 L 0.890625 0 L 0.890625 -0.78125 C 1.984375 -1.59375 2.820312 -2.257812 3.40625 -2.78125 C 3.988281 -3.300781 4.40625 -3.773438 4.65625 -4.203125 C 4.914062 -4.628906 5.046875 -5.082031 5.046875 -5.5625 C 5.046875 -6.03125 4.890625 -6.410156 4.578125 -6.703125 C 4.273438 -6.992188 3.867188 -7.140625 3.359375 -7.140625 C 2.828125 -7.140625 2.394531 -6.960938 2.0625 -6.609375 C 1.726562 -6.253906 1.535156 -5.78125 1.484375 -5.1875 Z M 0.640625 -5.6875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.390625 -5.171875 L 0.390625 -6 L 1.578125 -6 L 1.578125 -7.015625 C 1.578125 -7.554688 1.742188 -7.988281 2.078125 -8.3125 C 2.421875 -8.644531 2.910156 -8.8125 3.546875 -8.8125 C 3.765625 -8.8125 3.960938 -8.785156 4.140625 -8.734375 C 4.328125 -8.691406 4.472656 -8.628906 4.578125 -8.546875 L 4.3125 -7.765625 C 4.125 -7.890625 3.898438 -7.953125 3.640625 -7.953125 C 2.910156 -7.953125 2.546875 -7.609375 2.546875 -6.921875 L 2.546875 -6 L 4.546875 -6 L 4.546875 -5.171875 L 2.546875 -5.171875 L 2.546875 0 L 1.578125 0 L 1.578125 -5.171875 Z M 0.390625 -5.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.75 -3 C 0.75 -3.976562 0.992188 -4.742188 1.484375 -5.296875 C 1.972656 -5.847656 2.671875 -6.125 3.578125 -6.125 C 4.128906 -6.125 4.609375 -6 5.015625 -5.75 C 5.429688 -5.5 5.742188 -5.160156 5.953125 -4.734375 C 6.160156 -4.316406 6.265625 -3.84375 6.265625 -3.3125 C 6.265625 -3.09375 6.25 -2.867188 6.21875 -2.640625 L 1.6875 -2.640625 C 1.75 -2.035156 1.953125 -1.5625 2.296875 -1.21875 C 2.640625 -0.882812 3.09375 -0.71875 3.65625 -0.71875 C 4.09375 -0.71875 4.457031 -0.789062 4.75 -0.9375 C 5.039062 -1.09375 5.238281 -1.316406 5.34375 -1.609375 L 6.140625 -1.1875 C 5.910156 -0.757812 5.59375 -0.429688 5.1875 -0.203125 C 4.78125 0.015625 4.269531 0.125 3.65625 0.125 C 2.75 0.125 2.035156 -0.148438 1.515625 -0.703125 C 1.003906 -1.253906 0.75 -2.019531 0.75 -3 Z M 1.703125 -3.5 L 5.34375 -3.5 C 5.28125 -4.050781 5.09375 -4.484375 4.78125 -4.796875 C 4.476562 -5.117188 4.078125 -5.28125 3.578125 -5.28125 C 3.046875 -5.28125 2.617188 -5.125 2.296875 -4.8125 C 1.972656 -4.5 1.773438 -4.0625 1.703125 -3.5 Z M 2.953125 -7 L 3.875 -9 L 4.90625 -9 L 3.734375 -7 Z M 2.953125 -7 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.140625 -6 L 1.234375 -6 L 3.140625 -0.96875 L 5.09375 -6 L 6.09375 -6 L 3.59375 0 L 2.640625 0 Z M 0.140625 -6 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.78125 -3.96875 C 0.78125 -5.289062 1.03125 -6.300781 1.53125 -7 C 2.039062 -7.695312 2.773438 -8.046875 3.734375 -8.046875 C 4.691406 -8.046875 5.421875 -7.695312 5.921875 -7 C 6.429688 -6.300781 6.6875 -5.289062 6.6875 -3.96875 C 6.6875 -2.632812 6.429688 -1.617188 5.921875 -0.921875 C 5.421875 -0.222656 4.691406 0.125 3.734375 0.125 C 2.773438 0.125 2.039062 -0.222656 1.53125 -0.921875 C 1.03125 -1.617188 0.78125 -2.632812 0.78125 -3.96875 Z M 1.78125 -3.96875 C 1.78125 -2.914062 1.945312 -2.113281 2.28125 -1.5625 C 2.613281 -1.019531 3.097656 -0.75 3.734375 -0.75 C 4.367188 -0.75 4.851562 -1.019531 5.1875 -1.5625 C 5.519531 -2.113281 5.6875 -2.914062 5.6875 -3.96875 C 5.6875 -5.007812 5.519531 -5.800781 5.1875 -6.34375 C 4.851562 -6.894531 4.367188 -7.171875 3.734375 -7.171875 C 3.097656 -7.171875 2.613281 -6.894531 2.28125 -6.34375 C 1.945312 -5.800781 1.78125 -5.007812 1.78125 -3.96875 Z M 1.78125 -3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.625 -1.78125 L 1.515625 -2.25 C 1.671875 -1.757812 1.890625 -1.390625 2.171875 -1.140625 C 2.460938 -0.898438 2.882812 -0.78125 3.4375 -0.78125 C 3.96875 -0.78125 4.382812 -0.910156 4.6875 -1.171875 C 5 -1.441406 5.15625 -1.789062 5.15625 -2.21875 C 5.15625 -2.707031 5.003906 -3.050781 4.703125 -3.25 C 4.410156 -3.445312 3.953125 -3.546875 3.328125 -3.546875 L 3.015625 -3.546875 L 3.015625 -4.4375 L 3.328125 -4.4375 C 4.421875 -4.4375 4.96875 -4.882812 4.96875 -5.78125 C 4.96875 -6.226562 4.84375 -6.566406 4.59375 -6.796875 C 4.34375 -7.023438 3.976562 -7.140625 3.5 -7.140625 C 3.039062 -7.140625 2.671875 -7.03125 2.390625 -6.8125 C 2.117188 -6.601562 1.929688 -6.3125 1.828125 -5.9375 L 0.921875 -6.34375 C 1.117188 -6.863281 1.445312 -7.273438 1.90625 -7.578125 C 2.363281 -7.890625 2.894531 -8.046875 3.5 -8.046875 C 4.007812 -8.046875 4.453125 -7.953125 4.828125 -7.765625 C 5.203125 -7.578125 5.484375 -7.328125 5.671875 -7.015625 C 5.867188 -6.703125 5.96875 -6.359375 5.96875 -5.984375 C 5.96875 -5.609375 5.898438 -5.269531 5.765625 -4.96875 C 5.628906 -4.675781 5.445312 -4.441406 5.21875 -4.265625 C 4.988281 -4.097656 4.742188 -4.015625 4.484375 -4.015625 L 4.484375 -4 C 4.984375 -4 5.382812 -3.816406 5.6875 -3.453125 C 5.988281 -3.085938 6.140625 -2.644531 6.140625 -2.125 C 6.140625 -1.695312 6.023438 -1.3125 5.796875 -0.96875 C 5.578125 -0.625 5.253906 -0.351562 4.828125 -0.15625 C 4.398438 0.03125 3.910156 0.125 3.359375 0.125 C 2.035156 0.125 1.125 -0.507812 0.625 -1.78125 Z M 0.625 -1.78125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 2.484375 -7.921875 L 5.78125 -2.640625 L 6.640625 -1.0625 L 6.65625 -1.0625 L 6.59375 -2.328125 L 6.59375 -7.921875 L 7.515625 -7.921875 L 7.515625 0 L 6.328125 0 L 3.015625 -5.296875 L 2.171875 -6.859375 L 2.15625 -6.859375 L 2.203125 -5.59375 L 2.203125 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.84375 -3.96875 C 0.84375 -4.820312 0.976562 -5.554688 1.25 -6.171875 C 1.519531 -6.785156 1.890625 -7.25 2.359375 -7.5625 C 2.828125 -7.882812 3.359375 -8.046875 3.953125 -8.046875 C 4.585938 -8.046875 5.101562 -7.910156 5.5 -7.640625 C 5.894531 -7.378906 6.21875 -6.957031 6.46875 -6.375 L 5.578125 -5.953125 C 5.316406 -6.742188 4.753906 -7.140625 3.890625 -7.140625 C 3.472656 -7.140625 3.101562 -6.988281 2.78125 -6.6875 C 2.457031 -6.394531 2.203125 -5.992188 2.015625 -5.484375 C 1.835938 -4.972656 1.75 -4.40625 1.75 -3.78125 L 1.75 -3.5625 L 1.796875 -3.5625 C 1.921875 -4.03125 2.191406 -4.390625 2.609375 -4.640625 C 3.035156 -4.890625 3.488281 -5.015625 3.96875 -5.015625 C 4.78125 -5.015625 5.425781 -4.78125 5.90625 -4.3125 C 6.394531 -3.851562 6.640625 -3.234375 6.640625 -2.453125 C 6.640625 -1.660156 6.390625 -1.03125 5.890625 -0.5625 C 5.398438 -0.101562 4.742188 0.125 3.921875 0.125 C 3.265625 0.125 2.707031 -0.046875 2.25 -0.390625 C 1.789062 -0.742188 1.441406 -1.226562 1.203125 -1.84375 C 0.960938 -2.457031 0.84375 -3.164062 0.84375 -3.96875 Z M 2.171875 -2.46875 C 2.171875 -1.96875 2.328125 -1.5625 2.640625 -1.25 C 2.960938 -0.945312 3.382812 -0.796875 3.90625 -0.796875 C 4.445312 -0.796875 4.867188 -0.941406 5.171875 -1.234375 C 5.472656 -1.535156 5.625 -1.945312 5.625 -2.46875 C 5.625 -2.96875 5.472656 -3.363281 5.171875 -3.65625 C 4.867188 -3.945312 4.445312 -4.09375 3.90625 -4.09375 C 3.394531 -4.09375 2.976562 -3.941406 2.65625 -3.640625 C 2.332031 -3.335938 2.171875 -2.945312 2.171875 -2.46875 Z M 2.171875 -2.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.328125 0.84375 L 4.015625 -8.765625 L 4.90625 -8.765625 L 1.234375 0.84375 Z M 0.328125 0.84375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.53125 -2.078125 L 0.53125 -2.78125 L 4.140625 -7.921875 L 5.34375 -7.921875 L 5.34375 -2.90625 L 6.75 -2.90625 L 6.75 -2.078125 L 5.34375 -2.078125 L 5.34375 0 L 4.390625 0 L 4.390625 -2.078125 Z M 1.546875 -2.90625 L 4.390625 -2.90625 L 4.390625 -5.859375 L 4.4375 -7.140625 L 4.421875 -7.140625 C 4.222656 -6.734375 3.957031 -6.289062 3.625 -5.8125 Z M 1.546875 -2.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.6875 -1.484375 C 0.6875 -1.941406 0.882812 -2.335938 1.28125 -2.671875 C 1.6875 -3.003906 2.269531 -3.234375 3.03125 -3.359375 L 4.625 -3.625 L 4.625 -3.96875 C 4.625 -4.363281 4.5 -4.679688 4.25 -4.921875 C 4 -5.160156 3.65625 -5.28125 3.21875 -5.28125 C 2.820312 -5.28125 2.472656 -5.179688 2.171875 -4.984375 C 1.878906 -4.796875 1.65625 -4.515625 1.5 -4.140625 L 0.796875 -4.65625 C 0.953125 -5.101562 1.25 -5.457031 1.6875 -5.71875 C 2.125 -5.988281 2.632812 -6.125 3.21875 -6.125 C 3.925781 -6.125 4.492188 -5.953125 4.921875 -5.609375 C 5.359375 -5.265625 5.578125 -4.753906 5.578125 -4.078125 L 5.578125 -1.125 C 5.578125 -0.988281 5.613281 -0.882812 5.6875 -0.8125 C 5.757812 -0.738281 5.875 -0.703125 6.03125 -0.703125 C 6.195312 -0.703125 6.359375 -0.71875 6.515625 -0.75 L 6.453125 0 C 6.234375 0.0820312 5.992188 0.125 5.734375 0.125 C 5.421875 0.125 5.175781 0.0546875 5 -0.078125 C 4.820312 -0.210938 4.707031 -0.441406 4.65625 -0.765625 C 4.476562 -0.484375 4.207031 -0.265625 3.84375 -0.109375 C 3.488281 0.046875 3.113281 0.125 2.71875 0.125 C 2.125 0.125 1.632812 -0.0078125 1.25 -0.28125 C 0.875 -0.5625 0.6875 -0.960938 0.6875 -1.484375 Z M 1.6875 -1.484375 C 1.6875 -1.242188 1.78125 -1.054688 1.96875 -0.921875 C 2.15625 -0.785156 2.421875 -0.71875 2.765625 -0.71875 C 3.273438 -0.71875 3.710938 -0.835938 4.078125 -1.078125 C 4.441406 -1.316406 4.625 -1.628906 4.625 -2.015625 L 4.625 -2.84375 L 3.28125 -2.59375 C 2.738281 -2.488281 2.335938 -2.347656 2.078125 -2.171875 C 1.816406 -1.992188 1.6875 -1.765625 1.6875 -1.484375 Z M 1.859375 -9 L 2.90625 -9 L 3.8125 -7 L 3.03125 -7 Z M 1.859375 -9 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 4.296875 -7.921875 C 5.109375 -7.921875 5.753906 -7.710938 6.234375 -7.296875 C 6.722656 -6.878906 6.96875 -6.316406 6.96875 -5.609375 C 6.96875 -5.046875 6.8125 -4.570312 6.5 -4.1875 C 6.1875 -3.800781 5.757812 -3.539062 5.21875 -3.40625 L 7.453125 0 L 6.3125 0 L 4.15625 -3.28125 L 2.25 -3.28125 L 2.25 0 Z M 2.25 -4.1875 L 4.28125 -4.1875 C 5.40625 -4.1875 5.96875 -4.660156 5.96875 -5.609375 C 5.96875 -6.546875 5.40625 -7.015625 4.28125 -7.015625 L 2.25 -7.015625 Z M 2.25 -4.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.8125 -3.96875 C 0.8125 -4.789062 0.960938 -5.507812 1.265625 -6.125 C 1.566406 -6.738281 1.992188 -7.210938 2.546875 -7.546875 C 3.097656 -7.878906 3.742188 -8.046875 4.484375 -8.046875 C 5.234375 -8.046875 5.882812 -7.878906 6.4375 -7.546875 C 6.988281 -7.210938 7.410156 -6.738281 7.703125 -6.125 C 8.003906 -5.507812 8.15625 -4.789062 8.15625 -3.96875 C 8.15625 -3.132812 8.003906 -2.410156 7.703125 -1.796875 C 7.410156 -1.179688 6.988281 -0.707031 6.4375 -0.375 C 5.882812 -0.0390625 5.234375 0.125 4.484375 0.125 C 3.742188 0.125 3.097656 -0.0390625 2.546875 -0.375 C 1.992188 -0.707031 1.566406 -1.179688 1.265625 -1.796875 C 0.960938 -2.410156 0.8125 -3.132812 0.8125 -3.96875 Z M 1.828125 -3.96875 C 1.828125 -2.96875 2.0625 -2.1875 2.53125 -1.625 C 3.007812 -1.0625 3.660156 -0.78125 4.484375 -0.78125 C 5.304688 -0.78125 5.957031 -1.0625 6.4375 -1.625 C 6.914062 -2.1875 7.15625 -2.96875 7.15625 -3.96875 C 7.15625 -4.957031 6.914062 -5.734375 6.4375 -6.296875 C 5.957031 -6.859375 5.304688 -7.140625 4.484375 -7.140625 C 3.660156 -7.140625 3.007812 -6.859375 2.53125 -6.296875 C 2.0625 -5.734375 1.828125 -4.957031 1.828125 -3.96875 Z M 1.828125 -3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 2.765625 -7.921875 L 4.515625 -3.109375 L 5.109375 -1.125 L 5.140625 -1.125 L 5.75 -3.09375 L 7.484375 -7.921875 L 8.953125 -7.921875 L 8.953125 0 L 8.046875 0 L 8.046875 -4.984375 L 8.15625 -7.0625 L 8.140625 -7.0625 L 5.53125 0 L 4.71875 0 L 2.109375 -7.0625 L 2.09375 -7.0625 L 2.203125 -4.984375 L 2.203125 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-24"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.3125 0 L 3.40625 -7.921875 L 4.53125 -7.921875 L 7.609375 0 L 6.59375 0 L 5.75 -2.203125 L 2.15625 -2.203125 L 1.3125 0 Z M 2.515625 -3.09375 L 5.40625 -3.09375 L 4.328125 -5.90625 L 3.96875 -7.015625 L 3.9375 -7.015625 L 3.59375 -5.9375 Z M 2.515625 -3.09375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-25"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.578125 -1.59375 L 1.40625 -2.265625 C 1.625 -1.796875 1.941406 -1.429688 2.359375 -1.171875 C 2.773438 -0.910156 3.300781 -0.78125 3.9375 -0.78125 C 4.5625 -0.78125 5.054688 -0.894531 5.421875 -1.125 C 5.796875 -1.351562 5.984375 -1.675781 5.984375 -2.09375 C 5.984375 -2.4375 5.820312 -2.710938 5.5 -2.921875 C 5.175781 -3.128906 4.609375 -3.304688 3.796875 -3.453125 C 2.734375 -3.640625 1.984375 -3.90625 1.546875 -4.25 C 1.109375 -4.59375 0.890625 -5.070312 0.890625 -5.6875 C 0.890625 -6.113281 1.007812 -6.503906 1.25 -6.859375 C 1.488281 -7.222656 1.832031 -7.507812 2.28125 -7.71875 C 2.726562 -7.9375 3.25 -8.046875 3.84375 -8.046875 C 5.257812 -8.046875 6.28125 -7.484375 6.90625 -6.359375 L 6.078125 -5.6875 C 5.835938 -6.21875 5.550781 -6.59375 5.21875 -6.8125 C 4.882812 -7.03125 4.425781 -7.140625 3.84375 -7.140625 C 3.238281 -7.140625 2.765625 -7.015625 2.421875 -6.765625 C 2.078125 -6.515625 1.90625 -6.191406 1.90625 -5.796875 C 1.90625 -5.535156 1.96875 -5.320312 2.09375 -5.15625 C 2.226562 -4.988281 2.453125 -4.84375 2.765625 -4.71875 C 3.085938 -4.59375 3.53125 -4.484375 4.09375 -4.390625 C 5.132812 -4.210938 5.875 -3.945312 6.3125 -3.59375 C 6.75 -3.25 6.96875 -2.765625 6.96875 -2.140625 C 6.96875 -1.691406 6.84375 -1.296875 6.59375 -0.953125 C 6.34375 -0.617188 5.984375 -0.351562 5.515625 -0.15625 C 5.054688 0.03125 4.523438 0.125 3.921875 0.125 C 3.117188 0.125 2.429688 -0.03125 1.859375 -0.34375 C 1.296875 -0.65625 0.867188 -1.070312 0.578125 -1.59375 Z M 0.578125 -1.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-26"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.078125 -2.640625 L 1.078125 -3.640625 L 5.046875 -3.640625 L 5.046875 -2.640625 Z M 1.078125 -2.640625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-27"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.21875 -2.953125 L 1.21875 -7.921875 L 2.171875 -7.921875 L 2.171875 -3.1875 C 2.171875 -2.363281 2.34375 -1.753906 2.6875 -1.359375 C 3.039062 -0.972656 3.582031 -0.78125 4.3125 -0.78125 C 5.050781 -0.78125 5.59375 -0.972656 5.9375 -1.359375 C 6.289062 -1.753906 6.46875 -2.363281 6.46875 -3.1875 L 6.46875 -7.921875 L 7.4375 -7.921875 L 7.4375 -2.953125 C 7.4375 -1.941406 7.164062 -1.175781 6.625 -0.65625 C 6.09375 -0.132812 5.320312 0.125 4.3125 0.125 C 3.3125 0.125 2.546875 -0.132812 2.015625 -0.65625 C 1.484375 -1.175781 1.21875 -1.941406 1.21875 -2.953125 Z M 1.21875 -2.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-28"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 2.25 -7.921875 L 2.25 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-29"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 6.84375 -7.921875 L 6.84375 -7.015625 L 2.25 -7.015625 L 2.25 -4.46875 L 5.828125 -4.46875 L 5.828125 -3.5625 L 2.25 -3.5625 L 2.25 -0.90625 L 7.03125 -0.90625 L 7.03125 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-30"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.734375 -3.375 C 0.734375 -4.5 0.945312 -5.535156 1.375 -6.484375 C 1.8125 -7.429688 2.453125 -8.273438 3.296875 -9.015625 L 3.84375 -8.46875 C 3.0625 -7.75 2.507812 -7 2.1875 -6.21875 C 1.875 -5.4375 1.71875 -4.488281 1.71875 -3.375 C 1.71875 -2.257812 1.875 -1.304688 2.1875 -0.515625 C 2.507812 0.265625 3.0625 1.007812 3.84375 1.71875 L 3.296875 2.265625 C 2.453125 1.535156 1.8125 0.695312 1.375 -0.25 C 0.945312 -1.207031 0.734375 -2.25 0.734375 -3.375 Z M 0.734375 -3.375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-31"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.34375 1.71875 C 1.132812 1.007812 1.6875 0.265625 2 -0.515625 C 2.320312 -1.304688 2.484375 -2.257812 2.484375 -3.375 C 2.484375 -4.488281 2.320312 -5.4375 2 -6.21875 C 1.6875 -7 1.132812 -7.75 0.34375 -8.46875 L 0.90625 -9.015625 C 1.75 -8.273438 2.382812 -7.429688 2.8125 -6.484375 C 3.25 -5.535156 3.46875 -4.5 3.46875 -3.375 C 3.46875 -2.238281 3.25 -1.195312 2.8125 -0.25 C 2.382812 0.695312 1.75 1.535156 0.90625 2.265625 Z M 0.34375 1.71875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.8125 -3.96875 C 0.8125 -4.789062 0.960938 -5.507812 1.265625 -6.125 C 1.566406 -6.738281 1.992188 -7.210938 2.546875 -7.546875 C 3.097656 -7.878906 3.738281 -8.046875 4.46875 -8.046875 C 5.226562 -8.046875 5.863281 -7.890625 6.375 -7.578125 C 6.894531 -7.265625 7.28125 -6.800781 7.53125 -6.1875 L 6.59375 -5.75 C 6.414062 -6.21875 6.15625 -6.566406 5.8125 -6.796875 C 5.476562 -7.023438 5.050781 -7.140625 4.53125 -7.140625 C 3.988281 -7.140625 3.515625 -7.015625 3.109375 -6.765625 C 2.703125 -6.515625 2.382812 -6.148438 2.15625 -5.671875 C 1.9375 -5.191406 1.828125 -4.625 1.828125 -3.96875 C 1.828125 -2.96875 2.0625 -2.1875 2.53125 -1.625 C 3.007812 -1.0625 3.660156 -0.78125 4.484375 -0.78125 C 5.023438 -0.78125 5.488281 -0.914062 5.875 -1.1875 C 6.269531 -1.457031 6.550781 -1.859375 6.71875 -2.390625 L 7.6875 -2.03125 C 7.4375 -1.351562 7.023438 -0.820312 6.453125 -0.4375 C 5.890625 -0.0625 5.234375 0.125 4.484375 0.125 C 3.742188 0.125 3.097656 -0.0390625 2.546875 -0.375 C 1.992188 -0.707031 1.566406 -1.179688 1.265625 -1.796875 C 0.960938 -2.410156 0.8125 -3.132812 0.8125 -3.96875 Z M 0.8125 -3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-33"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.390625 -7.015625 L 0.390625 -7.921875 L 6.859375 -7.921875 L 6.859375 -7.015625 L 4.109375 -7.015625 L 4.109375 0 L 3.140625 0 L 3.140625 -7.015625 Z M 0.390625 -7.015625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-34"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 2.25 -7.921875 L 2.25 -4.46875 L 6.546875 -4.46875 L 6.546875 -7.921875 L 7.515625 -7.921875 L 7.515625 0 L 6.546875 0 L 6.546875 -3.5625 L 2.25 -3.5625 L 2.25 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-35"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 2.25 -7.921875 L 2.25 -0.90625 L 6.796875 -0.90625 L 6.796875 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-36"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.8125 -3.96875 C 0.8125 -4.789062 0.960938 -5.507812 1.265625 -6.125 C 1.578125 -6.738281 2.007812 -7.210938 2.5625 -7.546875 C 3.125 -7.878906 3.773438 -8.046875 4.515625 -8.046875 C 5.296875 -8.046875 5.941406 -7.894531 6.453125 -7.59375 C 6.960938 -7.300781 7.375 -6.847656 7.6875 -6.234375 L 6.796875 -5.75 C 6.628906 -6.195312 6.34375 -6.539062 5.9375 -6.78125 C 5.539062 -7.019531 5.066406 -7.140625 4.515625 -7.140625 C 3.972656 -7.140625 3.5 -7.007812 3.09375 -6.75 C 2.695312 -6.5 2.382812 -6.132812 2.15625 -5.65625 C 1.9375 -5.1875 1.828125 -4.625 1.828125 -3.96875 C 1.828125 -2.957031 2.054688 -2.171875 2.515625 -1.609375 C 2.984375 -1.054688 3.65625 -0.78125 4.53125 -0.78125 C 5.21875 -0.78125 5.773438 -0.953125 6.203125 -1.296875 C 6.640625 -1.648438 6.859375 -2.15625 6.859375 -2.8125 L 6.859375 -3.09375 L 4.34375 -3.09375 L 4.34375 -4 L 7.734375 -4 L 7.734375 0 L 7.015625 0 L 6.984375 -1.0625 C 6.753906 -0.6875 6.425781 -0.394531 6 -0.1875 C 5.582031 0.0195312 5.078125 0.125 4.484375 0.125 C 3.742188 0.125 3.097656 -0.0390625 2.546875 -0.375 C 1.992188 -0.707031 1.566406 -1.179688 1.265625 -1.796875 C 0.960938 -2.410156 0.8125 -3.132812 0.8125 -3.96875 Z M 0.8125 -3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-37"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 3.84375 -7.921875 C 5.09375 -7.921875 6.066406 -7.578125 6.765625 -6.890625 C 7.472656 -6.203125 7.828125 -5.226562 7.828125 -3.96875 C 7.828125 -2.695312 7.472656 -1.71875 6.765625 -1.03125 C 6.066406 -0.34375 5.09375 0 3.84375 0 Z M 2.25 -0.90625 L 3.953125 -0.90625 C 4.847656 -0.90625 5.550781 -1.171875 6.0625 -1.703125 C 6.570312 -2.242188 6.828125 -3 6.828125 -3.96875 C 6.828125 -4.925781 6.570312 -5.671875 6.0625 -6.203125 C 5.550781 -6.742188 4.847656 -7.015625 3.953125 -7.015625 L 2.25 -7.015625 Z M 2.25 -0.90625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-38"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7.921875 L 4.109375 -7.921875 C 5.023438 -7.921875 5.703125 -7.726562 6.140625 -7.34375 C 6.585938 -6.96875 6.8125 -6.429688 6.8125 -5.734375 C 6.8125 -5.316406 6.691406 -4.945312 6.453125 -4.625 C 6.222656 -4.3125 5.898438 -4.113281 5.484375 -4.03125 L 5.484375 -4.015625 C 5.953125 -3.929688 6.320312 -3.722656 6.59375 -3.390625 C 6.875 -3.054688 7.015625 -2.664062 7.015625 -2.21875 C 7.015625 -1.539062 6.757812 -1 6.25 -0.59375 C 5.738281 -0.195312 5.023438 0 4.109375 0 Z M 2.25 -0.90625 L 4.328125 -0.90625 C 4.890625 -0.90625 5.3125 -1.015625 5.59375 -1.234375 C 5.875 -1.460938 6.015625 -1.789062 6.015625 -2.21875 C 6.015625 -2.644531 5.875 -2.972656 5.59375 -3.203125 C 5.3125 -3.429688 4.890625 -3.546875 4.328125 -3.546875 L 2.25 -3.546875 Z M 2.25 -4.4375 L 4.125 -4.4375 C 4.695312 -4.4375 5.117188 -4.539062 5.390625 -4.75 C 5.671875 -4.96875 5.8125 -5.296875 5.8125 -5.734375 C 5.8125 -6.585938 5.25 -7.015625 4.125 -7.015625 L 2.25 -7.015625 Z M 2.25 -4.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-39"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.109375 2.515625 L 1.109375 -6 L 1.953125 -6 L 2.015625 -4.953125 C 2.191406 -5.304688 2.460938 -5.585938 2.828125 -5.796875 C 3.191406 -6.015625 3.601562 -6.125 4.0625 -6.125 C 4.90625 -6.125 5.570312 -5.84375 6.0625 -5.28125 C 6.550781 -4.726562 6.796875 -3.96875 6.796875 -3 C 6.796875 -2.03125 6.550781 -1.265625 6.0625 -0.703125 C 5.570312 -0.148438 4.90625 0.125 4.0625 0.125 C 3.625 0.125 3.226562 0.03125 2.875 -0.15625 C 2.53125 -0.351562 2.265625 -0.613281 2.078125 -0.9375 L 2.078125 2.515625 Z M 2.078125 -2.9375 C 2.078125 -2.257812 2.242188 -1.71875 2.578125 -1.3125 C 2.921875 -0.914062 3.382812 -0.71875 3.96875 -0.71875 C 4.539062 -0.71875 4.992188 -0.921875 5.328125 -1.328125 C 5.671875 -1.742188 5.84375 -2.300781 5.84375 -3 C 5.84375 -3.695312 5.671875 -4.25 5.328125 -4.65625 C 4.992188 -5.070312 4.539062 -5.28125 3.96875 -5.28125 C 3.382812 -5.28125 2.921875 -5.078125 2.578125 -4.671875 C 2.242188 -4.273438 2.078125 -3.742188 2.078125 -3.078125 Z M 2.078125 -2.9375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-40"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.75 -3 C 0.75 -3.976562 1.003906 -4.742188 1.515625 -5.296875 C 2.035156 -5.847656 2.75 -6.125 3.65625 -6.125 C 4.25 -6.125 4.75 -5.984375 5.15625 -5.703125 C 5.570312 -5.429688 5.898438 -5.039062 6.140625 -4.53125 L 5.21875 -4.09375 C 4.957031 -4.882812 4.425781 -5.28125 3.625 -5.28125 C 3.019531 -5.28125 2.546875 -5.078125 2.203125 -4.671875 C 1.867188 -4.265625 1.703125 -3.707031 1.703125 -3 C 1.703125 -2.289062 1.867188 -1.734375 2.203125 -1.328125 C 2.546875 -0.921875 3.019531 -0.71875 3.625 -0.71875 C 4.082031 -0.71875 4.453125 -0.820312 4.734375 -1.03125 C 5.023438 -1.25 5.210938 -1.554688 5.296875 -1.953125 L 6.1875 -1.640625 C 5.988281 -1.085938 5.671875 -0.65625 5.234375 -0.34375 C 4.796875 -0.03125 4.269531 0.125 3.65625 0.125 C 2.75 0.125 2.035156 -0.148438 1.515625 -0.703125 C 1.003906 -1.253906 0.75 -2.019531 0.75 -3 Z M 0.75 -3 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-41"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.375 -5.171875 L 0.375 -6 L 1.578125 -6 L 1.578125 -7.4375 L 2.53125 -7.703125 L 2.53125 -6 L 4.75 -6 L 4.75 -5.171875 L 2.53125 -5.171875 L 2.53125 -1.65625 C 2.53125 -1.363281 2.613281 -1.144531 2.78125 -1 C 2.945312 -0.851562 3.164062 -0.78125 3.4375 -0.78125 C 3.820312 -0.78125 4.160156 -0.925781 4.453125 -1.21875 L 4.78125 -0.421875 C 4.382812 -0.0546875 3.867188 0.125 3.234375 0.125 C 2.753906 0.125 2.359375 -0.00390625 2.046875 -0.265625 C 1.734375 -0.535156 1.578125 -0.941406 1.578125 -1.484375 L 1.578125 -5.171875 Z M 0.375 -5.171875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-42"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.125 -7.921875 L 1.265625 -7.921875 L 3.4375 -4.078125 L 5.609375 -7.921875 L 6.75 -7.921875 L 3.921875 -3.09375 L 3.921875 0 L 2.953125 0 L 2.953125 -3.09375 Z M 0.125 -7.921875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-43"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.8125 -3.96875 C 0.8125 -4.789062 0.960938 -5.507812 1.265625 -6.125 C 1.566406 -6.738281 1.992188 -7.210938 2.546875 -7.546875 C 3.097656 -7.878906 3.742188 -8.046875 4.484375 -8.046875 C 5.234375 -8.046875 5.882812 -7.878906 6.4375 -7.546875 C 6.988281 -7.210938 7.410156 -6.738281 7.703125 -6.125 C 8.003906 -5.507812 8.15625 -4.789062 8.15625 -3.96875 C 8.15625 -3.1875 8.019531 -2.5 7.75 -1.90625 C 7.488281 -1.320312 7.113281 -0.851562 6.625 -0.5 C 6.144531 -0.15625 5.570312 0.0390625 4.90625 0.09375 C 4.945312 0.59375 5.097656 0.925781 5.359375 1.09375 C 5.628906 1.269531 5.988281 1.359375 6.4375 1.359375 C 6.726562 1.359375 7 1.316406 7.25 1.234375 C 7.5 1.160156 7.695312 1.054688 7.84375 0.921875 L 8.15625 1.8125 C 7.976562 1.96875 7.71875 2.09375 7.375 2.1875 C 7.039062 2.289062 6.71875 2.34375 6.40625 2.34375 C 5.75 2.34375 5.203125 2.164062 4.765625 1.8125 C 4.328125 1.46875 4.085938 0.894531 4.046875 0.09375 C 3.378906 0.03125 2.800781 -0.171875 2.3125 -0.515625 C 1.832031 -0.859375 1.460938 -1.320312 1.203125 -1.90625 C 0.941406 -2.5 0.8125 -3.1875 0.8125 -3.96875 Z M 1.828125 -3.96875 C 1.828125 -2.96875 2.0625 -2.1875 2.53125 -1.625 C 3.007812 -1.0625 3.660156 -0.78125 4.484375 -0.78125 C 5.304688 -0.78125 5.957031 -1.0625 6.4375 -1.625 C 6.914062 -2.1875 7.15625 -2.96875 7.15625 -3.96875 C 7.15625 -4.957031 6.914062 -5.734375 6.4375 -6.296875 C 5.957031 -6.859375 5.304688 -7.140625 4.484375 -7.140625 C 3.660156 -7.140625 3.007812 -6.859375 2.53125 -6.296875 C 2.0625 -5.734375 1.828125 -4.957031 1.828125 -3.96875 Z M 1.828125 -3.96875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-44"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.75 -3 C 0.75 -3.976562 1.003906 -4.742188 1.515625 -5.296875 C 2.035156 -5.847656 2.75 -6.125 3.65625 -6.125 C 4.550781 -6.125 5.253906 -5.847656 5.765625 -5.296875 C 6.285156 -4.742188 6.546875 -3.976562 6.546875 -3 C 6.546875 -2.019531 6.285156 -1.253906 5.765625 -0.703125 C 5.253906 -0.148438 4.550781 0.125 3.65625 0.125 C 2.75 0.125 2.035156 -0.148438 1.515625 -0.703125 C 1.003906 -1.253906 0.75 -2.019531 0.75 -3 Z M 1.703125 -3 C 1.703125 -2.289062 1.875 -1.726562 2.21875 -1.3125 C 2.5625 -0.90625 3.039062 -0.703125 3.65625 -0.703125 C 4.257812 -0.703125 4.734375 -0.90625 5.078125 -1.3125 C 5.421875 -1.726562 5.59375 -2.289062 5.59375 -3 C 5.59375 -3.707031 5.421875 -4.265625 5.078125 -4.671875 C 4.734375 -5.085938 4.257812 -5.296875 3.65625 -5.296875 C 3.039062 -5.296875 2.5625 -5.085938 2.21875 -4.671875 C 1.875 -4.265625 1.703125 -3.707031 1.703125 -3 Z M 1.703125 -3 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-45"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.109375 0 L 1.109375 -6 L 1.953125 -6 L 2.015625 -5.0625 C 2.210938 -5.425781 2.488281 -5.691406 2.84375 -5.859375 C 3.195312 -6.035156 3.59375 -6.125 4.03125 -6.125 C 4.707031 -6.125 5.265625 -5.925781 5.703125 -5.53125 C 6.148438 -5.144531 6.375 -4.582031 6.375 -3.84375 L 6.375 0 L 5.421875 0 L 5.421875 -3.5 C 5.421875 -4.125 5.285156 -4.578125 5.015625 -4.859375 C 4.742188 -5.140625 4.382812 -5.28125 3.9375 -5.28125 C 3.613281 -5.28125 3.3125 -5.207031 3.03125 -5.0625 C 2.75 -4.925781 2.519531 -4.703125 2.34375 -4.390625 C 2.164062 -4.078125 2.078125 -3.675781 2.078125 -3.1875 L 2.078125 0 Z M 1.109375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.53125 0 L 0.53125 -10.671875 L 4.78125 -10.671875 L 4.78125 0 Z M 1.0625 -0.53125 L 4.25 -0.53125 L 4.25 -10.140625 L 1.0625 -10.140625 Z M 1.0625 -0.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.421875 0 L 4.53125 -10.5625 L 6.046875 -10.5625 L 10.140625 0 L 8.78125 0 L 7.671875 -2.9375 L 2.890625 -2.9375 L 1.765625 0 Z M 3.34375 -4.125 L 7.203125 -4.125 L 5.78125 -7.875 L 5.28125 -9.34375 L 5.25 -9.34375 L 4.78125 -7.921875 Z M 3.34375 -4.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.515625 -9.359375 L 0.515625 -10.5625 L 9.15625 -10.5625 L 9.15625 -9.359375 L 5.46875 -9.359375 L 5.46875 0 L 4.203125 0 L 4.203125 -9.359375 Z M 0.515625 -9.359375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 9.140625 -10.5625 L 9.140625 -9.359375 L 3.015625 -9.359375 L 3.015625 -5.953125 L 7.78125 -5.953125 L 7.78125 -4.75 L 3.015625 -4.75 L 3.015625 -1.203125 L 9.375 -1.203125 L 9.375 0 Z M 1.734375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.765625 -2.125 L 1.875 -3.03125 C 2.164062 -2.394531 2.585938 -1.90625 3.140625 -1.5625 C 3.703125 -1.21875 4.40625 -1.046875 5.25 -1.046875 C 6.082031 -1.046875 6.742188 -1.195312 7.234375 -1.5 C 7.722656 -1.800781 7.96875 -2.226562 7.96875 -2.78125 C 7.96875 -3.25 7.753906 -3.625 7.328125 -3.90625 C 6.898438 -4.1875 6.144531 -4.421875 5.0625 -4.609375 C 3.65625 -4.859375 2.65625 -5.210938 2.0625 -5.671875 C 1.476562 -6.128906 1.1875 -6.769531 1.1875 -7.59375 C 1.1875 -8.15625 1.34375 -8.675781 1.65625 -9.15625 C 1.976562 -9.632812 2.4375 -10.015625 3.03125 -10.296875 C 3.632812 -10.578125 4.332031 -10.71875 5.125 -10.71875 C 7.007812 -10.71875 8.367188 -9.972656 9.203125 -8.484375 L 8.09375 -7.59375 C 7.78125 -8.289062 7.398438 -8.785156 6.953125 -9.078125 C 6.515625 -9.378906 5.910156 -9.53125 5.140625 -9.53125 C 4.328125 -9.53125 3.6875 -9.359375 3.21875 -9.015625 C 2.757812 -8.679688 2.53125 -8.253906 2.53125 -7.734375 C 2.53125 -7.390625 2.617188 -7.101562 2.796875 -6.875 C 2.984375 -6.65625 3.285156 -6.460938 3.703125 -6.296875 C 4.128906 -6.128906 4.710938 -5.984375 5.453125 -5.859375 C 6.847656 -5.628906 7.835938 -5.273438 8.421875 -4.796875 C 9.003906 -4.328125 9.296875 -3.679688 9.296875 -2.859375 C 9.296875 -2.253906 9.128906 -1.722656 8.796875 -1.265625 C 8.460938 -0.816406 7.984375 -0.46875 7.359375 -0.21875 C 6.742188 0.03125 6.03125 0.15625 5.21875 0.15625 C 4.15625 0.15625 3.242188 -0.0507812 2.484375 -0.46875 C 1.734375 -0.882812 1.160156 -1.4375 0.765625 -2.125 Z M 0.765625 -2.125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 3.015625 -10.5625 L 3.015625 0 Z M 1.734375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 -5.28125 C 1.09375 -6.394531 1.289062 -7.359375 1.6875 -8.171875 C 2.09375 -8.984375 2.660156 -9.609375 3.390625 -10.046875 C 4.128906 -10.492188 4.992188 -10.71875 5.984375 -10.71875 C 6.972656 -10.71875 7.835938 -10.492188 8.578125 -10.046875 C 9.316406 -9.609375 9.882812 -8.984375 10.28125 -8.171875 C 10.6875 -7.359375 10.890625 -6.394531 10.890625 -5.28125 C 10.890625 -4.175781 10.6875 -3.210938 10.28125 -2.390625 C 9.882812 -1.578125 9.316406 -0.945312 8.578125 -0.5 C 7.835938 -0.0625 6.972656 0.15625 5.984375 0.15625 C 4.992188 0.15625 4.128906 -0.0625 3.390625 -0.5 C 2.660156 -0.945312 2.09375 -1.578125 1.6875 -2.390625 C 1.289062 -3.210938 1.09375 -4.175781 1.09375 -5.28125 Z M 2.4375 -5.28125 C 2.4375 -3.957031 2.753906 -2.921875 3.390625 -2.171875 C 4.023438 -1.421875 4.890625 -1.046875 5.984375 -1.046875 C 7.085938 -1.046875 7.957031 -1.421875 8.59375 -2.171875 C 9.226562 -2.921875 9.546875 -3.957031 9.546875 -5.28125 C 9.546875 -6.601562 9.226562 -7.640625 8.59375 -8.390625 C 7.957031 -9.148438 7.085938 -9.53125 5.984375 -9.53125 C 4.890625 -9.53125 4.023438 -9.148438 3.390625 -8.390625 C 2.753906 -7.640625 2.4375 -6.601562 2.4375 -5.28125 Z M 2.4375 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 3.3125 -10.5625 L 7.71875 -3.53125 L 8.859375 -1.40625 L 8.875 -1.40625 L 8.796875 -3.109375 L 8.796875 -10.5625 L 10.015625 -10.5625 L 10.015625 0 L 8.4375 0 L 4.015625 -7.078125 L 2.90625 -9.15625 L 2.890625 -9.15625 L 2.953125 -7.453125 L 2.953125 0 Z M 1.734375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 5.140625 -10.5625 C 6.804688 -10.5625 8.109375 -10.101562 9.046875 -9.1875 C 9.984375 -8.269531 10.453125 -6.96875 10.453125 -5.28125 C 10.453125 -3.59375 9.984375 -2.289062 9.046875 -1.375 C 8.109375 -0.457031 6.804688 0 5.140625 0 Z M 3.015625 -1.203125 L 5.265625 -1.203125 C 6.472656 -1.203125 7.414062 -1.5625 8.09375 -2.28125 C 8.769531 -3 9.109375 -4 9.109375 -5.28125 C 9.109375 -6.5625 8.769531 -7.5625 8.09375 -8.28125 C 7.414062 -9 6.472656 -9.359375 5.265625 -9.359375 L 3.015625 -9.359375 Z M 3.015625 -1.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 5.734375 -10.5625 C 6.804688 -10.5625 7.664062 -10.285156 8.3125 -9.734375 C 8.96875 -9.179688 9.296875 -8.425781 9.296875 -7.46875 C 9.296875 -6.726562 9.085938 -6.097656 8.671875 -5.578125 C 8.253906 -5.066406 7.6875 -4.71875 6.96875 -4.53125 L 9.9375 0 L 8.421875 0 L 5.546875 -4.390625 L 3.015625 -4.390625 L 3.015625 0 Z M 3.015625 -5.59375 L 5.71875 -5.59375 C 7.207031 -5.59375 7.953125 -6.21875 7.953125 -7.46875 C 7.953125 -8.726562 7.207031 -9.359375 5.71875 -9.359375 L 3.015625 -9.359375 Z M 3.015625 -5.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.734375 0 L 1.734375 -10.5625 L 9.140625 -10.5625 L 9.140625 -9.359375 L 3.015625 -9.359375 L 3.015625 -5.953125 L 7.78125 -5.953125 L 7.78125 -4.75 L 3.015625 -4.75 L 3.015625 -1.203125 L 9.375 -1.203125 L 9.375 0 Z M 4.75 -11.890625 L 5.671875 -14.265625 L 7.171875 -14.265625 L 5.796875 -11.890625 Z M 4.75 -11.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.625 -3.9375 L 1.625 -10.5625 L 2.90625 -10.5625 L 2.90625 -4.265625 C 2.90625 -3.148438 3.132812 -2.332031 3.59375 -1.8125 C 4.0625 -1.300781 4.785156 -1.046875 5.765625 -1.046875 C 6.742188 -1.046875 7.460938 -1.300781 7.921875 -1.8125 C 8.390625 -2.332031 8.625 -3.148438 8.625 -4.265625 L 8.625 -10.5625 L 9.90625 -10.5625 L 9.90625 -3.9375 C 9.90625 -2.582031 9.550781 -1.5625 8.84375 -0.875 C 8.132812 -0.1875 7.109375 0.15625 5.765625 0.15625 C 4.421875 0.15625 3.394531 -0.1875 2.6875 -0.875 C 1.976562 -1.570312 1.625 -2.59375 1.625 -3.9375 Z M 1.625 -3.9375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.53125 0 L 0.53125 -10.671875 L 4.78125 -10.671875 L 4.78125 0 Z M 1.0625 -0.53125 L 4.25 -0.53125 L 4.25 -10.140625 L 1.0625 -10.140625 Z M 1.0625 -0.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 6.3125 -10.5625 C 8.84375 -10.550781 10.109375 -9.601562 10.109375 -7.71875 C 10.109375 -7.09375 9.925781 -6.566406 9.5625 -6.140625 C 9.207031 -5.722656 8.675781 -5.457031 7.96875 -5.34375 L 7.96875 -5.328125 C 8.757812 -5.222656 9.359375 -4.945312 9.765625 -4.5 C 10.179688 -4.0625 10.390625 -3.515625 10.390625 -2.859375 C 10.390625 -1.941406 10.0625 -1.234375 9.40625 -0.734375 C 8.757812 -0.242188 7.804688 0 6.546875 0 Z M 3.828125 -1.9375 L 6.078125 -1.9375 C 6.566406 -1.9375 6.9375 -2.035156 7.1875 -2.234375 C 7.445312 -2.441406 7.578125 -2.738281 7.578125 -3.125 C 7.578125 -3.5 7.445312 -3.785156 7.1875 -3.984375 C 6.9375 -4.179688 6.566406 -4.28125 6.078125 -4.28125 L 3.828125 -4.28125 Z M 3.828125 -6.25 L 5.8125 -6.25 C 6.800781 -6.25 7.296875 -6.628906 7.296875 -7.390625 C 7.296875 -8.160156 6.800781 -8.546875 5.8125 -8.546875 L 3.828125 -8.546875 Z M 3.828125 -6.25 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.0625 0 L 3.78125 -10.5625 L 7.078125 -10.5625 L 10.765625 0 L 7.9375 0 L 7.21875 -2.390625 L 3.578125 -2.390625 L 2.828125 0 Z M 4.140625 -4.265625 L 6.640625 -4.265625 L 5.875 -6.78125 L 5.40625 -8.453125 L 5.375 -8.453125 L 4.953125 -6.796875 Z M 4.140625 -4.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.71875 -5.28125 C 0.71875 -6.40625 0.925781 -7.375 1.34375 -8.1875 C 1.757812 -9.007812 2.359375 -9.632812 3.140625 -10.0625 C 3.921875 -10.5 4.835938 -10.71875 5.890625 -10.71875 C 7.046875 -10.71875 8.019531 -10.472656 8.8125 -9.984375 C 9.613281 -9.503906 10.144531 -8.78125 10.40625 -7.8125 L 7.984375 -6.828125 C 7.835938 -7.472656 7.609375 -7.921875 7.296875 -8.171875 C 6.984375 -8.429688 6.546875 -8.5625 5.984375 -8.5625 C 5.203125 -8.5625 4.597656 -8.28125 4.171875 -7.71875 C 3.753906 -7.164062 3.546875 -6.351562 3.546875 -5.28125 C 3.546875 -4.21875 3.75 -3.40625 4.15625 -2.84375 C 4.5625 -2.28125 5.15625 -2 5.9375 -2 C 6.53125 -2 6.992188 -2.132812 7.328125 -2.40625 C 7.671875 -2.6875 7.90625 -3.128906 8.03125 -3.734375 L 10.53125 -3.03125 C 10.226562 -1.957031 9.671875 -1.15625 8.859375 -0.625 C 8.054688 -0.101562 7.070312 0.15625 5.90625 0.15625 C 4.84375 0.15625 3.921875 -0.0546875 3.140625 -0.484375 C 2.359375 -0.921875 1.757812 -1.546875 1.34375 -2.359375 C 0.925781 -3.179688 0.71875 -4.15625 0.71875 -5.28125 Z M 0.71875 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 3.921875 -10.5625 L 3.921875 -2.125 L 9.21875 -2.125 L 9.21875 0 Z M 1.171875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.984375 -4.3125 L 0.984375 -10.5625 L 3.75 -10.5625 L 3.75 -4.265625 C 3.75 -3.503906 3.90625 -2.9375 4.21875 -2.5625 C 4.539062 -2.1875 5.035156 -2 5.703125 -2 C 7.023438 -2 7.6875 -2.753906 7.6875 -4.265625 L 7.6875 -10.5625 L 10.421875 -10.5625 L 10.421875 -4.3125 C 10.421875 -2.820312 10.023438 -1.703125 9.234375 -0.953125 C 8.441406 -0.210938 7.265625 0.15625 5.703125 0.15625 C 4.140625 0.15625 2.960938 -0.210938 2.171875 -0.953125 C 1.378906 -1.703125 0.984375 -2.820312 0.984375 -4.3125 Z M 0.984375 -4.3125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 6.21875 -10.5625 C 7.5 -10.5625 8.484375 -10.269531 9.171875 -9.6875 C 9.859375 -9.113281 10.203125 -8.285156 10.203125 -7.203125 C 10.203125 -6.441406 10.023438 -5.800781 9.671875 -5.28125 C 9.316406 -4.769531 8.800781 -4.390625 8.125 -4.140625 L 10.8125 0 L 7.78125 0 L 5.53125 -3.859375 L 3.875 -3.859375 L 3.875 0 Z M 3.875 -5.8125 L 5.75 -5.8125 C 6.332031 -5.8125 6.753906 -5.914062 7.015625 -6.125 C 7.285156 -6.34375 7.421875 -6.6875 7.421875 -7.15625 C 7.421875 -7.613281 7.285156 -7.945312 7.015625 -8.15625 C 6.753906 -8.375 6.332031 -8.484375 5.75 -8.484375 L 3.875 -8.484375 Z M 3.875 -5.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 9.390625 -10.5625 L 9.390625 -8.4375 L 3.921875 -8.4375 L 3.921875 -6.296875 L 8.28125 -6.296875 L 8.28125 -4.296875 L 3.921875 -4.296875 L 3.921875 -2.125 L 9.609375 -2.125 L 9.609375 0 Z M 1.171875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.40625 -8.4375 L 0.40625 -10.5625 L 10.046875 -10.5625 L 10.046875 -8.4375 L 6.609375 -8.4375 L 6.609375 0 L 3.859375 0 L 3.859375 -8.4375 Z M 0.40625 -8.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 3.921875 -10.5625 L 3.921875 -6.390625 L 7.953125 -6.390625 L 7.953125 -10.5625 L 10.703125 -10.5625 L 10.703125 0 L 7.953125 0 L 7.953125 -4.265625 L 3.921875 -4.265625 L 3.921875 0 Z M 1.171875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 4.234375 -10.5625 L 7.515625 -4.859375 L 8.3125 -3.25 L 8.328125 -3.25 L 8.265625 -5.234375 L 8.265625 -10.5625 L 10.6875 -10.5625 L 10.6875 0 L 7.640625 0 L 4.359375 -5.71875 L 3.5625 -7.3125 L 3.546875 -7.3125 L 3.609375 -5.328125 L 3.609375 0 Z M 1.171875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.71875 -5.28125 C 0.71875 -6.414062 0.925781 -7.390625 1.34375 -8.203125 C 1.757812 -9.015625 2.359375 -9.632812 3.140625 -10.0625 C 3.921875 -10.5 4.84375 -10.71875 5.90625 -10.71875 C 6.976562 -10.71875 7.898438 -10.5 8.671875 -10.0625 C 9.441406 -9.632812 10.035156 -9.015625 10.453125 -8.203125 C 10.867188 -7.390625 11.078125 -6.414062 11.078125 -5.28125 C 11.078125 -4.15625 10.867188 -3.179688 10.453125 -2.359375 C 10.035156 -1.546875 9.441406 -0.921875 8.671875 -0.484375 C 7.898438 -0.0546875 6.976562 0.15625 5.90625 0.15625 C 4.84375 0.15625 3.921875 -0.0546875 3.140625 -0.484375 C 2.359375 -0.921875 1.757812 -1.546875 1.34375 -2.359375 C 0.925781 -3.179688 0.71875 -4.15625 0.71875 -5.28125 Z M 3.546875 -5.28125 C 3.546875 -4.207031 3.742188 -3.390625 4.140625 -2.828125 C 4.546875 -2.273438 5.132812 -2 5.90625 -2 C 6.675781 -2 7.257812 -2.273438 7.65625 -2.828125 C 8.0625 -3.390625 8.265625 -4.207031 8.265625 -5.28125 C 8.265625 -6.363281 8.0625 -7.179688 7.65625 -7.734375 C 7.257812 -8.285156 6.675781 -8.5625 5.90625 -8.5625 C 5.132812 -8.5625 4.546875 -8.285156 4.140625 -7.734375 C 3.742188 -7.179688 3.546875 -6.363281 3.546875 -5.28125 Z M 3.546875 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.703125 -5.265625 C 0.703125 -6.398438 0.914062 -7.375 1.34375 -8.1875 C 1.769531 -9 2.378906 -9.625 3.171875 -10.0625 C 3.960938 -10.5 4.894531 -10.71875 5.96875 -10.71875 C 7.175781 -10.71875 8.144531 -10.503906 8.875 -10.078125 C 9.613281 -9.648438 10.195312 -8.960938 10.625 -8.015625 L 8.078125 -7.015625 C 7.953125 -7.535156 7.710938 -7.921875 7.359375 -8.171875 C 7.003906 -8.429688 6.566406 -8.5625 6.046875 -8.5625 C 5.234375 -8.5625 4.613281 -8.285156 4.1875 -7.734375 C 3.757812 -7.179688 3.546875 -6.363281 3.546875 -5.28125 C 3.546875 -3.0625 4.40625 -1.953125 6.125 -1.953125 C 6.78125 -1.953125 7.304688 -2.101562 7.703125 -2.40625 C 8.109375 -2.707031 8.3125 -3.140625 8.3125 -3.703125 L 8.3125 -3.859375 L 5.6875 -3.859375 L 5.6875 -5.71875 L 10.640625 -5.71875 L 10.640625 0 L 8.71875 0 L 8.640625 -1.25 C 8.035156 -0.3125 7.03125 0.15625 5.625 0.15625 C 4.664062 0.15625 3.8125 -0.0507812 3.0625 -0.46875 C 2.320312 -0.894531 1.742188 -1.515625 1.328125 -2.328125 C 0.910156 -3.148438 0.703125 -4.128906 0.703125 -5.265625 Z M 0.703125 -5.265625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.171875 0 L 1.171875 -10.5625 L 3.921875 -10.5625 L 3.921875 0 Z M 1.171875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.71875 -5.28125 C 0.71875 -6.414062 0.925781 -7.390625 1.34375 -8.203125 C 1.757812 -9.015625 2.359375 -9.632812 3.140625 -10.0625 C 3.921875 -10.5 4.84375 -10.71875 5.90625 -10.71875 C 6.976562 -10.71875 7.898438 -10.5 8.671875 -10.0625 C 9.441406 -9.632812 10.035156 -9.015625 10.453125 -8.203125 C 10.867188 -7.390625 11.078125 -6.414062 11.078125 -5.28125 C 11.078125 -3.738281 10.691406 -2.492188 9.921875 -1.546875 C 9.160156 -0.609375 8.101562 -0.0546875 6.75 0.109375 C 6.789062 0.484375 6.945312 0.742188 7.21875 0.890625 C 7.5 1.046875 7.882812 1.125 8.375 1.125 C 9.238281 1.125 9.894531 0.914062 10.34375 0.5 L 11 2.5 C 10.71875 2.738281 10.34375 2.925781 9.875 3.0625 C 9.40625 3.195312 8.875 3.265625 8.28125 3.265625 C 7.21875 3.265625 6.398438 3.007812 5.828125 2.5 C 5.253906 2 4.96875 1.304688 4.96875 0.421875 L 4.984375 0.09375 C 3.648438 -0.09375 2.601562 -0.65625 1.84375 -1.59375 C 1.09375 -2.53125 0.71875 -3.757812 0.71875 -5.28125 Z M 3.546875 -5.28125 C 3.546875 -4.207031 3.742188 -3.390625 4.140625 -2.828125 C 4.546875 -2.273438 5.132812 -2 5.90625 -2 C 6.675781 -2 7.257812 -2.273438 7.65625 -2.828125 C 8.0625 -3.390625 8.265625 -4.207031 8.265625 -5.28125 C 8.265625 -6.363281 8.0625 -7.179688 7.65625 -7.734375 C 7.257812 -8.285156 6.675781 -8.5625 5.90625 -8.5625 C 5.144531 -8.5625 4.5625 -8.285156 4.15625 -7.734375 C 3.75 -7.179688 3.546875 -6.363281 3.546875 -5.28125 Z M 3.546875 -5.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.5 0 L 0.5 -10 L 4.484375 -10 L 4.484375 0 Z M 1 -0.5 L 3.984375 -0.5 L 3.984375 -9.5 L 1 -9.5 Z M 1 -0.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 4.765625 -9.90625 L 6.328125 -4.859375 L 6.890625 -2.765625 L 6.921875 -2.765625 L 7.484375 -4.84375 L 9.03125 -9.90625 L 12.546875 -9.90625 L 12.546875 0 L 10.28125 0 L 10.28125 -4.546875 L 10.34375 -7.59375 L 10.3125 -7.59375 L 7.875 0 L 5.796875 0 L 3.34375 -7.59375 L 3.3125 -7.59375 L 3.390625 -4.546875 L 3.390625 0 Z M 1.09375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -1.21875 C 0.671875 -1.644531 0.800781 -1.976562 1.0625 -2.21875 C 1.332031 -2.457031 1.703125 -2.578125 2.171875 -2.578125 C 2.640625 -2.578125 3.003906 -2.457031 3.265625 -2.21875 C 3.535156 -1.976562 3.671875 -1.644531 3.671875 -1.21875 C 3.671875 -0.800781 3.535156 -0.472656 3.265625 -0.234375 C 3.003906 0.00390625 2.640625 0.125 2.171875 0.125 C 1.703125 0.125 1.332031 0.00390625 1.0625 -0.234375 C 0.800781 -0.472656 0.671875 -0.800781 0.671875 -1.21875 Z M 0.671875 -1.21875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.453125 -2.984375 C 0.453125 -3.273438 0.484375 -3.585938 0.546875 -3.921875 L 3.09375 -4.359375 C 3.039062 -3.984375 3.015625 -3.675781 3.015625 -3.4375 C 3.015625 -2.882812 3.117188 -2.484375 3.328125 -2.234375 C 3.546875 -1.992188 3.882812 -1.875 4.34375 -1.875 C 4.875 -1.875 5.25 -2.046875 5.46875 -2.390625 C 5.695312 -2.742188 5.8125 -3.304688 5.8125 -4.078125 L 5.8125 -9.90625 L 8.390625 -9.90625 L 8.390625 -3.8125 C 8.390625 -2.5625 8.023438 -1.585938 7.296875 -0.890625 C 6.578125 -0.203125 5.550781 0.140625 4.21875 0.140625 C 2.96875 0.140625 2.023438 -0.132812 1.390625 -0.6875 C 0.765625 -1.25 0.453125 -2.015625 0.453125 -2.984375 Z M 0.453125 -2.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 8.796875 -9.90625 L 8.796875 -7.90625 L 3.671875 -7.90625 L 3.671875 -5.890625 L 7.75 -5.890625 L 7.75 -4.015625 L 3.671875 -4.015625 L 3.671875 -2 L 9 -2 L 9 0 Z M 1.09375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 3.96875 -9.90625 L 7.03125 -4.546875 L 7.78125 -3.046875 L 7.796875 -3.046875 L 7.734375 -4.90625 L 7.734375 -9.90625 L 10.015625 -9.90625 L 10.015625 0 L 7.15625 0 L 4.078125 -5.359375 L 3.328125 -6.859375 L 3.3125 -6.859375 L 3.375 -5 L 3.375 0 Z M 1.09375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.65625 -4.9375 C 0.65625 -6 0.851562 -6.910156 1.25 -7.671875 C 1.65625 -8.429688 2.226562 -9.015625 2.96875 -9.421875 C 3.707031 -9.835938 4.582031 -10.046875 5.59375 -10.046875 C 6.71875 -10.046875 7.625 -9.84375 8.3125 -9.4375 C 9.007812 -9.039062 9.5625 -8.398438 9.96875 -7.515625 L 7.578125 -6.5625 C 7.453125 -7.050781 7.222656 -7.414062 6.890625 -7.65625 C 6.566406 -7.90625 6.160156 -8.03125 5.671875 -8.03125 C 4.910156 -8.03125 4.328125 -7.769531 3.921875 -7.25 C 3.515625 -6.726562 3.3125 -5.960938 3.3125 -4.953125 C 3.3125 -2.867188 4.125 -1.828125 5.75 -1.828125 C 6.351562 -1.828125 6.84375 -1.96875 7.21875 -2.25 C 7.59375 -2.53125 7.78125 -2.9375 7.78125 -3.46875 L 7.78125 -3.625 L 5.328125 -3.625 L 5.328125 -5.359375 L 9.96875 -5.359375 L 9.96875 0 L 8.171875 0 L 8.09375 -1.171875 C 7.53125 -0.296875 6.585938 0.140625 5.265625 0.140625 C 4.367188 0.140625 3.570312 -0.0507812 2.875 -0.4375 C 2.175781 -0.832031 1.628906 -1.410156 1.234375 -2.171875 C 0.847656 -2.941406 0.65625 -3.863281 0.65625 -4.9375 Z M 0.65625 -4.9375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 5.828125 -9.90625 C 7.023438 -9.90625 7.945312 -9.632812 8.59375 -9.09375 C 9.238281 -8.550781 9.5625 -7.769531 9.5625 -6.75 C 9.5625 -6.03125 9.394531 -5.429688 9.0625 -4.953125 C 8.726562 -4.472656 8.25 -4.113281 7.625 -3.875 L 10.140625 0 L 7.28125 0 L 5.171875 -3.625 L 3.640625 -3.625 L 3.640625 0 Z M 3.640625 -5.4375 L 5.390625 -5.4375 C 5.941406 -5.4375 6.335938 -5.535156 6.578125 -5.734375 C 6.828125 -5.941406 6.953125 -6.265625 6.953125 -6.703125 C 6.953125 -7.128906 6.828125 -7.441406 6.578125 -7.640625 C 6.335938 -7.847656 5.941406 -7.953125 5.390625 -7.953125 L 3.640625 -7.953125 Z M 3.640625 -5.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 5.296875 -9.90625 C 6.847656 -9.90625 8.035156 -9.472656 8.859375 -8.609375 C 9.679688 -7.753906 10.09375 -6.535156 10.09375 -4.953125 C 10.09375 -3.359375 9.679688 -2.132812 8.859375 -1.28125 C 8.035156 -0.425781 6.847656 0 5.296875 0 Z M 3.671875 -1.953125 L 5.046875 -1.953125 C 5.867188 -1.953125 6.472656 -2.203125 6.859375 -2.703125 C 7.253906 -3.203125 7.453125 -3.953125 7.453125 -4.953125 C 7.453125 -5.953125 7.253906 -6.703125 6.859375 -7.203125 C 6.472656 -7.703125 5.867188 -7.953125 5.046875 -7.953125 L 3.671875 -7.953125 Z M 3.671875 -1.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.0625 0 L 3.53125 -9.90625 L 6.625 -9.90625 L 10.09375 0 L 7.4375 0 L 6.765625 -2.234375 L 3.34375 -2.234375 L 2.65625 0 Z M 3.875 -3.984375 L 6.21875 -3.984375 L 5.515625 -6.359375 L 5.0625 -7.921875 L 5.046875 -7.921875 L 4.640625 -6.375 Z M 3.875 -3.984375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 3.671875 -9.90625 L 3.671875 0 Z M 1.09375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -4.953125 C 0.671875 -6.015625 0.863281 -6.925781 1.25 -7.6875 C 1.644531 -8.445312 2.207031 -9.03125 2.9375 -9.4375 C 3.664062 -9.84375 4.53125 -10.046875 5.53125 -10.046875 C 6.53125 -10.046875 7.390625 -9.84375 8.109375 -9.4375 C 8.835938 -9.03125 9.394531 -8.445312 9.78125 -7.6875 C 10.175781 -6.925781 10.375 -6.015625 10.375 -4.953125 C 10.375 -3.890625 10.175781 -2.972656 9.78125 -2.203125 C 9.394531 -1.441406 8.835938 -0.859375 8.109375 -0.453125 C 7.390625 -0.0546875 6.53125 0.140625 5.53125 0.140625 C 4.53125 0.140625 3.664062 -0.0546875 2.9375 -0.453125 C 2.207031 -0.859375 1.644531 -1.441406 1.25 -2.203125 C 0.863281 -2.972656 0.671875 -3.890625 0.671875 -4.953125 Z M 3.3125 -4.953125 C 3.3125 -3.941406 3.5 -3.175781 3.875 -2.65625 C 4.257812 -2.132812 4.8125 -1.875 5.53125 -1.875 C 6.25 -1.875 6.796875 -2.132812 7.171875 -2.65625 C 7.546875 -3.175781 7.734375 -3.941406 7.734375 -4.953125 C 7.734375 -5.960938 7.546875 -6.726562 7.171875 -7.25 C 6.796875 -7.769531 6.25 -8.03125 5.53125 -8.03125 C 4.8125 -8.03125 4.257812 -7.769531 3.875 -7.25 C 3.5 -6.726562 3.3125 -5.960938 3.3125 -4.953125 Z M 3.3125 -4.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -4.953125 C 0.671875 -6.015625 0.863281 -6.925781 1.25 -7.6875 C 1.644531 -8.445312 2.207031 -9.03125 2.9375 -9.4375 C 3.664062 -9.84375 4.53125 -10.046875 5.53125 -10.046875 C 6.53125 -10.046875 7.390625 -9.84375 8.109375 -9.4375 C 8.835938 -9.03125 9.394531 -8.445312 9.78125 -7.6875 C 10.175781 -6.925781 10.375 -6.015625 10.375 -4.953125 C 10.375 -3.503906 10.015625 -2.335938 9.296875 -1.453125 C 8.585938 -0.566406 7.597656 -0.046875 6.328125 0.109375 C 6.367188 0.453125 6.515625 0.691406 6.765625 0.828125 C 7.023438 0.972656 7.382812 1.046875 7.84375 1.046875 C 8.65625 1.046875 9.269531 0.851562 9.6875 0.46875 L 10.3125 2.34375 C 10.050781 2.570312 9.695312 2.75 9.25 2.875 C 8.8125 3 8.3125 3.0625 7.75 3.0625 C 6.757812 3.0625 5.992188 2.820312 5.453125 2.34375 C 4.921875 1.875 4.65625 1.222656 4.65625 0.390625 L 4.671875 0.09375 C 3.421875 -0.0820312 2.441406 -0.609375 1.734375 -1.484375 C 1.023438 -2.367188 0.671875 -3.523438 0.671875 -4.953125 Z M 3.3125 -4.953125 C 3.3125 -3.941406 3.5 -3.175781 3.875 -2.65625 C 4.257812 -2.132812 4.8125 -1.875 5.53125 -1.875 C 6.25 -1.875 6.796875 -2.132812 7.171875 -2.65625 C 7.546875 -3.175781 7.734375 -3.941406 7.734375 -4.953125 C 7.734375 -5.960938 7.546875 -6.726562 7.171875 -7.25 C 6.796875 -7.769531 6.25 -8.03125 5.53125 -8.03125 C 4.8125 -8.03125 4.257812 -7.769531 3.875 -7.25 C 3.5 -6.726562 3.3125 -5.960938 3.3125 -4.953125 Z M 3.3125 -4.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.921875 -4.03125 L 0.921875 -9.90625 L 3.515625 -9.90625 L 3.515625 -3.984375 C 3.515625 -3.285156 3.660156 -2.757812 3.953125 -2.40625 C 4.253906 -2.050781 4.71875 -1.875 5.34375 -1.875 C 6.582031 -1.875 7.203125 -2.578125 7.203125 -3.984375 L 7.203125 -9.90625 L 9.765625 -9.90625 L 9.765625 -4.03125 C 9.765625 -2.644531 9.394531 -1.601562 8.65625 -0.90625 C 7.914062 -0.207031 6.8125 0.140625 5.34375 0.140625 C 3.882812 0.140625 2.78125 -0.207031 2.03125 -0.90625 C 1.289062 -1.601562 0.921875 -2.644531 0.921875 -4.03125 Z M 0.921875 -4.03125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -4.953125 C 0.671875 -6.003906 0.863281 -6.910156 1.25 -7.671875 C 1.644531 -8.441406 2.207031 -9.03125 2.9375 -9.4375 C 3.664062 -9.84375 4.523438 -10.046875 5.515625 -10.046875 C 6.597656 -10.046875 7.515625 -9.816406 8.265625 -9.359375 C 9.015625 -8.910156 9.507812 -8.226562 9.75 -7.3125 L 7.484375 -6.40625 C 7.335938 -7 7.117188 -7.414062 6.828125 -7.65625 C 6.546875 -7.90625 6.140625 -8.03125 5.609375 -8.03125 C 4.878906 -8.03125 4.3125 -7.765625 3.90625 -7.234375 C 3.507812 -6.710938 3.3125 -5.953125 3.3125 -4.953125 C 3.3125 -3.953125 3.503906 -3.1875 3.890625 -2.65625 C 4.273438 -2.132812 4.832031 -1.875 5.5625 -1.875 C 6.113281 -1.875 6.550781 -2.003906 6.875 -2.265625 C 7.195312 -2.523438 7.414062 -2.9375 7.53125 -3.5 L 9.875 -2.828125 C 9.59375 -1.828125 9.070312 -1.082031 8.3125 -0.59375 C 7.550781 -0.101562 6.625 0.140625 5.53125 0.140625 C 4.53125 0.140625 3.664062 -0.0546875 2.9375 -0.453125 C 2.207031 -0.859375 1.644531 -1.441406 1.25 -2.203125 C 0.863281 -2.972656 0.671875 -3.890625 0.671875 -4.953125 Z M 0.671875 -4.953125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.09375 0 L 1.09375 -9.90625 L 3.671875 -9.90625 L 3.671875 -2 L 8.640625 -2 L 8.640625 0 Z M 1.09375 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph7-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.421875 -1.53125 L 1.75 -3.328125 C 2.132812 -2.785156 2.570312 -2.40625 3.0625 -2.1875 C 3.550781 -1.96875 4.140625 -1.859375 4.828125 -1.859375 C 5.378906 -1.859375 5.789062 -1.9375 6.0625 -2.09375 C 6.34375 -2.25 6.484375 -2.472656 6.484375 -2.765625 C 6.484375 -2.992188 6.332031 -3.175781 6.03125 -3.3125 C 5.738281 -3.457031 5.25 -3.597656 4.5625 -3.734375 C 3.707031 -3.898438 3.003906 -4.097656 2.453125 -4.328125 C 1.898438 -4.566406 1.46875 -4.882812 1.15625 -5.28125 C 0.851562 -5.6875 0.703125 -6.203125 0.703125 -6.828125 C 0.703125 -7.441406 0.867188 -7.992188 1.203125 -8.484375 C 1.535156 -8.984375 2.023438 -9.367188 2.671875 -9.640625 C 3.316406 -9.910156 4.082031 -10.046875 4.96875 -10.046875 C 5.90625 -10.046875 6.707031 -9.90625 7.375 -9.625 C 8.039062 -9.34375 8.660156 -8.890625 9.234375 -8.265625 L 7.765625 -6.578125 C 7.429688 -7.078125 7.039062 -7.445312 6.59375 -7.6875 C 6.15625 -7.925781 5.628906 -8.046875 5.015625 -8.046875 C 4.492188 -8.046875 4.09375 -7.953125 3.8125 -7.765625 C 3.53125 -7.585938 3.390625 -7.347656 3.390625 -7.046875 C 3.390625 -6.804688 3.535156 -6.609375 3.828125 -6.453125 C 4.128906 -6.296875 4.632812 -6.148438 5.34375 -6.015625 C 6.707031 -5.765625 7.679688 -5.398438 8.265625 -4.921875 C 8.847656 -4.441406 9.140625 -3.765625 9.140625 -2.890625 C 9.140625 -2.265625 8.960938 -1.722656 8.609375 -1.265625 C 8.253906 -0.804688 7.757812 -0.457031 7.125 -0.21875 C 6.488281 0.0195312 5.769531 0.140625 4.96875 0.140625 C 3.84375 0.140625 2.929688 0.00390625 2.234375 -0.265625 C 1.535156 -0.535156 0.929688 -0.957031 0.421875 -1.53125 Z M 0.421875 -1.53125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.46875 0 L 0.46875 -9.328125 L 4.1875 -9.328125 L 4.1875 0 Z M 0.9375 -0.46875 L 3.71875 -0.46875 L 3.71875 -8.859375 L 0.9375 -8.859375 Z M 0.9375 -0.46875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.359375 0 L 3.96875 -9.25 L 5.296875 -9.25 L 8.875 0 L 7.6875 0 L 6.703125 -2.5625 L 2.515625 -2.5625 L 1.53125 0 Z M 2.921875 -3.609375 L 6.296875 -3.609375 L 5.046875 -6.890625 L 4.625 -8.171875 L 4.59375 -8.171875 L 4.1875 -6.9375 Z M 2.921875 -3.609375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.953125 -4.625 C 0.953125 -5.59375 1.125 -6.429688 1.46875 -7.140625 C 1.820312 -7.859375 2.320312 -8.410156 2.96875 -8.796875 C 3.613281 -9.179688 4.367188 -9.375 5.234375 -9.375 C 6.097656 -9.375 6.851562 -9.179688 7.5 -8.796875 C 8.144531 -8.410156 8.640625 -7.859375 8.984375 -7.140625 C 9.335938 -6.429688 9.515625 -5.59375 9.515625 -4.625 C 9.515625 -3.65625 9.335938 -2.8125 8.984375 -2.09375 C 8.640625 -1.382812 8.144531 -0.832031 7.5 -0.4375 C 6.851562 -0.0507812 6.097656 0.140625 5.234375 0.140625 C 4.367188 0.140625 3.613281 -0.0507812 2.96875 -0.4375 C 2.320312 -0.832031 1.820312 -1.382812 1.46875 -2.09375 C 1.125 -2.8125 0.953125 -3.65625 0.953125 -4.625 Z M 2.125 -4.625 C 2.125 -3.46875 2.398438 -2.554688 2.953125 -1.890625 C 3.515625 -1.234375 4.273438 -0.90625 5.234375 -0.90625 C 6.191406 -0.90625 6.945312 -1.234375 7.5 -1.890625 C 8.0625 -2.554688 8.34375 -3.46875 8.34375 -4.625 C 8.34375 -5.78125 8.0625 -6.6875 7.5 -7.34375 C 6.945312 -8 6.191406 -8.328125 5.234375 -8.328125 C 4.273438 -8.328125 3.515625 -8 2.953125 -7.34375 C 2.398438 -6.6875 2.125 -5.78125 2.125 -4.625 Z M 2.125 -4.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 4.796875 -9.25 C 5.859375 -9.25 6.648438 -9.023438 7.171875 -8.578125 C 7.691406 -8.128906 7.953125 -7.5 7.953125 -6.6875 C 7.953125 -6.207031 7.8125 -5.78125 7.53125 -5.40625 C 7.257812 -5.03125 6.882812 -4.796875 6.40625 -4.703125 L 6.40625 -4.6875 C 6.945312 -4.582031 7.378906 -4.332031 7.703125 -3.9375 C 8.023438 -3.550781 8.1875 -3.101562 8.1875 -2.59375 C 8.1875 -1.800781 7.890625 -1.171875 7.296875 -0.703125 C 6.703125 -0.234375 5.863281 0 4.78125 0 Z M 2.625 -1.046875 L 5.046875 -1.046875 C 5.703125 -1.046875 6.191406 -1.175781 6.515625 -1.4375 C 6.847656 -1.707031 7.015625 -2.09375 7.015625 -2.59375 C 7.015625 -3.09375 6.847656 -3.472656 6.515625 -3.734375 C 6.191406 -3.992188 5.703125 -4.125 5.046875 -4.125 L 2.625 -4.125 Z M 2.625 -5.1875 L 4.8125 -5.1875 C 5.476562 -5.1875 5.972656 -5.304688 6.296875 -5.546875 C 6.617188 -5.796875 6.78125 -6.175781 6.78125 -6.6875 C 6.78125 -7.6875 6.125 -8.1875 4.8125 -8.1875 L 2.625 -8.1875 Z M 2.625 -5.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.453125 -8.1875 L 0.453125 -9.25 L 8 -9.25 L 8 -8.1875 L 4.78125 -8.1875 L 4.78125 0 L 3.671875 0 L 3.671875 -8.1875 Z M 0.453125 -8.1875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 7.984375 -9.25 L 7.984375 -8.1875 L 2.625 -8.1875 L 2.625 -5.203125 L 6.796875 -5.203125 L 6.796875 -4.15625 L 2.625 -4.15625 L 2.625 -1.046875 L 8.203125 -1.046875 L 8.203125 0 Z M 1.515625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 2.90625 -9.25 L 6.75 -3.078125 L 7.75 -1.234375 L 7.765625 -1.234375 L 7.703125 -2.71875 L 7.703125 -9.25 L 8.765625 -9.25 L 8.765625 0 L 7.375 0 L 3.515625 -6.1875 L 2.53125 -8 L 2.515625 -8 L 2.578125 -6.515625 L 2.578125 0 Z M 1.515625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.421875 -3.453125 L 1.421875 -9.25 L 2.53125 -9.25 L 2.53125 -3.71875 C 2.53125 -2.75 2.734375 -2.035156 3.140625 -1.578125 C 3.546875 -1.128906 4.175781 -0.90625 5.03125 -0.90625 C 5.894531 -0.90625 6.53125 -1.128906 6.9375 -1.578125 C 7.34375 -2.035156 7.546875 -2.75 7.546875 -3.71875 L 7.546875 -9.25 L 8.671875 -9.25 L 8.671875 -3.453125 C 8.671875 -2.265625 8.359375 -1.367188 7.734375 -0.765625 C 7.109375 -0.160156 6.207031 0.140625 5.03125 0.140625 C 3.863281 0.140625 2.96875 -0.160156 2.34375 -0.765625 C 1.726562 -1.378906 1.421875 -2.273438 1.421875 -3.453125 Z M 1.421875 -3.453125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 2.625 -9.25 L 2.625 -1.046875 L 7.921875 -1.046875 L 7.921875 0 Z M 1.515625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 5.015625 -9.25 C 5.953125 -9.25 6.707031 -9.003906 7.28125 -8.515625 C 7.851562 -8.023438 8.140625 -7.363281 8.140625 -6.53125 C 8.140625 -5.882812 7.957031 -5.335938 7.59375 -4.890625 C 7.226562 -4.441406 6.726562 -4.132812 6.09375 -3.96875 L 8.703125 0 L 7.359375 0 L 4.84375 -3.828125 L 2.625 -3.828125 L 2.625 0 Z M 2.625 -4.890625 L 5 -4.890625 C 6.300781 -4.890625 6.953125 -5.4375 6.953125 -6.53125 C 6.953125 -7.632812 6.300781 -8.1875 5 -8.1875 L 2.625 -8.1875 Z M 2.625 -4.890625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-11"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 7.984375 -9.25 L 7.984375 -8.1875 L 2.625 -8.1875 L 2.625 -5.203125 L 6.796875 -5.203125 L 6.796875 -4.15625 L 2.625 -4.15625 L 2.625 -1.046875 L 8.203125 -1.046875 L 8.203125 0 Z M 4.15625 -10.40625 L 4.953125 -12.46875 L 6.28125 -12.46875 L 5.0625 -10.40625 Z M 4.15625 -10.40625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-12"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -1.859375 L 1.640625 -2.640625 C 1.890625 -2.085938 2.257812 -1.660156 2.75 -1.359375 C 3.238281 -1.054688 3.851562 -0.90625 4.59375 -0.90625 C 5.320312 -0.90625 5.898438 -1.035156 6.328125 -1.296875 C 6.753906 -1.566406 6.96875 -1.945312 6.96875 -2.4375 C 6.96875 -2.84375 6.78125 -3.164062 6.40625 -3.40625 C 6.039062 -3.65625 5.378906 -3.863281 4.421875 -4.03125 C 3.191406 -4.25 2.320312 -4.554688 1.8125 -4.953125 C 1.300781 -5.359375 1.046875 -5.921875 1.046875 -6.640625 C 1.046875 -7.140625 1.179688 -7.597656 1.453125 -8.015625 C 1.734375 -8.429688 2.132812 -8.757812 2.65625 -9 C 3.1875 -9.25 3.796875 -9.375 4.484375 -9.375 C 6.128906 -9.375 7.316406 -8.722656 8.046875 -7.421875 L 7.078125 -6.640625 C 6.804688 -7.253906 6.472656 -7.6875 6.078125 -7.9375 C 5.691406 -8.195312 5.160156 -8.328125 4.484375 -8.328125 C 3.773438 -8.328125 3.21875 -8.179688 2.8125 -7.890625 C 2.414062 -7.597656 2.21875 -7.222656 2.21875 -6.765625 C 2.21875 -6.460938 2.296875 -6.210938 2.453125 -6.015625 C 2.609375 -5.828125 2.867188 -5.660156 3.234375 -5.515625 C 3.609375 -5.367188 4.117188 -5.238281 4.765625 -5.125 C 5.992188 -4.914062 6.863281 -4.601562 7.375 -4.1875 C 7.882812 -3.78125 8.140625 -3.21875 8.140625 -2.5 C 8.140625 -1.96875 7.988281 -1.503906 7.6875 -1.109375 C 7.394531 -0.710938 6.976562 -0.40625 6.4375 -0.1875 C 5.894531 0.03125 5.269531 0.140625 4.5625 0.140625 C 3.632812 0.140625 2.835938 -0.0390625 2.171875 -0.40625 C 1.515625 -0.769531 1.015625 -1.253906 0.671875 -1.859375 Z M 0.671875 -1.859375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-13"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 4.484375 -9.25 C 5.941406 -9.25 7.082031 -8.84375 7.90625 -8.03125 C 8.726562 -7.226562 9.140625 -6.09375 9.140625 -4.625 C 9.140625 -3.144531 8.726562 -2.003906 7.90625 -1.203125 C 7.082031 -0.398438 5.941406 0 4.484375 0 Z M 2.625 -1.046875 L 4.609375 -1.046875 C 5.660156 -1.046875 6.484375 -1.359375 7.078125 -1.984375 C 7.671875 -2.617188 7.96875 -3.5 7.96875 -4.625 C 7.96875 -5.738281 7.671875 -6.609375 7.078125 -7.234375 C 6.484375 -7.867188 5.660156 -8.1875 4.609375 -8.1875 L 2.625 -8.1875 Z M 2.625 -1.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 3.234375 -9.25 L 5.265625 -3.625 L 5.96875 -1.3125 L 6 -1.3125 L 6.703125 -3.609375 L 8.71875 -9.25 L 10.453125 -9.25 L 10.453125 0 L 9.375 0 L 9.375 -5.8125 L 9.515625 -8.25 L 9.5 -8.25 L 6.453125 0 L 5.5 0 L 2.46875 -8.25 L 2.453125 -8.25 L 2.578125 -5.8125 L 2.578125 0 Z M 1.515625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-15"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.515625 0 L 1.515625 -9.25 L 2.625 -9.25 L 2.625 0 Z M 1.515625 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-16"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.953125 -4.625 C 0.953125 -5.582031 1.125 -6.421875 1.46875 -7.140625 C 1.820312 -7.859375 2.320312 -8.410156 2.96875 -8.796875 C 3.613281 -9.179688 4.359375 -9.375 5.203125 -9.375 C 6.097656 -9.375 6.84375 -9.191406 7.4375 -8.828125 C 8.039062 -8.460938 8.492188 -7.925781 8.796875 -7.21875 L 7.6875 -6.703125 C 7.476562 -7.242188 7.175781 -7.648438 6.78125 -7.921875 C 6.394531 -8.191406 5.898438 -8.328125 5.296875 -8.328125 C 4.660156 -8.328125 4.101562 -8.179688 3.625 -7.890625 C 3.144531 -7.597656 2.773438 -7.171875 2.515625 -6.609375 C 2.253906 -6.046875 2.125 -5.382812 2.125 -4.625 C 2.125 -3.46875 2.398438 -2.554688 2.953125 -1.890625 C 3.515625 -1.234375 4.273438 -0.90625 5.234375 -0.90625 C 5.859375 -0.90625 6.398438 -1.0625 6.859375 -1.375 C 7.316406 -1.695312 7.644531 -2.171875 7.84375 -2.796875 L 8.96875 -2.359375 C 8.675781 -1.578125 8.195312 -0.960938 7.53125 -0.515625 C 6.863281 -0.078125 6.097656 0.140625 5.234375 0.140625 C 4.367188 0.140625 3.613281 -0.0507812 2.96875 -0.4375 C 2.320312 -0.832031 1.820312 -1.382812 1.46875 -2.09375 C 1.125 -2.8125 0.953125 -3.65625 0.953125 -4.625 Z M 0.953125 -4.625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.25 -1.734375 L 1.25 -10.21875 L 2.359375 -10.21875 L 2.359375 -1.875 C 2.359375 -1.519531 2.410156 -1.273438 2.515625 -1.140625 C 2.628906 -1.003906 2.832031 -0.9375 3.125 -0.9375 C 3.320312 -0.9375 3.488281 -0.953125 3.625 -0.984375 C 3.769531 -1.015625 3.941406 -1.066406 4.140625 -1.140625 L 3.96875 -0.0625 C 3.664062 0.0703125 3.332031 0.140625 2.96875 0.140625 C 2.957031 0.140625 2.941406 0.140625 2.921875 0.140625 C 2.359375 0.140625 1.9375 -0.0078125 1.65625 -0.3125 C 1.382812 -0.625 1.25 -1.097656 1.25 -1.734375 Z M 1.25 -1.734375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.160156 -5.523438 1.734375 -6.171875 C 2.304688 -6.816406 3.117188 -7.140625 4.171875 -7.140625 C 4.816406 -7.140625 5.378906 -6.992188 5.859375 -6.703125 C 6.335938 -6.421875 6.695312 -6.03125 6.9375 -5.53125 C 7.1875 -5.03125 7.3125 -4.472656 7.3125 -3.859375 C 7.3125 -3.597656 7.289062 -3.335938 7.25 -3.078125 L 1.96875 -3.078125 C 2.039062 -2.367188 2.273438 -1.816406 2.671875 -1.421875 C 3.078125 -1.035156 3.609375 -0.84375 4.265625 -0.84375 C 4.773438 -0.84375 5.195312 -0.929688 5.53125 -1.109375 C 5.875 -1.285156 6.109375 -1.539062 6.234375 -1.875 L 7.171875 -1.390625 C 6.890625 -0.890625 6.515625 -0.507812 6.046875 -0.25 C 5.578125 0.0078125 4.984375 0.140625 4.265625 0.140625 C 3.210938 0.140625 2.382812 -0.179688 1.78125 -0.828125 C 1.175781 -1.472656 0.875 -2.363281 0.875 -3.5 Z M 1.984375 -4.078125 L 6.234375 -4.078125 C 6.160156 -4.722656 5.941406 -5.226562 5.578125 -5.59375 C 5.222656 -5.96875 4.753906 -6.15625 4.171875 -6.15625 C 3.554688 -6.15625 3.054688 -5.972656 2.671875 -5.609375 C 2.296875 -5.242188 2.066406 -4.734375 1.984375 -4.078125 Z M 3.453125 -8.15625 L 4.515625 -10.5 L 5.734375 -10.5 L 4.359375 -8.15625 Z M 3.453125 -8.15625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.160156 -5.523438 1.734375 -6.171875 C 2.316406 -6.816406 3.097656 -7.140625 4.078125 -7.140625 C 4.585938 -7.140625 5.046875 -7.023438 5.453125 -6.796875 C 5.859375 -6.578125 6.175781 -6.28125 6.40625 -5.90625 L 6.40625 -10.21875 L 7.515625 -10.21875 L 7.515625 0 L 6.53125 0 L 6.46875 -1.21875 C 6.257812 -0.8125 5.941406 -0.484375 5.515625 -0.234375 C 5.097656 0.015625 4.617188 0.140625 4.078125 0.140625 C 3.097656 0.140625 2.316406 -0.179688 1.734375 -0.828125 C 1.160156 -1.484375 0.875 -2.375 0.875 -3.5 Z M 2 -3.5 C 2 -2.6875 2.191406 -2.039062 2.578125 -1.5625 C 2.972656 -1.082031 3.515625 -0.84375 4.203125 -0.84375 C 4.867188 -0.84375 5.398438 -1.078125 5.796875 -1.546875 C 6.203125 -2.015625 6.40625 -2.640625 6.40625 -3.421875 L 6.40625 -3.578125 C 6.40625 -4.367188 6.203125 -4.992188 5.796875 -5.453125 C 5.398438 -5.921875 4.867188 -6.15625 4.203125 -6.15625 C 3.515625 -6.15625 2.972656 -5.914062 2.578125 -5.4375 C 2.191406 -4.957031 2 -4.3125 2 -3.5 Z M 2 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-20"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.160156 -5.523438 1.734375 -6.171875 C 2.304688 -6.816406 3.117188 -7.140625 4.171875 -7.140625 C 4.816406 -7.140625 5.378906 -6.992188 5.859375 -6.703125 C 6.335938 -6.421875 6.695312 -6.03125 6.9375 -5.53125 C 7.1875 -5.03125 7.3125 -4.472656 7.3125 -3.859375 C 7.3125 -3.597656 7.289062 -3.335938 7.25 -3.078125 L 1.96875 -3.078125 C 2.039062 -2.367188 2.273438 -1.816406 2.671875 -1.421875 C 3.078125 -1.035156 3.609375 -0.84375 4.265625 -0.84375 C 4.773438 -0.84375 5.195312 -0.929688 5.53125 -1.109375 C 5.875 -1.285156 6.109375 -1.539062 6.234375 -1.875 L 7.171875 -1.390625 C 6.890625 -0.890625 6.515625 -0.507812 6.046875 -0.25 C 5.578125 0.0078125 4.984375 0.140625 4.265625 0.140625 C 3.210938 0.140625 2.382812 -0.179688 1.78125 -0.828125 C 1.175781 -1.472656 0.875 -2.363281 0.875 -3.5 Z M 1.984375 -4.078125 L 6.234375 -4.078125 C 6.160156 -4.722656 5.941406 -5.226562 5.578125 -5.59375 C 5.222656 -5.96875 4.753906 -6.15625 4.171875 -6.15625 C 3.554688 -6.15625 3.054688 -5.972656 2.671875 -5.609375 C 2.296875 -5.242188 2.066406 -4.734375 1.984375 -4.078125 Z M 1.984375 -4.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-21"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.171875 -5.523438 1.765625 -6.171875 C 2.367188 -6.816406 3.203125 -7.140625 4.265625 -7.140625 C 4.960938 -7.140625 5.550781 -6.976562 6.03125 -6.65625 C 6.507812 -6.332031 6.882812 -5.875 7.15625 -5.28125 L 6.09375 -4.765625 C 5.789062 -5.691406 5.164062 -6.15625 4.21875 -6.15625 C 3.519531 -6.15625 2.972656 -5.921875 2.578125 -5.453125 C 2.179688 -4.984375 1.984375 -4.332031 1.984375 -3.5 C 1.984375 -2.664062 2.179688 -2.015625 2.578125 -1.546875 C 2.972656 -1.078125 3.519531 -0.84375 4.21875 -0.84375 C 4.757812 -0.84375 5.195312 -0.960938 5.53125 -1.203125 C 5.863281 -1.453125 6.082031 -1.8125 6.1875 -2.28125 L 7.21875 -1.921875 C 6.976562 -1.265625 6.601562 -0.753906 6.09375 -0.390625 C 5.59375 -0.0351562 4.984375 0.140625 4.265625 0.140625 C 3.210938 0.140625 2.382812 -0.179688 1.78125 -0.828125 C 1.175781 -1.472656 0.875 -2.363281 0.875 -3.5 Z M 0.875 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-22"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.171875 -5.523438 1.765625 -6.171875 C 2.367188 -6.816406 3.203125 -7.140625 4.265625 -7.140625 C 5.316406 -7.140625 6.140625 -6.816406 6.734375 -6.171875 C 7.335938 -5.523438 7.640625 -4.632812 7.640625 -3.5 C 7.640625 -2.363281 7.335938 -1.472656 6.734375 -0.828125 C 6.140625 -0.179688 5.316406 0.140625 4.265625 0.140625 C 3.210938 0.140625 2.382812 -0.179688 1.78125 -0.828125 C 1.175781 -1.472656 0.875 -2.363281 0.875 -3.5 Z M 1.984375 -3.5 C 1.984375 -2.664062 2.179688 -2.007812 2.578125 -1.53125 C 2.984375 -1.0625 3.546875 -0.828125 4.265625 -0.828125 C 4.972656 -0.828125 5.523438 -1.0625 5.921875 -1.53125 C 6.316406 -2.007812 6.515625 -2.664062 6.515625 -3.5 C 6.515625 -4.332031 6.3125 -4.984375 5.90625 -5.453125 C 5.507812 -5.929688 4.960938 -6.171875 4.265625 -6.171875 C 3.546875 -6.171875 2.984375 -5.929688 2.578125 -5.453125 C 2.179688 -4.984375 1.984375 -4.332031 1.984375 -3.5 Z M 1.984375 -3.5 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-23"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7 L 2.28125 -7 L 2.359375 -5.90625 C 2.585938 -6.320312 2.90625 -6.628906 3.3125 -6.828125 C 3.726562 -7.035156 4.191406 -7.140625 4.703125 -7.140625 C 5.492188 -7.140625 6.144531 -6.910156 6.65625 -6.453125 C 7.175781 -5.992188 7.4375 -5.335938 7.4375 -4.484375 L 7.4375 0 L 6.3125 0 L 6.3125 -4.09375 C 6.3125 -4.820312 6.15625 -5.347656 5.84375 -5.671875 C 5.53125 -5.992188 5.113281 -6.15625 4.59375 -6.15625 C 4.21875 -6.15625 3.863281 -6.070312 3.53125 -5.90625 C 3.207031 -5.75 2.941406 -5.484375 2.734375 -5.109375 C 2.523438 -4.742188 2.421875 -4.28125 2.421875 -3.71875 L 2.421875 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-24"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.4375 -6.03125 L 0.4375 -7 L 1.828125 -7 L 1.828125 -8.6875 L 2.953125 -8.984375 L 2.953125 -7 L 5.546875 -7 L 5.546875 -6.03125 L 2.953125 -6.03125 L 2.953125 -1.9375 C 2.953125 -1.59375 3.046875 -1.332031 3.234375 -1.15625 C 3.429688 -0.988281 3.6875 -0.90625 4 -0.90625 C 4.445312 -0.90625 4.847656 -1.078125 5.203125 -1.421875 L 5.578125 -0.5 C 5.117188 -0.0703125 4.519531 0.140625 3.78125 0.140625 C 3.207031 0.140625 2.738281 -0.0078125 2.375 -0.3125 C 2.019531 -0.625 1.835938 -1.097656 1.828125 -1.734375 L 1.828125 -6.03125 Z M 0.4375 -6.03125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-25"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.296875 0 L 1.296875 -7 L 2.21875 -7 L 2.359375 -5.859375 C 2.753906 -6.710938 3.503906 -7.140625 4.609375 -7.140625 C 4.941406 -7.140625 5.195312 -7.09375 5.375 -7 L 5.15625 -5.90625 C 4.925781 -6.03125 4.628906 -6.09375 4.265625 -6.09375 C 3.972656 -6.09375 3.679688 -6.003906 3.390625 -5.828125 C 3.109375 -5.660156 2.875 -5.398438 2.6875 -5.046875 C 2.507812 -4.703125 2.421875 -4.28125 2.421875 -3.78125 L 2.421875 0 Z M 1.296875 0 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-26"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.875 -3.5 C 0.875 -4.632812 1.171875 -5.523438 1.765625 -6.171875 C 2.367188 -6.816406 3.203125 -7.140625 4.265625 -7.140625 C 5.316406 -7.140625 6.140625 -6.816406 6.734375 -6.171875 C 7.335938 -5.523438 7.640625 -4.632812 7.640625 -3.5 C 7.640625 -2.363281 7.335938 -1.472656 6.734375 -0.828125 C 6.140625 -0.179688 5.316406 0.140625 4.265625 0.140625 C 3.210938 0.140625 2.382812 -0.179688 1.78125 -0.828125 C 1.175781 -1.472656 0.875 -2.363281 0.875 -3.5 Z M 1.984375 -3.5 C 1.984375 -2.664062 2.179688 -2.007812 2.578125 -1.53125 C 2.984375 -1.0625 3.546875 -0.828125 4.265625 -0.828125 C 4.972656 -0.828125 5.523438 -1.0625 5.921875 -1.53125 C 6.316406 -2.007812 6.515625 -2.664062 6.515625 -3.5 C 6.515625 -4.332031 6.3125 -4.984375 5.90625 -5.453125 C 5.507812 -5.929688 4.960938 -6.171875 4.265625 -6.171875 C 3.546875 -6.171875 2.984375 -5.929688 2.578125 -5.453125 C 2.179688 -4.984375 1.984375 -4.332031 1.984375 -3.5 Z M 2.046875 -8.0625 L 3.609375 -10.40625 L 4.90625 -10.40625 L 6.46875 -8.0625 L 5.453125 -8.0625 L 4.265625 -9.625 L 3.0625 -8.0625 Z M 2.046875 -8.0625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-27"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.15625 -0.765625 C 1.15625 -1.035156 1.238281 -1.253906 1.40625 -1.421875 C 1.582031 -1.597656 1.804688 -1.6875 2.078125 -1.6875 C 2.347656 -1.6875 2.566406 -1.597656 2.734375 -1.421875 C 2.898438 -1.253906 2.984375 -1.035156 2.984375 -0.765625 C 2.984375 -0.503906 2.898438 -0.285156 2.734375 -0.109375 C 2.566406 0.0546875 2.347656 0.140625 2.078125 0.140625 C 1.804688 0.140625 1.582031 0.0546875 1.40625 -0.109375 C 1.238281 -0.273438 1.15625 -0.492188 1.15625 -0.765625 Z M 1.15625 -6.234375 C 1.15625 -6.503906 1.238281 -6.722656 1.40625 -6.890625 C 1.582031 -7.054688 1.804688 -7.140625 2.078125 -7.140625 C 2.347656 -7.140625 2.566406 -7.054688 2.734375 -6.890625 C 2.898438 -6.722656 2.984375 -6.503906 2.984375 -6.234375 C 2.984375 -5.960938 2.898438 -5.742188 2.734375 -5.578125 C 2.566406 -5.410156 2.347656 -5.328125 2.078125 -5.328125 C 1.804688 -5.328125 1.582031 -5.410156 1.40625 -5.578125 C 1.238281 -5.742188 1.15625 -5.960938 1.15625 -6.234375 Z M 1.15625 -6.234375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-28"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.234375 -2.421875 L 1.234375 -7 L 2.359375 -7 L 2.359375 -2.71875 C 2.359375 -2.03125 2.492188 -1.546875 2.765625 -1.265625 C 3.046875 -0.984375 3.457031 -0.84375 4 -0.84375 C 4.644531 -0.84375 5.175781 -1.035156 5.59375 -1.421875 C 6.019531 -1.816406 6.234375 -2.40625 6.234375 -3.1875 L 6.234375 -7 L 7.359375 -7 L 7.359375 0 L 6.390625 0 L 6.3125 -1.0625 C 5.851562 -0.257812 5.019531 0.140625 3.8125 0.140625 C 3.050781 0.140625 2.429688 -0.0664062 1.953125 -0.484375 C 1.472656 -0.910156 1.234375 -1.554688 1.234375 -2.421875 Z M 1.234375 -2.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-29"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.140625 -9.25 L 1.46875 -9.25 L 4 -4.765625 L 6.53125 -9.25 L 7.875 -9.25 L 4.5625 -3.609375 L 4.5625 0 L 3.453125 0 L 3.453125 -3.609375 Z M 0.140625 -9.25 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-30"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.640625 1.15625 C 0.640625 0.84375 0.75 0.5625 0.96875 0.3125 C 1.1875 0.0703125 1.488281 -0.0976562 1.875 -0.203125 C 1.582031 -0.335938 1.347656 -0.507812 1.171875 -0.71875 C 1.003906 -0.9375 0.921875 -1.191406 0.921875 -1.484375 C 0.921875 -1.828125 1.015625 -2.113281 1.203125 -2.34375 C 1.390625 -2.570312 1.644531 -2.742188 1.96875 -2.859375 C 1.632812 -3.066406 1.378906 -3.332031 1.203125 -3.65625 C 1.035156 -3.988281 0.953125 -4.359375 0.953125 -4.765625 C 0.953125 -5.222656 1.070312 -5.628906 1.3125 -5.984375 C 1.5625 -6.347656 1.90625 -6.628906 2.34375 -6.828125 C 2.78125 -7.035156 3.273438 -7.140625 3.828125 -7.140625 C 4.347656 -7.140625 4.820312 -7.046875 5.25 -6.859375 C 5.507812 -7.804688 6.164062 -8.28125 7.21875 -8.28125 L 7.484375 -7.3125 C 6.566406 -7.3125 6.007812 -7.050781 5.8125 -6.53125 C 6.09375 -6.320312 6.304688 -6.066406 6.453125 -5.765625 C 6.609375 -5.460938 6.6875 -5.128906 6.6875 -4.765625 C 6.6875 -4.316406 6.566406 -3.910156 6.328125 -3.546875 C 6.085938 -3.191406 5.75 -2.910156 5.3125 -2.703125 C 4.875 -2.503906 4.378906 -2.40625 3.828125 -2.40625 C 3.410156 -2.40625 3.046875 -2.445312 2.734375 -2.53125 C 2.460938 -2.46875 2.265625 -2.363281 2.140625 -2.21875 C 2.023438 -2.082031 1.96875 -1.894531 1.96875 -1.65625 C 1.96875 -1.414062 2.050781 -1.226562 2.21875 -1.09375 C 2.382812 -0.957031 2.609375 -0.890625 2.890625 -0.890625 L 5.203125 -0.890625 C 5.867188 -0.890625 6.390625 -0.738281 6.765625 -0.4375 C 7.140625 -0.144531 7.328125 0.253906 7.328125 0.765625 C 7.328125 1.210938 7.171875 1.609375 6.859375 1.953125 C 6.554688 2.296875 6.140625 2.554688 5.609375 2.734375 C 5.078125 2.921875 4.492188 3.015625 3.859375 3.015625 C 2.796875 3.015625 1.992188 2.84375 1.453125 2.5 C 0.910156 2.15625 0.640625 1.707031 0.640625 1.15625 Z M 1.6875 0.9375 C 1.6875 1.289062 1.878906 1.566406 2.265625 1.765625 C 2.660156 1.972656 3.238281 2.078125 4 2.078125 C 4.695312 2.078125 5.253906 1.960938 5.671875 1.734375 C 6.085938 1.503906 6.296875 1.222656 6.296875 0.890625 C 6.296875 0.628906 6.1875 0.425781 5.96875 0.28125 C 5.757812 0.132812 5.40625 0.0625 4.90625 0.0625 L 3.015625 0.0625 C 2.585938 0.0625 2.257812 0.140625 2.03125 0.296875 C 1.800781 0.453125 1.6875 0.664062 1.6875 0.9375 Z M 2.109375 -4.765625 C 2.109375 -4.335938 2.269531 -3.988281 2.59375 -3.71875 C 2.925781 -3.445312 3.335938 -3.3125 3.828125 -3.3125 C 4.304688 -3.3125 4.707031 -3.445312 5.03125 -3.71875 C 5.363281 -3.988281 5.53125 -4.335938 5.53125 -4.765625 C 5.53125 -5.203125 5.363281 -5.554688 5.03125 -5.828125 C 4.707031 -6.097656 4.304688 -6.234375 3.828125 -6.234375 C 3.335938 -6.234375 2.925781 -6.097656 2.59375 -5.828125 C 2.269531 -5.554688 2.109375 -5.203125 2.109375 -4.765625 Z M 2.109375 -4.765625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-31"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.953125 -2.5 C 0.953125 -3.0625 1.101562 -3.546875 1.40625 -3.953125 C 1.707031 -4.359375 2.132812 -4.660156 2.6875 -4.859375 L 2.6875 -4.875 C 2.28125 -5.050781 1.957031 -5.320312 1.71875 -5.6875 C 1.488281 -6.050781 1.375 -6.472656 1.375 -6.953125 C 1.375 -7.691406 1.640625 -8.273438 2.171875 -8.703125 C 2.703125 -9.140625 3.414062 -9.359375 4.3125 -9.359375 C 5.207031 -9.359375 5.921875 -9.140625 6.453125 -8.703125 C 6.984375 -8.273438 7.25 -7.691406 7.25 -6.953125 C 7.25 -6.472656 7.132812 -6.050781 6.90625 -5.6875 C 6.675781 -5.332031 6.359375 -5.0625 5.953125 -4.875 L 5.953125 -4.859375 C 6.492188 -4.648438 6.914062 -4.34375 7.21875 -3.9375 C 7.519531 -3.539062 7.671875 -3.0625 7.671875 -2.5 C 7.671875 -1.96875 7.53125 -1.5 7.25 -1.09375 C 6.976562 -0.695312 6.585938 -0.390625 6.078125 -0.171875 C 5.566406 0.0351562 4.976562 0.140625 4.3125 0.140625 C 3.644531 0.140625 3.054688 0.0351562 2.546875 -0.171875 C 2.046875 -0.390625 1.65625 -0.695312 1.375 -1.09375 C 1.09375 -1.5 0.953125 -1.96875 0.953125 -2.5 Z M 2.109375 -2.609375 C 2.109375 -2.078125 2.304688 -1.660156 2.703125 -1.359375 C 3.097656 -1.054688 3.632812 -0.90625 4.3125 -0.90625 C 4.988281 -0.90625 5.523438 -1.054688 5.921875 -1.359375 C 6.316406 -1.660156 6.515625 -2.078125 6.515625 -2.609375 C 6.515625 -3.140625 6.3125 -3.554688 5.90625 -3.859375 C 5.507812 -4.160156 4.976562 -4.3125 4.3125 -4.3125 C 3.65625 -4.3125 3.125 -4.15625 2.71875 -3.84375 C 2.3125 -3.539062 2.109375 -3.128906 2.109375 -2.609375 Z M 2.53125 -6.828125 C 2.53125 -6.378906 2.691406 -6.019531 3.015625 -5.75 C 3.347656 -5.488281 3.78125 -5.359375 4.3125 -5.359375 C 4.84375 -5.359375 5.269531 -5.488281 5.59375 -5.75 C 5.925781 -6.019531 6.09375 -6.378906 6.09375 -6.828125 C 6.09375 -7.296875 5.929688 -7.660156 5.609375 -7.921875 C 5.296875 -8.179688 4.863281 -8.3125 4.3125 -8.3125 C 3.757812 -8.3125 3.320312 -8.179688 3 -7.921875 C 2.6875 -7.660156 2.53125 -7.296875 2.53125 -6.828125 Z M 2.53125 -6.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 0.671875 -1.4375 L 1.578125 -2.078125 C 1.734375 -1.660156 2.007812 -1.347656 2.40625 -1.140625 C 2.800781 -0.941406 3.265625 -0.84375 3.796875 -0.84375 C 4.347656 -0.84375 4.765625 -0.9375 5.046875 -1.125 C 5.335938 -1.320312 5.484375 -1.570312 5.484375 -1.875 C 5.484375 -2.144531 5.347656 -2.363281 5.078125 -2.53125 C 4.804688 -2.695312 4.332031 -2.835938 3.65625 -2.953125 C 2.988281 -3.078125 2.457031 -3.222656 2.0625 -3.390625 C 1.664062 -3.566406 1.378906 -3.785156 1.203125 -4.046875 C 1.023438 -4.316406 0.9375 -4.644531 0.9375 -5.03125 C 0.9375 -5.414062 1.046875 -5.765625 1.265625 -6.078125 C 1.492188 -6.398438 1.816406 -6.65625 2.234375 -6.84375 C 2.660156 -7.039062 3.148438 -7.140625 3.703125 -7.140625 C 4.441406 -7.140625 5.035156 -7 5.484375 -6.71875 C 5.941406 -6.445312 6.269531 -6.03125 6.46875 -5.46875 L 5.515625 -4.90625 C 5.367188 -5.351562 5.140625 -5.671875 4.828125 -5.859375 C 4.523438 -6.054688 4.148438 -6.15625 3.703125 -6.15625 C 3.242188 -6.15625 2.851562 -6.050781 2.53125 -5.84375 C 2.21875 -5.644531 2.0625 -5.410156 2.0625 -5.140625 C 2.0625 -4.828125 2.195312 -4.585938 2.46875 -4.421875 C 2.75 -4.253906 3.242188 -4.113281 3.953125 -4 C 4.921875 -3.832031 5.601562 -3.585938 6 -3.265625 C 6.40625 -2.953125 6.609375 -2.507812 6.609375 -1.9375 C 6.609375 -1.53125 6.488281 -1.171875 6.25 -0.859375 C 6.007812 -0.546875 5.664062 -0.300781 5.21875 -0.125 C 4.78125 0.0507812 4.269531 0.140625 3.6875 0.140625 C 3.007812 0.140625 2.398438 0.0078125 1.859375 -0.25 C 1.316406 -0.519531 0.921875 -0.914062 0.671875 -1.4375 Z M 0.671875 -1.4375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph8-33"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M -1.109375 2.546875 L -0.875 1.484375 C -0.539062 1.773438 -0.15625 1.921875 0.28125 1.921875 C 0.96875 1.921875 1.304688 1.484375 1.296875 0.609375 L 1.296875 -7 L 2.421875 -7 L 2.421875 0.71875 C 2.421875 1.507812 2.207031 2.085938 1.78125 2.453125 C 1.363281 2.828125 0.867188 3.015625 0.296875 3.015625 C 0.015625 3.015625 -0.242188 2.96875 -0.484375 2.875 C -0.734375 2.789062 -0.941406 2.679688 -1.109375 2.546875 Z M 1.03125 -9.1875 C 1.03125 -9.414062 1.109375 -9.609375 1.265625 -9.765625 C 1.429688 -9.929688 1.628906 -10.015625 1.859375 -10.015625 C 2.097656 -10.015625 2.296875 -9.929688 2.453125 -9.765625 C 2.617188 -9.609375 2.703125 -9.414062 2.703125 -9.1875 C 2.703125 -8.945312 2.617188 -8.742188 2.453125 -8.578125 C 2.296875 -8.421875 2.097656 -8.34375 1.859375 -8.34375 C 1.628906 -8.34375 1.429688 -8.421875 1.265625 -8.578125 C 1.109375 -8.742188 1.03125 -8.945312 1.03125 -9.1875 Z M 1.03125 -9.1875 "
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image7",
    width: 170,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAACWCAAAAABrpUyIAAAAAmJLR0QA/4ePzL8AAACsSURBVHic7c5BCQAgAAAxtX9nreBniHBLsLnHL9brwL2qQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlWhqlBVqCpUFaoKVYWqQlXhAO+PAiv976lqAAAAAElFTkSuQmCC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7",
    transform: "matrix(1,0,0,1,-0.000000000000007105,-0.000000000000007105)"
  }))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "image6",
    width: 170,
    height: 150,
    xlinkHref: "data:image/png;base64,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"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "image13",
    width: 664,
    height: 88,
    xlinkHref: "data:image/png;base64,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"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image13",
    transform: "matrix(1,0,0,1,0,0.000000000000028422)"
  }))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "image12",
    width: 664,
    height: 88,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApgAAABYCAIAAADeJBADAAAABmJLR0QA/wD/AP+gvaeTAAAKEklEQVR4nO3dO3bbSBOGYdjHm1Kk3CvwXhhzL1qBckdcFifgHA4HBBp9qaquKrzP+YN/ZAnsC9gfunH7cb/fFwAAUO12uxX+9ePjw6wky7L8sAzyz++vwr/+/f3HrCRxldtwoRkBQFM5wl+Zxfkvm4/RUIg0wgwAIKs+wp+/b5PlPw0+Q0N5Yno4bQUAoF5rilsKGeQ1OU2WAwBEeE7xJeLSOgkNADDTdF3b6y9zjhwAAKf2Qvrxc+MZPEEOAMC2zUg+nGob334W8hw5AABTGId0DYIcAIANzq9xeyLIAQCo4nA6vkQMch72AgDAU7wgr0TeAwDOIORV639//+Gx7QAGXS6X5/+/Xq8TSwKMCBnky0tUrxKdCAdw6DXCgeiiBvkTyQ2g3l6EXy4XJuUIKu05cgBYYSKOlAhyAKdAiiOr8EvrAHCokOKsqCM6ghzASRHhyIEgByQ9b6NwdRnm5u2arkrYZzXP3gvm9+m4aoQbfxzOoPzulh/3+71yQ/UvAt8bIARv/j4sTP3Wuks13iAdBCsu/tHvxAtTKMN4T3WUdso+UMNDZ2loOs/9jM/KvO/WevbdoAAahw71zWh/KDPyiaoPVN97pOvqQyt/be8jqmbkrYPC4/dDjAt9ztYgHamw+sNZdW8qeVM3ud0HBjvL517ad52awdVtIwU71TSdu/ta1R9e3G63gyDvHhQW3+NCt7M1yEh937djWXe9PHO7D4h0lre9VDyMpeJkvGCJ4/x6vVreI5DsXEbHCsHu7Wef31+C40IOp2oQqR1gtU3ZDW5uXKTke1vwuQ+Id5aTvdTnDWOXy0WwYLJbQ3R96/zbQZ5yUBghO1D6bxC9EmrXXbWbfO4DSk2qcSTXpCberm9ENiv15/XzwjNkuVIdMzVd99n6jaV1jW/v5/eXn8U6Dzw3iE3Wuq3+q9du0phGjzeCQWdN6any6FwIyL0L3FYb71t6PcyM982ufqJRKp+MV9dXH930+4VXjL8n65T3kZcvhdu42C3uVEyP3ozHYZjF7aZF8xjU5z4QurMKRB7e8vhN2TXw8mfVKJcqWZa/S1/BEeUbzDY9/5VHtB6wOa3rhGV5vNW9wOc+YNaAxj21F3KVK+eVf9Ua8LIPhivUJdNCsUFmp7nMrSPFX/0vyLu/sQ5nlmb+/v7z/N/ssgzp6/2RugfK8gRGdtTpPTU4Ootk+eZmRwp2hixHt6Y1/P4nu62Gg9f/nP61N7A5GnacT/W5wF5WrvvisvrvnyK4l6pufNPgg2j0TvwP2swwkTnWyClbn6UK4b2CgqvriZuu9Uz8fzPypqGhPPgmmJ4W1NSuqQU8DKayTyhz1ft7fSGyl4psvO/ZModkd1QPe2lKSqsF5xR0XX2l43q65nPk9cOTq9FcSlOlkrVAUzh5SIjKJHO48XFpdlTBofl9UzV5qTcdV9qafxymiPs3yJUeRu15gOjQUZ0QLaAapUpbFvxo1W6d0gKenxyXgE3upkk7peZKc5nbSt/tbQ0z8r7RIUSS1RiZuh3+jv8hMlY/qh5xzj2cVXprTqz+NWOWpjlCCLNw+xmOjYzyOY5jtHloAbK8Bonboe+kRgHT8ZWfS90goj2UOzdYBc8t4CFCZKm2tueuXPSLl29v8UM87XAezMi9cDtEilzaLVISVSHiX3snCdFTyIHDFEFGQR56gBApfOgWMCAVUSHyWInz4oWTdf12CsGmy9ovI09xrwpyBggAAHzqf7IbUE/vvSN4StnCqg8C8zaTU30O2nQitfPfiVNwjvzUlO5lAgCY+Wl2FE8kACjTe14pl1Z5wJX5SpiRA/BO/LbjhSXZgFhX30OQA3Ck8HLPjjjv+ysgFoIcgC+FaVZ9MJd/k5ncLN2r60zHC7hqHYA75Rd1r/7pMaDXz7wJACRjNyNPeW8MACX1cdu0fk6KTydyyRv9+IqldZRw+IVXxveeiL/2m9E/KC50KPvFkzrOjN7PJNkdnoJjN/mN3JiRwwKHC2gileKxZuHnuZ6raXX9PM3Srepit8/vr2QH+01Eqk+SlZ15B5OS43vadKm56g3i5Qvuzoam8MzoqnVi7JDbIThHPCC0vWw2npllevL5dN2PXqcL3tUurZ88iQerT+vNLkISh0dU0Zv6zI9gY8q7iWapYXGOPPrgklvNbJsePJXP7y8/PX6SFN/kp+5KaeqngtH9XKoXdf18t6forj7tdvg7LN0Lklo9esT53L13+kBv9pIP5p0P74vtq1+Yvkv41DYj7/hWZ4oxver7T7JM/Ria/QqKWZxHCbMo5ZRytvpG9G+Q1wdJ01c63+ifsvpKSzKVAeD/ICaivn2v8FfTZ+ezGEwBNa4MiJK+TWseTMf39Jwjr/k+J/7aV9arvvqySaba7PUbz9r7HmgcePn8wrpNI28F00u4iTX11sie/RfkTXFS+Nr7HBFkles4vQXeP/3wfGfTkky5dk3VZzququY89/Td9cntfGuzYFIxo3eh/ngJbaK0srJudw8Phu4jd/L9n0Wk+kpJ1lG2pse1nrzrp2t9tq7lvip7gZLnW7cHy2YQkyMlzDEXv91uq598fHxIbdyP/y2tMz3yL1MfZaqLPePW607xvR/Wa3q5mZK9OOwum/iZ4EIJO7Y2vcFFvKf43g+j41nrM3lLMsvyeKt7RGZtOP5BlcFQyLDLi8HC9CmXrX475SpoLD+IFE91XeRw4x2fnjKw96yX1vVehxX3RVtKJfeZZDbd5LPuERn0l/2rSw+DZzDLuzOpULbnz0dmxoNhqVc8t2c3+txut2QL7BvnyDWGhugDt3ibjDSI9tj9KJveR0TfGbxR3R+aOkvwlWWq0+7HxrtXsMtl6y65SFhqFM8mxQslT3YYoWF7af3v7z+Co22OgdtVgxg0qcZHyO5XeFJq1dyd1b1KL54rsu9alS1eyhBNNh1fyufIRfLmdSPRx4XxHBJMso7ttP4Jx3OBiHdWx9akBn3Ls+DdWS74slSR7Yhv0/5V7psf112GfGldcHD7Wfcqa+JRu28lU2mCu+jfCTb+KYl3Bm+id9aUC9m679F6/NXctfTyxp0sOUDbj/v9Xv/bhwNExCF7pFJ+GmSvJOIFSPP0+JOw76/ua561r+WeuH3ZD+owftdAUKtr17NO09uCPCU/YQyk0XFBmdldT2d+6zlSGnqyGwBsas1FyxdWal8VDxjjgTAATof5NzIhyAG4Yx+0zNERF0EOAEBgBDkAAIER5ADAWXMERpADABAYQQ7AHe1Lz7i0DZkQ5AA8ImuBSgQ5AKc0snzzpWecIEdoBDmA+faiVDDLu99bCjjHI1oBuPZM3+55czm/mY4jOl6awktTAC/qZ8yH6Xva933hhAhyghxwxGz1mwhHGpwjB+DI9Xo1iFhSHJlwjhyAO4+g1ZidE+HIhyAH4JRsnBPhyIpz5ADCaA11whtn8A+RFPg62tEN5AAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      stroke: "rgb(85.096741%,85.096741%,85.096741%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 28 20 L 570 20 C 572.761719 20 575 22.238281 575 25 L 575 817 C 575 819.761719 572.761719 822 570 822 L 28 822 C 25.238281 822 23 819.761719 23 817 L 23 25 C 23 22.238281 25.238281 20 28 20 ",
    transform: "matrix(1,0,0,-1,0,842)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(85.096741%,85.096741%,85.096741%)",
      fillOpacity: 1
    },
    d: "M 25 822 L 573 822 C 574.101562 822 575 821.101562 575 820 L 575 757 C 575 755.898438 574.101562 755 573 755 L 25 755 C 23.898438 755 23 755.898438 23 757 L 23 820 C 23 821.101562 23.898438 822 25 822 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(74.900818%,74.900818%,74.900818%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 582.44,
    y: 819
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 582.44,
    y: 813.728
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 582.44,
    y: 810.384
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 582.44,
    y: 807.04
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 582.44,
    y: 802.4
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 582.44,
    y: 798.192
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 582.44,
    y: 794.848
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 582.44,
    y: 790.328
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 582.44,
    y: 786.984
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 582.44,
    y: 784.864
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 582.44,
    y: 780.008
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 775.064
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 582.44,
    y: 772.344
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 582.44,
    y: 767.96
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-8",
    x: 582.44,
    y: 763.32
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 582.44,
    y: 758.376
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 582.44,
    y: 753.736
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-11",
    x: 582.44,
    y: 750.48
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 582.44,
    y: 745.84
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 741.2
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-13",
    x: 582.44,
    y: 738.48
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 582.44,
    y: 733.448
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 582.44,
    y: 728.928
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 725.672
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-14",
    x: 582.44,
    y: 722.952
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 582.44,
    y: 717.92
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-13",
    x: 582.44,
    y: 715.8
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-15",
    x: 582.44,
    y: 710.768
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 582.44,
    y: 708.328
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-16",
    x: 582.44,
    y: 703.472
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 582.44,
    y: 695.856
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-17",
    x: 582.44,
    y: 691.216
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-10",
    x: 582.44,
    y: 689.096
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-7",
    x: 582.44,
    y: 684.712
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-18",
    x: 582.44,
    y: 679.856
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-19",
    x: 582.44,
    y: 674.912
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-17",
    x: 582.44,
    y: 670.76
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-20",
    x: 582.44,
    y: 668.64
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-12",
    x: 582.44,
    y: 665.504
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 662.248
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-15",
    x: 582.44,
    y: 659.528
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 582.44,
    y: 657.088
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 652.448
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-21",
    x: 582.44,
    y: 649.728
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-22",
    x: 582.44,
    y: 644.76
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-23",
    x: 582.44,
    y: 640.104
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-21",
    x: 582.44,
    y: 636.608
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-22",
    x: 582.44,
    y: 631.64
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-23",
    x: 582.44,
    y: 626.984
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-22",
    x: 582.44,
    y: 623.488
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-21",
    x: 582.44,
    y: 618.832
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-22",
    x: 582.44,
    y: 613.864
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-24",
    x: 582.44,
    y: 609.208
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 604.552
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-25",
    x: 582.44,
    y: 601.832
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-9",
    x: 582.44,
    y: 597.312
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-26",
    x: 582.44,
    y: 594.592
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-22",
    x: 582.44,
    y: 591.328
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-27",
    x: 582.44,
    y: 586.672
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-21",
    x: 582.44,
    y: 581.728
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-28",
    x: 582.44,
    y: 576.76
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 108.64,
    y: 793.3
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 115.11,
    y: 793.3
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 121.18,
    y: 793.3
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 127.36,
    y: 793.3
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 132.62,
    y: 793.3
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 136.02,
    y: 793.3
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 142.31,
    y: 793.3
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 148.38,
    y: 793.3
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 154.56,
    y: 793.3
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 159.75,
    y: 793.3
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-9",
    x: 165.55,
    y: 793.3
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 170.88,
    y: 793.3
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 174.28,
    y: 793.3
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 179.91,
    y: 793.3
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 185.98,
    y: 793.3
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 192.16,
    y: 793.3
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 196.34,
    y: 793.3
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-14",
    x: 200.41,
    y: 793.3
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 206.48,
    y: 793.3
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 209.53,
    y: 793.3
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 215.33,
    y: 793.3
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 219.4,
    y: 793.3
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 222.8,
    y: 793.3
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 225.85,
    y: 793.3
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 231.5,
    y: 793.3
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 234.9,
    y: 793.3
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 240.09,
    y: 793.3
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 245.74,
    y: 793.3
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 248.79,
    y: 793.3
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 251.44,
    y: 793.3
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 257.73,
    y: 793.3
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 260.38,
    y: 793.3
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-19",
    x: 264.56,
    y: 793.3
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 270.36,
    y: 793.3
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 273.76,
    y: 793.3
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 280.05,
    y: 793.3
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 285.85,
    y: 793.3
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 289.25,
    y: 793.3
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 294.88,
    y: 793.3
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 300.68,
    y: 793.3
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 304.86,
    y: 793.3
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 309.04,
    y: 793.3
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 314.84,
    y: 793.3
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 318.24,
    y: 793.3
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 323.89,
    y: 793.3
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 328.07,
    y: 793.3
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 332.25,
    y: 793.3
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 338.05,
    y: 793.3
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 343.31,
    y: 793.3
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 347.49,
    y: 793.3
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 353.14,
    y: 793.3
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 357.32,
    y: 793.3
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 359.97,
    y: 793.3
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 366.04,
    y: 793.3
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 372.22,
    y: 793.3
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 375.62,
    y: 793.3
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 381.91,
    y: 793.3
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 387.71,
    y: 793.3
  })), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 394,
    y: 793.3
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 400.18,
    y: 793.3
  })), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-4",
    x: 402.83,
    y: 793.3
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 408.09,
    y: 793.3
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(24.313354%,70.979309%,65.489197%)",
      fillOpacity: 1
    }
  }, _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 411.49,
    y: 793.3
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 417.78,
    y: 793.3
  })), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-6",
    x: 420.43,
    y: 793.3
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 426.72,
    y: 793.3
  })), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 429.77,
    y: 793.3
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-20",
    x: 435.84,
    y: 793.3
  })), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 445.36,
    y: 793.3
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-21",
    x: 451.16,
    y: 793.3
  })), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-22",
    x: 453.81,
    y: 793.3
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 459.29,
    y: 793.3
  })), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-3",
    x: 465.36,
    y: 793.3
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 471.54,
    y: 793.3
  })), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-21",
    x: 476.73,
    y: 793.3
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-23",
    x: 479.38,
    y: 793.3
  })), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 483.3,
    y: 793.3
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 211.9,
    y: 806.93
  })), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 217.55,
    y: 806.93
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 222.74,
    y: 806.93
  })), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 228.54,
    y: 806.93
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 234.17,
    y: 806.93
  })), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 237.57,
    y: 806.93
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 240.62,
    y: 806.93
  })), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 246.27,
    y: 806.93
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 249.67,
    y: 806.93
  })), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-15",
    x: 255.3,
    y: 806.93
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-19",
    x: 258.35,
    y: 806.93
  })), _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 264.15,
    y: 806.93
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-18",
    x: 267.55,
    y: 806.93
  })), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-8",
    x: 273.84,
    y: 806.93
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 279.64,
    y: 806.93
  })), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-7",
    x: 283.04,
    y: 806.93
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-19",
    x: 288.23,
    y: 806.93
  })), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-13",
    x: 294.03,
    y: 806.93
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 298.1,
    y: 806.93
  })), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-23",
    x: 300.75,
    y: 806.93
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 304.67,
    y: 806.93
  })), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-10",
    x: 307.32,
    y: 806.93
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-16",
    x: 312.95,
    y: 806.93
  })), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-12",
    x: 318.6,
    y: 806.93
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-17",
    x: 322.78,
    y: 806.93
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 325.43,
    y: 806.93
  })), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-11",
    x: 331.5,
    y: 806.93
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-5",
    x: 337.68,
    y: 806.93
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 341.08,
    y: 806.93
  })), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-2",
    x: 347.27,
    y: 806.93
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-3",
    x: 351.61,
    y: 806.93
  })), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-4",
    x: 358.17,
    y: 806.93
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-5",
    x: 363.82,
    y: 806.93
  })), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-6",
    x: 370.08,
    y: 806.93
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-7",
    x: 375.4,
    y: 806.93
  })), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-8",
    x: 378.29,
    y: 806.93
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(24.313354%,70.979309%,65.489197%)",
      fillOpacity: 1
    }
  }, _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 256.27,
    y: 772.23
  })), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-2",
    x: 263.189,
    y: 772.23
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-3",
    x: 266.104,
    y: 772.23
  })), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-4",
    x: 273.023,
    y: 772.23
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 276.378,
    y: 772.23
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-6",
    x: 283.055,
    y: 772.23
  })), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-7",
    x: 293.527,
    y: 772.23
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(47.842407%,47.842407%,47.842407%)",
      fillOpacity: 1
    }
  }, _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-8",
    x: 299.907,
    y: 772.23
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-9",
    x: 302.822,
    y: 772.23
  })), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-5",
    x: 308.85,
    y: 772.23
  })), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-10",
    x: 315.527,
    y: 772.23
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-11",
    x: 322.325,
    y: 772.23
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    }
  }, _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-8",
    x: 328.034,
    y: 772.23
  })), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-12",
    x: 330.949,
    y: 772.23
  })), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-13",
    x: 335.261,
    y: 772.23
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 428.23,
    y: 126.16
  })), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 435.538,
    y: 126.16
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 442.318,
    y: 126.16
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 447.202,
    y: 126.16
  })), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-5",
    x: 450.382,
    y: 126.16
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-6",
    x: 456.694,
    y: 126.16
  })), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 459.874,
    y: 126.16
  })), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 463.954,
    y: 126.16
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 467.614,
    y: 126.16
  })), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 474.574,
    y: 126.16
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 478.654,
    y: 126.16
  })), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 485.638,
    y: 126.16
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-11",
    x: 489.718,
    y: 126.16
  })), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-12",
    x: 494.422,
    y: 126.16
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-13",
    x: 501.382,
    y: 126.16
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 507.61,
    y: 126.16
  })), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 512.494,
    y: 126.16
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 515.674,
    y: 126.16
  })), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 522.634,
    y: 126.16
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 527.518,
    y: 126.16
  })), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 531.598,
    y: 126.16
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 538.582,
    y: 126.16
  })), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 546.034,
    y: 126.16
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-15",
    x: 553.018,
    y: 126.16
  }))), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6",
    mask: "url(#mask0)",
    transform: "matrix(0.666647,0,0,0.666667,36,37)"
  })), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12",
    mask: "url(#mask1)",
    transform: "matrix(0.224398,0,0,0.224432,410,37)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 190.77,
    y: 228.88
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 201.314,
    y: 228.88
  })), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 210.962,
    y: 228.88
  })), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 220.61,
    y: 228.88
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 230.802,
    y: 228.88
  })), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 241.042,
    y: 228.88
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 250.69,
    y: 228.88
  })), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 261.234,
    y: 228.88
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 270.882,
    y: 228.88
  })), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-6",
    x: 275.602,
    y: 228.88
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-7",
    x: 287.554,
    y: 228.88
  })), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 299.282,
    y: 228.88
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-9",
    x: 304.722,
    y: 228.88
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 316.242,
    y: 228.88
  })), _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-8",
    x: 326.434,
    y: 228.88
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-10",
    x: 331.874,
    y: 228.88
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-11",
    x: 342.498,
    y: 228.88
  })), _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-12",
    x: 352.69,
    y: 228.88
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 364.194,
    y: 228.88
  })), _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-4",
    x: 374.434,
    y: 228.88
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-5",
    x: 384.674,
    y: 228.88
  })), _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-2",
    x: 389.394,
    y: 228.88
  })), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-3",
    x: 399.042,
    y: 228.88
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(24.313354%,70.979309%,65.489197%)",
      fillOpacity: 1
    }
  }, _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-1",
    x: 164.42,
    y: 258.72
  })), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-2",
    x: 175.348,
    y: 258.72
  })), _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-3",
    x: 186.164,
    y: 258.72
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-3",
    x: 197.044,
    y: 258.72
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-2",
    x: 207.924,
    y: 258.72
  })), _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-4",
    x: 218.74,
    y: 258.72
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-2",
    x: 228.356,
    y: 258.72
  })), _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-5",
    x: 239.172,
    y: 258.72
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-6",
    x: 250.564,
    y: 258.72
  })), _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-7",
    x: 261.572,
    y: 258.72
  })), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-2",
    x: 271.652,
    y: 258.72
  })), _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-8",
    x: 282.468,
    y: 258.72
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-9",
    x: 292.9,
    y: 258.72
  })), _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-8",
    x: 297.46,
    y: 258.72
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-7",
    x: 307.892,
    y: 258.72
  })), _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-3",
    x: 317.972,
    y: 258.72
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-10",
    x: 328.852,
    y: 258.72
  })), _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-11",
    x: 340.708,
    y: 258.72
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-12",
    x: 352.548,
    y: 258.72
  })), _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-4",
    x: 364.324,
    y: 258.72
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-12",
    x: 373.94,
    y: 258.72
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-13",
    x: 385.716,
    y: 258.72
  })), _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-14",
    x: 397.268,
    y: 258.72
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-15",
    x: 402.34,
    y: 258.72
  })), _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-5",
    x: 414.116,
    y: 258.72
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-7",
    x: 425.508,
    y: 258.72
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-1",
    x: 145.77,
    y: 294.8
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-2",
    x: 159.405,
    y: 294.8
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-3",
    x: 163.74,
    y: 294.8
  })), _use268 || (_use268 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-4",
    x: 168.015,
    y: 294.8
  })), _use269 || (_use269 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-5",
    x: 177.315,
    y: 294.8
  })), _use270 || (_use270 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-6",
    x: 186.765,
    y: 294.8
  })), _use271 || (_use271 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-7",
    x: 197.865,
    y: 294.8
  })), _use272 || (_use272 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-5",
    x: 208.695,
    y: 294.8
  })), _use273 || (_use273 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-8",
    x: 218.145,
    y: 294.8
  })), _use274 || (_use274 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-3",
    x: 228.465,
    y: 294.8
  })), _use275 || (_use275 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-9",
    x: 232.74,
    y: 294.8
  })), _use276 || (_use276 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-10",
    x: 243.495,
    y: 294.8
  })), _use277 || (_use277 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-1",
    x: 253.635,
    y: 294.8
  })), _use278 || (_use278 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-11",
    x: 267.27,
    y: 294.8
  })), _use279 || (_use279 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-5",
    x: 272.025,
    y: 294.8
  })), _use280 || (_use280 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-6",
    x: 281.475,
    y: 294.8
  })), _use281 || (_use281 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-3",
    x: 292.575,
    y: 294.8
  })), _use282 || (_use282 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-9",
    x: 296.85,
    y: 294.8
  })), _use283 || (_use283 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-12",
    x: 307.605,
    y: 294.8
  })), _use284 || (_use284 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-1",
    x: 318.645,
    y: 294.8
  })), _use285 || (_use285 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-11",
    x: 332.28,
    y: 294.8
  })), _use286 || (_use286 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-6",
    x: 337.035,
    y: 294.8
  })), _use287 || (_use287 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-11",
    x: 348.135,
    y: 294.8
  })), _use288 || (_use288 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-13",
    x: 352.89,
    y: 294.8
  })), _use289 || (_use289 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-14",
    x: 363.93,
    y: 294.8
  })), _use290 || (_use290 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-5",
    x: 374.61,
    y: 294.8
  })), _use291 || (_use291 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-3",
    x: 384.06,
    y: 294.8
  })), _use292 || (_use292 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-6",
    x: 388.335,
    y: 294.8
  })), _use293 || (_use293 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-11",
    x: 399.435,
    y: 294.8
  })), _use294 || (_use294 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-15",
    x: 404.19,
    y: 294.8
  })), _use295 || (_use295 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-12",
    x: 414.39,
    y: 294.8
  })), _use296 || (_use296 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-16",
    x: 425.43,
    y: 294.8
  })), _use297 || (_use297 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-10",
    x: 434.445,
    y: 294.8
  })), _use298 || (_use298 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph7-17",
    x: 444.585,
    y: 294.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(47.842407%,47.842407%,47.842407%)",
      fillOpacity: 1
    }
  }, _use299 || (_use299 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 162.59,
    y: 315.16
  })), _use300 || (_use300 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-12",
    x: 171.386,
    y: 315.16
  })), _use301 || (_use301 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 178.346,
    y: 315.16
  })), _use302 || (_use302 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 182.426,
    y: 315.16
  })), _use303 || (_use303 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 186.086,
    y: 315.16
  })), _use304 || (_use304 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 193.046,
    y: 315.16
  })), _use305 || (_use305 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 197.126,
    y: 315.16
  })), _use306 || (_use306 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-17",
    x: 204.11,
    y: 315.16
  })), _use307 || (_use307 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-18",
    x: 211.514,
    y: 315.16
  })), _use308 || (_use308 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 216.758,
    y: 315.16
  })), _use309 || (_use309 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-19",
    x: 224.21,
    y: 315.16
  })), _use310 || (_use310 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-18",
    x: 231.53,
    y: 315.16
  })), _use311 || (_use311 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 236.774,
    y: 315.16
  })), _use312 || (_use312 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 243.758,
    y: 315.16
  })), _use313 || (_use313 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 251.21,
    y: 315.16
  })), _use314 || (_use314 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 258.662,
    y: 315.16
  })), _use315 || (_use315 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 265.646,
    y: 315.16
  })), _use316 || (_use316 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-20",
    x: 269.726,
    y: 315.16
  })), _use317 || (_use317 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 276.506,
    y: 315.16
  })), _use318 || (_use318 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 280.586,
    y: 315.16
  })), _use319 || (_use319 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 288.554,
    y: 315.16
  })), _use320 || (_use320 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-23",
    x: 297.518,
    y: 315.16
  })), _use321 || (_use321 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 307.754,
    y: 315.16
  })), _use322 || (_use322 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 315.662,
    y: 315.16
  })), _use323 || (_use323 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 324.458,
    y: 315.16
  })), _use324 || (_use324 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-26",
    x: 332.138,
    y: 315.16
  })), _use325 || (_use325 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 338.246,
    y: 315.16
  })), _use326 || (_use326 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-27",
    x: 345.926,
    y: 315.16
  })), _use327 || (_use327 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 354.554,
    y: 315.16
  })), _use328 || (_use328 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-26",
    x: 362.522,
    y: 315.16
  })), _use329 || (_use329 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 368.63,
    y: 315.16
  })), _use330 || (_use330 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 372.17,
    y: 315.16
  })), _use331 || (_use331 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 379.85,
    y: 315.16
  })), _use332 || (_use332 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 387.494,
    y: 315.16
  })), _use333 || (_use333 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 395.462,
    y: 315.16
  })), _use334 || (_use334 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 403.106,
    y: 315.16
  })), _use335 || (_use335 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-30",
    x: 407.186,
    y: 315.16
  })), _use336 || (_use336 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 411.374,
    y: 315.16
  })), _use337 || (_use337 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 418.826,
    y: 315.16
  })), _use338 || (_use338 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-17",
    x: 425.81,
    y: 315.16
  })), _use339 || (_use339 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-31",
    x: 433.214,
    y: 315.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use340 || (_use340 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-1",
    x: 190.57,
    y: 340.02
  })), _use341 || (_use341 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 199.796,
    y: 340.02
  })), _use342 || (_use342 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-3",
    x: 204.556,
    y: 340.02
  })), _use343 || (_use343 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-4",
    x: 215.014,
    y: 340.02
  })), _use344 || (_use344 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-5",
    x: 224.142,
    y: 340.02
  })), _use345 || (_use345 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-6",
    x: 232.584,
    y: 340.02
  })), _use346 || (_use346 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-7",
    x: 241.502,
    y: 340.02
  })), _use347 || (_use347 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-8",
    x: 251.764,
    y: 340.02
  })), _use348 || (_use348 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 261.83,
    y: 340.02
  })), _use349 || (_use349 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-9",
    x: 266.59,
    y: 340.02
  })), _use350 || (_use350 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-6",
    x: 274.948,
    y: 340.02
  })), _use351 || (_use351 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 283.866,
    y: 340.02
  })), _use352 || (_use352 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-10",
    x: 288.626,
    y: 340.02
  })), _use353 || (_use353 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-11",
    x: 297.922,
    y: 340.02
  })), _use354 || (_use354 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-12",
    x: 306.84,
    y: 340.02
  })), _use355 || (_use355 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-8",
    x: 315.8,
    y: 340.02
  })), _use356 || (_use356 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-9",
    x: 325.866,
    y: 340.02
  })), _use357 || (_use357 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-5",
    x: 334.224,
    y: 340.02
  })), _use358 || (_use358 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-1",
    x: 342.666,
    y: 340.02
  })), _use359 || (_use359 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-5",
    x: 351.892,
    y: 340.02
  })), _use360 || (_use360 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 360.334,
    y: 340.02
  })), _use361 || (_use361 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-1",
    x: 365.094,
    y: 340.02
  })), _use362 || (_use362 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-13",
    x: 374.32,
    y: 340.02
  })), _use363 || (_use363 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-14",
    x: 384.4,
    y: 340.02
  })), _use364 || (_use364 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-15",
    x: 396.342,
    y: 340.02
  })), _use365 || (_use365 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-12",
    x: 400.472,
    y: 340.02
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use366 || (_use366 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 43.91,
    y: 363.16
  })), _use367 || (_use367 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-12",
    x: 51.59,
    y: 363.16
  })), _use368 || (_use368 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-3",
    x: 58.55,
    y: 363.16
  })), _use369 || (_use369 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 63.434,
    y: 363.16
  })), _use370 || (_use370 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 66.614,
    y: 363.16
  })), _use371 || (_use371 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 73.574,
    y: 363.16
  })), _use372 || (_use372 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 77.654,
    y: 363.16
  })), _use373 || (_use373 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 85.334,
    y: 363.16
  })), _use374 || (_use374 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 93.554,
    y: 363.16
  })), _use375 || (_use375 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 97.094,
    y: 363.16
  })), _use376 || (_use376 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 104.738,
    y: 363.16
  })), _use377 || (_use377 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 113.534,
    y: 363.16
  })), _use378 || (_use378 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 121.754,
    y: 363.16
  })), _use379 || (_use379 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 129.398,
    y: 363.16
  })), _use380 || (_use380 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 137.078,
    y: 363.16
  })), _use381 || (_use381 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 141.158,
    y: 363.16
  })), _use382 || (_use382 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-33",
    x: 148.802,
    y: 363.16
  })), _use383 || (_use383 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 156.038,
    y: 363.16
  })), _use384 || (_use384 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-33",
    x: 160.118,
    y: 363.16
  })), _use385 || (_use385 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 167.354,
    y: 363.16
  })), _use386 || (_use386 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 174.998,
    y: 363.16
  })), _use387 || (_use387 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-34",
    x: 183.218,
    y: 363.16
  })), _use388 || (_use388 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 192.014,
    y: 363.16
  })), _use389 || (_use389 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 200.81,
    y: 363.16
  })), _use390 || (_use390 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-35",
    x: 209.774,
    y: 363.16
  })), _use391 || (_use391 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 216.938,
    y: 363.16
  })), _use392 || (_use392 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-36",
    x: 225.902,
    y: 363.16
  })), _use393 || (_use393 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 234.578,
    y: 363.16
  })), _use394 || (_use394 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 238.118,
    y: 363.16
  })), _use395 || (_use395 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 245.762,
    y: 363.16
  })), _use396 || (_use396 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 253.442,
    y: 363.16
  })), _use397 || (_use397 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-37",
    x: 257.522,
    y: 363.16
  })), _use398 || (_use398 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 266.162,
    y: 363.16
  })), _use399 || (_use399 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 273.806,
    y: 363.16
  })), _use400 || (_use400 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-35",
    x: 277.886,
    y: 363.16
  })), _use401 || (_use401 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 285.05,
    y: 363.16
  })), _use402 || (_use402 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-38",
    x: 292.958,
    y: 363.16
  })), _use403 || (_use403 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 300.782,
    y: 363.16
  })), _use404 || (_use404 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 309.746,
    y: 363.16
  })), _use405 || (_use405 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 317.714,
    y: 363.16
  })), _use406 || (_use406 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-33",
    x: 325.622,
    y: 363.16
  })), _use407 || (_use407 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 332.858,
    y: 363.16
  })), _use408 || (_use408 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 341.822,
    y: 363.16
  })), _use409 || (_use409 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 345.362,
    y: 363.16
  })), _use410 || (_use410 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 353.33,
    y: 363.16
  })), _use411 || (_use411 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 360.974,
    y: 363.16
  })), _use412 || (_use412 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-5",
    x: 365.054,
    y: 363.16
  })), _use413 || (_use413 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-39",
    x: 371.366,
    y: 363.16
  })), _use414 || (_use414 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-12",
    x: 378.914,
    y: 363.16
  })), _use415 || (_use415 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-40",
    x: 385.874,
    y: 363.16
  })), _use416 || (_use416 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 392.63,
    y: 363.16
  })), _use417 || (_use417 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-2",
    x: 395.81,
    y: 363.16
  })), _use418 || (_use418 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-8",
    x: 402.59,
    y: 363.16
  })), _use419 || (_use419 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 406.25,
    y: 363.16
  })), _use420 || (_use420 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-41",
    x: 409.43,
    y: 363.16
  })), _use421 || (_use421 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-12",
    x: 414.446,
    y: 363.16
  })), _use422 || (_use422 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 421.406,
    y: 363.16
  })), _use423 || (_use423 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 425.486,
    y: 363.16
  })), _use424 || (_use424 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 433.166,
    y: 363.16
  })), _use425 || (_use425 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 441.386,
    y: 363.16
  })), _use426 || (_use426 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 444.926,
    y: 363.16
  })), _use427 || (_use427 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 452.57,
    y: 363.16
  })), _use428 || (_use428 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 461.366,
    y: 363.16
  })), _use429 || (_use429 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 469.586,
    y: 363.16
  })), _use430 || (_use430 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 477.23,
    y: 363.16
  })), _use431 || (_use431 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 484.91,
    y: 363.16
  })), _use432 || (_use432 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 488.99,
    y: 363.16
  })), _use433 || (_use433 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-34",
    x: 496.298,
    y: 363.16
  })), _use434 || (_use434 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-42",
    x: 505.094,
    y: 363.16
  })), _use435 || (_use435 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 511.946,
    y: 363.16
  })), _use436 || (_use436 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 519.626,
    y: 363.16
  })), _use437 || (_use437 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-43",
    x: 523.166,
    y: 363.16
  })), _use438 || (_use438 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-27",
    x: 532.13,
    y: 363.16
  })), _use439 || (_use439 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 540.758,
    y: 363.16
  })), _use440 || (_use440 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 548.402,
    y: 363.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use441 || (_use441 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 199.21,
    y: 379.46
  })), _use442 || (_use442 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-33",
    x: 206.854,
    y: 379.46
  })), _use443 || (_use443 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 214.09,
    y: 379.46
  })), _use444 || (_use444 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 218.17,
    y: 379.46
  })), _use445 || (_use445 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-34",
    x: 226.39,
    y: 379.46
  })), _use446 || (_use446 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 235.186,
    y: 379.46
  })), _use447 || (_use447 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-23",
    x: 238.726,
    y: 379.46
  })), _use448 || (_use448 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 248.962,
    y: 379.46
  })), _use449 || (_use449 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-43",
    x: 252.502,
    y: 379.46
  })), _use450 || (_use450 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-27",
    x: 261.466,
    y: 379.46
  })), _use451 || (_use451 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 270.094,
    y: 379.46
  })), _use452 || (_use452 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 277.738,
    y: 379.46
  })), _use453 || (_use453 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 285.418,
    y: 379.46
  })), _use454 || (_use454 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 289.498,
    y: 379.46
  })), _use455 || (_use455 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 297.142,
    y: 379.46
  })), _use456 || (_use456 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 305.938,
    y: 379.46
  })), _use457 || (_use457 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-35",
    x: 310.018,
    y: 379.46
  })), _use458 || (_use458 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 317.182,
    y: 379.46
  })), _use459 || (_use459 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-38",
    x: 325.09,
    y: 379.46
  })), _use460 || (_use460 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 332.914,
    y: 379.46
  })), _use461 || (_use461 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 341.878,
    y: 379.46
  })), _use462 || (_use462 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 349.846,
    y: 379.46
  })), _use463 || (_use463 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-33",
    x: 357.754,
    y: 379.46
  })), _use464 || (_use464 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 364.99,
    y: 379.46
  })), _use465 || (_use465 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 373.954,
    y: 379.46
  })), _use466 || (_use466 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 377.494,
    y: 379.46
  })), _use467 || (_use467 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 385.462,
    y: 379.46
  })), _use468 || (_use468 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 393.106,
    y: 379.46
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(47.842407%,47.842407%,47.842407%)",
      fillOpacity: 1
    }
  }, _use469 || (_use469 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-25",
    x: 181.89,
    y: 403.16
  })), _use470 || (_use470 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-9",
    x: 189.57,
    y: 403.16
  })), _use471 || (_use471 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-5",
    x: 196.53,
    y: 403.16
  })), _use472 || (_use472 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-5",
    x: 202.842,
    y: 403.16
  })), _use473 || (_use473 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-4",
    x: 209.154,
    y: 403.16
  })), _use474 || (_use474 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-44",
    x: 212.334,
    y: 403.16
  })), _use475 || (_use475 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-45",
    x: 219.618,
    y: 403.16
  })), _use476 || (_use476 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 227.034,
    y: 403.16
  })), _use477 || (_use477 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 231.114,
    y: 403.16
  })), _use478 || (_use478 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 238.098,
    y: 403.16
  })), _use479 || (_use479 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-10",
    x: 245.55,
    y: 403.16
  })), _use480 || (_use480 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-14",
    x: 252.534,
    y: 403.16
  })), _use481 || (_use481 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-6",
    x: 259.986,
    y: 403.16
  })), _use482 || (_use482 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 263.166,
    y: 403.16
  })), _use483 || (_use483 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 267.246,
    y: 403.16
  })), _use484 || (_use484 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-32",
    x: 275.154,
    y: 403.16
  })), _use485 || (_use485 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-24",
    x: 283.374,
    y: 403.16
  })), _use486 || (_use486 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-37",
    x: 291.282,
    y: 403.16
  })), _use487 || (_use487 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 299.922,
    y: 403.16
  })), _use488 || (_use488 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-23",
    x: 307.566,
    y: 403.16
  })), _use489 || (_use489 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-28",
    x: 317.802,
    y: 403.16
  })), _use490 || (_use490 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 321.342,
    y: 403.16
  })), _use491 || (_use491 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 328.986,
    y: 403.16
  })), _use492 || (_use492 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-37",
    x: 333.066,
    y: 403.16
  })), _use493 || (_use493 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 341.706,
    y: 403.16
  })), _use494 || (_use494 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-7",
    x: 349.35,
    y: 403.16
  })), _use495 || (_use495 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-36",
    x: 353.43,
    y: 403.16
  })), _use496 || (_use496 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-21",
    x: 362.106,
    y: 403.16
  })), _use497 || (_use497 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 370.074,
    y: 403.16
  })), _use498 || (_use498 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-16",
    x: 377.718,
    y: 403.16
  })), _use499 || (_use499 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-22",
    x: 386.514,
    y: 403.16
  })), _use500 || (_use500 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-38",
    x: 395.478,
    y: 403.16
  })), _use501 || (_use501 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-35",
    x: 403.302,
    y: 403.16
  })), _use502 || (_use502 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-29",
    x: 410.466,
    y: 403.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use503 || (_use503 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-16",
    x: 211.24,
    y: 432.02
  })), _use504 || (_use504 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-17",
    x: 220.83,
    y: 432.02
  })), _use505 || (_use505 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-18",
    x: 225.1,
    y: 432.02
  })), _use506 || (_use506 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 233.22,
    y: 432.02
  })), _use507 || (_use507 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-19",
    x: 237.98,
    y: 432.02
  })), _use508 || (_use508 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-20",
    x: 246.786,
    y: 432.02
  })), _use509 || (_use509 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 254.906,
    y: 432.02
  })), _use510 || (_use510 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-21",
    x: 259.666,
    y: 432.02
  })), _use511 || (_use511 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-22",
    x: 267.548,
    y: 432.02
  })), _use512 || (_use512 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-23",
    x: 276.046,
    y: 432.02
  })), _use513 || (_use513 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-24",
    x: 284.698,
    y: 432.02
  })), _use514 || (_use514 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-25",
    x: 290.55,
    y: 432.02
  })), _use515 || (_use515 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-26",
    x: 296.248,
    y: 432.02
  })), _use516 || (_use516 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-17",
    x: 304.746,
    y: 432.02
  })), _use517 || (_use517 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-20",
    x: 309.016,
    y: 432.02
  })), _use518 || (_use518 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 317.136,
    y: 432.02
  })), _use519 || (_use519 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-27",
    x: 321.896,
    y: 432.02
  })), _use520 || (_use520 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-2",
    x: 326.026,
    y: 432.02
  })), _use521 || (_use521 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-28",
    x: 330.786,
    y: 432.02
  })), _use522 || (_use522 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-24",
    x: 339.438,
    y: 432.02
  })), _use523 || (_use523 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-29",
    x: 345.29,
    y: 432.02
  })), _use524 || (_use524 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-30",
    x: 353.284,
    y: 432.02
  })), _use525 || (_use525 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-31",
    x: 360.956,
    y: 432.02
  })), _use526 || (_use526 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-32",
    x: 369.566,
    y: 432.02
  })), _use527 || (_use527 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-33",
    x: 376.93,
    y: 432.02
  })), _use528 || (_use528 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph8-20",
    x: 380.64,
    y: 432.02
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBac);
export default __webpack_public_path__ + "static/media/BAC.e92cb197f609cd62df07985e7fa9081b.svg";
export { ForwardRef as ReactComponent };